import {
    APP_TITLE,
    LANDING_BRIEF,
    LANDING_LANGUAGE_SELECTOR,
    LANDING_COUNTRY_SELECTOR,
    LANDING_TERMS,
    LANDING_TERMS_ERROR,
    LANDING_CAPTCHA_ERROR,
    BUTTON_PREV,
    BUTTON_NEXT,
    BUTTON_SUBMIT,
    MENU_FEEDBACK_FORM,
    MENU_FEEDBACK_STATUS,
    MENU_FORM_INTAKE,
    MENU_FORM_EVENT_DETAILS,
    MENU_FORM_PRODUCT_INFO,
    SYSTEM_FEEDBACK_FORM,
    SYSTEM_FEEDBACK_STATUS,
    FORM_TITLE,
    FORM_MANDATORY_FIELDS,
    APP_DESCRIPTION,
    SUBMIT_FEEDBACK,
    CHECK_SUBMITTED_FEEDBACK,
    BTN_LAUNCH_FORM,
    BTN_CHECK_STATUS,
    SELECT_RESPONSE,
    FUNCTION_ROLE,
    CUSTOMER_ACCOUNT_NUMBER,
    ENTER_CUSTOMER_ACCOUNT,
    HELP_CUSTOMER_ACCOUNT_NUMBER,
    EVENT_REPORTED,
    REFERENCE_NUMBER,
    ENTER_REFERENCE,
    WHO_REPORTED_TO,
    WHO_WAS_NOTIFIED,
    ENTER_NAME,
    PRODUCT_SURVEILLANCE,
    YOUR_NAME,
    OCCUPATION,
    PHONE_NUMBER,
    ENTER_PHONE_NUMBER,
    ENTER_EMAIL,
    EMAIL_ADDRESS,
    ENTER_ADDRESS,
    ENTER_NA_IF_UNKNOWN,
    FACILITY_HOSPITAL,
    ENTER_FACILITY,
    ADDRESS_1,
    ADDRESS_2,
    CITY,
    STATE,
    POSTAL_CODE,
    COUNTRY,
    END_USER_CUSTOMER,
    ADDITIONAL_CONTACT_PERSON,
    ADDITIONAL_PHONE,
    ADDITIONAL_EMAIL,
    ANOTHER_FACILITY_ADDRESS,
    ANOTHER_FACILITY_HOSPITAL,
    ANOTHER_ENTER_FACILITY,
    ANOTHER_ADDRESS_1,
    ANOTHER_ADDRESS_2,
    ANOTHER_CITY,
    ANOTHER_STATE,
    ANOTHER_POSTAL_CODE,
    ANOTHER_COUNTRY,
    LOT_SERIAL_NUMBER,
    ENTER_LOT_SERIAL_NUMBER,
    HELP_LOT_SERIAL_NUMBER,
    OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_PRODUCT_CODE,
    PRODUCT_CODE,
    ENTER_PRODUCT_CODE,
    HELP_PRODUCT_CODE,
    NDC,
    ENTER_NDC,
    UDI,
    ENTER_UDI,
    PRODUCT_NAME,
    ENTER_PRODUCT_NAME,
    HELP_PRODUCT_NAME,
    BEST_DESCRIBES,
    QUANTITY_TO_SELECT,
    ENTER_QUANTITY,
    HELP_QUANTITY,
    UNIT,
    AVAILABLE_TO_RETURNED,
    PHOTOGRAPH_AVAILABLE,
    HELP_PHOTOGRAPH_AVAILABLE,
    UPLOAD_IMAGES,
    REPORTER_NAME,
    REPORTER_FACILITY,
    REPORTER_OCCUPATION,
    ENTER_NUMBER,
    REPORTER_PHONE_NUMBER,
    REPORTER_EMAIL_ADDRESS,
    EMPLOYEE_NAME,
    EMPLOYEE_PHONE_NUMBER,
    EMPLOYEE_EMAIL_ADDRESS,
    RETURNING_FOR_INVESTIGATION,
    HELP_RETURNING_FOR_INVESTIGATION,
    UNUSED_BAXTER_PRODUCT,
    YOU_INDICATED_SAMPLES,
    SAMPLE_RETURN_KIT,
    A_BOX_WITH_A_PREPAID_LABEL,
    SAME_AS_MY_ADDRESS,
    OTHER_CONTACT_NAME,
    OTHER_CONTACT_OCCUPATION,
    OTHER_CONTACT_PHONE_NUMBER,
    OTHER_CONTACT_EMAIL_ADDRESS,
    MANUFACTURED_BY_ANOTHER_COMPANY,
    CUSTOMER_EXPLICITLY_REQUEST,
    EXPLICITLY_REQUEST_CREDIT,
    PRODUCT_FROM_BAXTER,
    QUANTITY_REQUESTED_CREDIT,
    ENTER_OCCUPATION,
    LOT_QUANTITY_NUMBER,
    WHOLESALERS_NAME,
    PLACE_WHOLESALERS_NAME,
    DATE_OF_EVENT,
    DATE_OF_EVENT_MSG,
    HELP_DATE_OF_EVENT,
    DATE_BAXTER_EMPLOYEE,
    DATE_MESSAGE_BAXTER_EMPLOYEE,
    DURING_WHAT_PROCESS,
    WAS_THE_PATIENT,
    WERE_YOU_CONNECTED,
    PROVIDE_ANY_ADDITIONAL,
    HELP_YOU_IDENTIFIED_MORE,
    ENTER_DETAILS,
    PROVIDE_ANY_ATTACHMENT,
    WAS_NEGATIVE_MEDICAL,
    WAS_MEDICAL_INTERVENTION,
    PROVIDE_DETAILS,
    REQUIRED_TREATMENT,
    ENTER_TREATMENT,
    RELEVANT_TESTS,
    HELP_RELEVANT_TESTS,
    RELEVANT_MEDICAL_HISTORY,
    ENTER_HISTORY,
    PATIENT_NAME,
    PATIENT_INITIALS,
    PATIENT_PHONE_NUMBER,
    PATIENT_EMAIL_ADDRESS,
    I_DO_NOT_WISH_TO_PROVIDE,
    PATIENT_ADDRESS,
    SAME_ADDRESS,
    DRUG_BEING_USED,
    PATIENT_IDENTIFIER,
    PATIENT_AGE_OR_DOB,
    ENTER_PATIENT_AGE,
    PATIENT_GENDER,
    PATIENT_WEIGHT,
    ENTER_WEIGHT,
    PATIENT_WEIGHT_UNIT,
    MY_NAME,
    ENTER_IN_YOUR_CONTACT,
    MY_PHONE_NUMBER,
    MY_EMAIL_ADDRESS,
    MY_ADDRESS,
    NAME_OF_BAXTER_DRUG,
    ENTER_DRUG_NAME,
    PLEASE_PROVIDE_THE_NAME,
    APPLY_TO_EACH_UNIT,
    SELECT_THE_COMPONENT,
    USE_THE_DIAGRAM,
    TYPE_OF_DAMAGE,
    PLEASE_ENTER_VALUE,
    WAS_THE_PRODUCT_KINKED,
    WERE_ANY_CLEANING,
    WHAT_WAS_THE_DISINFECTANT,
    NOTE_BAXTER_LABELING,
    SELECT_ALL_THAT_APPLY,
    DID_FOLLOWING_OCCUR,
    SELECT_THE_LOCATION,
    WAS_THE_PRODUCT_EXPOSED,
    HOW_LONG_TRANSFER,
    WAS_THERE_DIFFICULTY,
    WAS_DEVICE_OR_TOOL,
    DESCRIBE_HOW_PRODUCT,
    DID_YOU_OBSERVE,
    WERE_DIFFICULTIES_PUTTING,
    WAS_THE_TRANSFER,
    SELECT_TYPE_OF_FLOW,
    WAS_ANYTHING_BLOCKING,
    WAS_ANY_ALARM,
    SELECT_BEST_DESCRIBE,
    WERE_THE_MINICAPS,
    WAS_THE_SPONGE_VISIBLE,
    WHERE_PARTICULATE_MATTERFOREIGN,
    DESCRIBE_THE_EXACT_LOCATION,
    WAS_THE_PARTICULATE_MATTER,
    DOES_THE_PARTICULATE_MATER,
    WHAT_COMPONENT_DOES,
    SELECT_CONNECTION_ISSUE,
    WERE_ASSIST_DEVICES,
    WERE_ANY_DIFFICULTIES,
    PROVIDE_PRODUCT_INFORMATION,
    WERE_THE_SPIKE_LUER,
    BAXTER_LABELING_STATES,
    WERE_PETS_OR_ANIMALS,
    BAXTER_LABELING_CONTAMINATION,
    WERE_OTHER_ISSUES,
    WAS_MINICAP_TWISTED,
    WERE_DIFFICULTIES_TRANSFER_SET,
    DID_TRANSFER_SET_CONNECTORS,
    WHAT_WAS_THE_ALARM,
    WHERE_OBSERVED_DAMAGE,
    SELECT_THE_TYPE_OBSERVED,
    DID_DAMAGE_CAUSE_LEAK,
    WAS_THE_SHIPPING_CARTON,
    SELECT_FLOW_ISSUE_OBSERVED,
    HOW_LONG_WAS_STORAGE,
    WAS_THERE_AN_ADAPTER,
    NAME_AND_MODEL,
    NAME_VAPORIZER,
    WAS_VIAL_INVERTED,
    WHAT_VIAL_USED,
    DRUG_NAME_MANUFACTURER,
    WERE_BREAK_FRANGIBLE,
    WAS_ALARM_ASSOCIATED,
    WHAT_PART_DISCOLORED,
    DESCRIBE_DISCOLORATION,
    HOW_PRODUCT_STORED,
    DOES_DISCOLORATION_APPEAR,
    WHICH_CHAMBER_DISCOLORED,
    WAS_PEEL_SEAL_INTERCHAMBER,
    WAS_DISCOLORATION_NOTICED,
    SELECT_SPECIFICALLY_DESCRIBES,
    WHAT_DEVICE_HAD_ALARM,
    WHAT_MISSING_MISASSEMBLED,
    RECONSTITUTION_ISSUE,
    WHAT_MEDICATION_SOLUTION,
    WHAT_VOLUME_MEDICATION,
    WHAT_DEVICES_RECONSTITUTION,
    WAS_PRODUCT_EXPOSED_HEAT,
    DESCRIBE_EXPOSURE,
    WHAT_USED_ACTIVATE_SOLUTION,
    WAS_DAMAGE_OBSERVED,
    DESCRIBE_THE_DAMAGE,
    APPROXIMATELY_SOLUTION_POWDER,
    WAS_LEAK_OBSERVED,
    WHAT_FEATUR_DIFFICULT_USE,
    HOW_WAS_DIFFICULT_USE,
    WHERE_MATTER_FOREIGN,
    DOES_PARTICULATE_MATTER,
    DESCRIBE_EXACT_LOCATION,
    WAS_MATTER_FOREIGN,
    WHEN_MATTER_FOREIGN,
    PROVIDE_INFORMATION_MEDICATION,
    PRODUCT_NAME_CODE_NUMBER,
    DESCRIBE_SPIKING,
    INCLUDE_NEEDLE,
    WHAT_ADMINISTRATION_RECONSTITUTION,
    INCLUDE_MANUFACTURER,
    WAS_MEDICATION_ADDITIVE,
    WHAT_MEDICATION_ADDITIVE,
    WHAT_STATE_OF_PRODUCT,
    AFTER_UNITS_SAT,
    DID_ATTEMPT_AGITATE,
    DID_PRECIPITATE_DISSOLVE,
    WHAT_STORAGE_TEMPERATURE,
    PROVIDE_TEMPERATURE_LOCATION,
    ARE_TEMPERATURE_LOGS,
    LOGS_CAN_BE_ATTACHED,
    IS_THE_STORAGE_UNIT,
    HOW_PRODUCT_THAWED,
    WHAT_STORAGE_CONDITIONS,
    WAS_ANY_DAMAGE,
    MORE_SPECIFIC_INFORMATION,
    WHAT_PURPOSE_INDICATION,
    WHAT_ROUTE_ADMINISTRATION,
    WHAT_DATE_ADMINISTRATION,
    WHAT_DOSAGE_STRENGTH,
    WAS_RECENT_PRESCRIPTION,
    WHAT_WAS_STORAGE_TEMPERATURE,
    WERE_ANY_ADJUSTMENTS,
    SELECT_APPROPRIATE_DESCRIPTION,
    SELECT_LABELING_ISSUE,
    WAS_CONNECTION_SECURE,
    WAS_EXPIRED_PRODUCT,
    WAS_COMPONENT_DAMAGED,
    WERE_ABNORMALITIES_DAMAGE,
    WHAT_PURCHASE_ORDER_NUMBER,
    WHAT_DATE_OF_ADMINISTRATION,
    WHAT_WAS_EXPIRATION_DATE,
    DESCRIBE_WAS_INCORRECT,
    WHAT_SCANNER_USED,
    WAS_OVERPOUCH_POUCH,
    WHAT_BACKGROUND_COLOR,
    DO_ALL_OF_THE_LABELS,
    PRODUCT_INFORMATION,
    IS_A_BARCODE_SCANNER,
    HOW_ARE_THESE_PRODUCTS,
    WHAT_INFORMATION_INCORRECTLY,
    WAS_THERE_LEAK,
    WHERE_LEAK_OBSERVED,
    WAS_FRANGIBLE_OBSERVED,
    IS_MOISTURE_CLEAR,
    WHO_IS_YOUR_DISTRIBUTOR,
    WHAT_MANUFACTURER_MEDICATION,
    WHAT_GAUGE_NEEDLE,
    WHAT_ADMINISTRATION_SET,
    WAS_DIFFICULTY_SPIKING,
    WERE_FOLLOWING_SCENARIOS,
    WAS_FRANGIBLE_OBSERVED_DEFECT,
    WHAT_AMOUNT_PRESSURE,
    WAS_BAG_COMPLETELY,
    WHAT_MANUFACTURER_MODEL,
    WHAT_PRESSURE_PRIOR,
    LIST_THE_VAPORIZER,
    APPROXIMATELY_HOW_MUCH,
    WAS_THE_BOTTLE_DIFFICULT,
    WERE_VISIBLE_DEFECTS,
    SELECT_THE_OPTION,
    PROVIDE_INVOLVED_CONNECTION_ISSUE,
    WHICH_PART_SEPARATED,
    WHAT_COMPONENT_DISCOLORED,
    SELECT_DESCRIBES_DISCOLORATION,
    WAS_THE_SET_DISCOLORED,
    DID_SET_CHANGE_COLOR,
    WHAT_MEDICATION_ADDED,
    WHERE_MATERIAL_LOCATED,
    DESCRIBE_APPEARANCE_COLOR_SIZE,
    WAS_EMBEDDED_PLASTIC,
    WAS_THERE_A_PRECIPITATE,
    WHAT_MEDICATIONS_SOLUTIONS,
    WHERE_DAMAGE_COMPONENT_AFFECTED,
    WHAT_DAMAGE_ISSUE,
    DID_ISSUE_RESULT,
    WAS_PATIENT_CONNECTED,
    WAS_PRODUCT_REPLACED,
    WHICH_SITUATION_BEST,
    SELECT_MOST_LABELING_ISSUE,
    WHAT_INFORMATION_DISPLAYED,
    WHAT_SCANNER_WAS_USED,
    INCLUDE_THE_MODEL_NAME,
    WAS_PRODUCT_ORDERED,
    WHERE_LEAK_COMING,
    DID_SCENARIOS_OCCURRED_LEAK,
    WAS_POWER_INJECTOR,
    WHAT_INJECTOR_USED,
    MANUFACTURER_NAME_CODE_LOT,
    DESCRIBE_INCORRECT_INCOMPLETE,
    PROVIDE_INFORMATION_SECOND_PRODUCT,
    WHICH_COMPONENTS_WERE_FOUND,
    DESCRIBE_CUT_HOLE_SLICE,
    WAS_LEAK_ORIGINATING,
    PROVIDE_DISCONNECTION_CONNECTION,
    WHICH_SPECIFIC_BONDED,
    WERE_VISIBLE_IRREGULARITIES,
    WAS_SUCCESSFUL_CONNECTION,
    WAS_TOOL_USED_ASSIST,
    WERE_LUER_CONNECTIONS,
    WAS_PRODUCT_SECURELY,
    WHICH_DESCRIBES_FLOW_ISSUE,
    WHAT_FLOWING_BACKWARDS,
    DESCRIBE_COMPONENTS_BACKFLOW,
    DO_SITUATIONS_APPLY,
    WHICH_SPECIFIC_AREA,
    WAS_FLOW_PREVIOUSLY_SEEN,
    WAS_ANY_FOLLOWING_OBSERVED,
    WHERE_SIMULTANEOUS_FLOW,
    WHAT_TYPE_HANGER,
    WHAT_WAS_HANGER_LENGTH,
    WHICH_BAG_LOWER,
    WHAT_Y_SITE_WAS,
    WHAT_COMPONENT_WITHIN,
    WAS_COMPONENT_SET_REPLACED,
    WHAT_VOLUME_FLUID_PERIOD_TIME,
    WHAT_VOLUME_FLUID_OVER_TIME,
    WAS_USED_WITH_PUMP,
    DID_CLAMP_FAIL,
    WHAT_CLAMP_FAILED,
    WAS_ISSUES_OBSERVED_CLAMP,
    DO_OTHER_SITUATIONS_DESCRIBE,
    DESCRIBE_ALARM_OBSERVED,
    INCLUDE_ANY_MESSAGES,
    WHICH_CLAMP_HAD_ISSUE,
    WHICH_TYPE_CLAMP_ISSUE,
    SELECT_BEST_DESCRIBES_ISSUE,
    PROVIDE_MORE_DETAILS,
    PROVIDE_MORE_DETAILS_INSTRUCTIONS,
    DESCRIBE_THE_SMELL,
    WAS_ISSUES_WITH_SET,
    WHERE_LEAK_LOCATED,
    DID_OCCUR_WITH_LEAK,
    PROVIDE_INVOLVED_DISCONNECTION,
    DID_OCCURRED_WITH_THE_LEAK,
    WHERE_WAS_PRODUCT_DAMAGED,
    SELECT_ALL_APPLY,
    DESCRIBE_OBSERVED_DAMAGE,
    WHAT_COMPONENT_IS_DISCOLORED,
    DESCRIBE_HUE_TINT_SHADE,
    INSIDE_OUTSIDE_OVERPOUCH,
    DESCRIBE_EXACT_LOCATION_SIZE,
    DOES_THE_PARTICULATE_MATTER,
    WAS_PARTICULATE_MATERIAL_EMBEDDED,
    DOES_APPEAR_PRODUCT_MATERIAL,
    WHERE_DID_THE_ISSUE_OCCUR,
    LIST_COMPONENTS_IF,
    WERE_THERE_VISIBLE_IRREGULARITIES,
    SELECT_OPTION_FLOW_ISSUE,
    DESCRIBE_IRREGULARITIES,

    HOW_PRODUCT_SETUP,
    SELECT_MOST_APPROPRIATE_DESCRIPTION,
    DESCRIBE_WHAT_INCORRECT_INCOMPLETE,
    WAS_SHIPPING_CARTON_DAMAGED,
    WHAT_PRODUCT_WAS_SUPPOSED,
    IF_PRODUCT_CODE_NOT,
    WAS_THE_CASE_MISSING,
    WHAT_CARRIER_DELIVERED,
    WHAT_IS_PURCHASE_ORDER_NUMBER,
    WHAT_QUANTITY_MISSING_UNITS,
    WAS_EXPIRED_PRODUCT_USE,
    ADD_PRODUCT_TO_THE_GRID,
    SAVE,
    CANCEL,
    ADD_MORE_PRODUCTS,
    REPORTER_ADDRESS,
    ATTACHMENTS,
    COPYRIGHT,
    TERMS_CONDITIONS,
    PRIVACY_POLICY,
    COOKIE_POLICY,
    FORM_SUB_TITLE,
    OPTION_REPORTEROCCUPATIONOPTIONS_ASKED_UNKNOWN,
    OPTION_FUNCTIONOPTIONS_BAXTER_EMPLOYEE,
    OPTION_FUNCTIONOPTIONS_CAREGIVER,
    OPTION_FUNCTIONOPTIONS_DISTRIBUTOR,
    OPTION_FUNCTIONOPTIONS_HEALTHCARE_PROFESSIONAL,
    OPTION_FUNCTIONOPTIONS_PATIENT,
    OPTION_FUNCTIONOPTIONS_OTHER,
    OPTION_PROCESSSTEPOPTIONS_AFTER_USE,
    OPTION_PROCESSSTEPOPTIONS_BEFORE_USE,
    OPTION_PROCESSSTEPOPTIONS_DURING_SETUP_PREPARATION,
    OPTION_PROCESSSTEPOPTIONS_DURING_THERAPY,
    OPTION_PROCESSSTEPOPTIONS_MULTIPLE_STEPS,
    OPTION_PROCESSSTEPOPTIONS_NOT_SPECIFIED,
    OPTION_OCCUPATIONOPTIONS_FAMILY_MEMBER,
    OPTION_OCCUPATIONOPTIONS_NURSE,
    OPTION_OCCUPATIONOPTIONS_NURSE_PRACTITIONER,
    OPTION_OCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL,
    OPTION_OCCUPATIONOPTIONS_PHYSICIAN,
    OPTION_UNITOPTIONS_BOXES,
    OPTION_UNITOPTIONS_PALLETS,
    OPTION_UNITOPTIONS_UNITS,
    OPTION_PROBLEMOPTIONS_ALARM_CONDITION,
    OPTION_PROBLEMOPTIONS_DAMAGE,
    OPTION_PROBLEMOPTIONS_DIFFICULT_TO_USE,
    OPTION_PROBLEMOPTIONS_DISCOLORED,
    OPTION_PROBLEMOPTIONS_FLOW_ISSUES,
    OPTION_PROBLEMOPTIONS_LABELING_ISSUES,
    OPTION_PROBLEMOPTIONS_LEAK_EXCESSIVE_MOISTURE,
    OPTION_PROBLEMOPTIONS_PARTICULATE_MATTER_FOREIGN_MATERIAL,
    OPTION_PROBLEMOPTIONS_PATIENT_REACTION_ADVERSE_EVENT,
    OPTION_PROBLEMOPTIONS_PRODUCT_INQUIRY,
    OPTION_PROBLEMOPTIONS_SEPARATION_CONNECTION,
    OPTION_PROBLEMOPTIONS_SHIPPING_ISSUES_EXPIRED_PRODUCT,
    OPTION_PATIENTSEXOPTIONS_FEMALE,
    OPTION_PATIENTSEXOPTIONS_UNDIFFERENTIATE,
    OPTION_PATIENTSEXOPTIONS_MALE,
    OPTION_PATIENTSEXOPTIONS_DECLINETOANSWER,
    OPTION_REPORTEROCCUPATIONOPTIONS_ADMINISTRATOR_SUPERVISOR,
    OPTION_REPORTEROCCUPATIONOPTIONS_BIOMEDICAL_ENGINEER,
    OPTION_REPORTEROCCUPATIONOPTIONS_COMPANY_REPRESENTATIVE,
    OPTION_REPORTEROCCUPATIONOPTIONS_DENTIST,
    OPTION_REPORTEROCCUPATIONOPTIONS_DISTRIBUTOR,
    OPTION_REPORTEROCCUPATIONOPTIONS_FAMILY_MEMBER,
    OPTION_REPORTEROCCUPATIONOPTIONS_LAY_USER,
    OPTION_REPORTEROCCUPATIONOPTIONS_NURSE,
    OPTION_REPORTEROCCUPATIONOPTIONS_NURSE_PRACTITIONER,
    OPTION_REPORTEROCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL,
    OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACIST,
    OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACY_TECHNICIAN,
    OPTION_REPORTEROCCUPATIONOPTIONS_PHYSICIAN,
    OPTION_REPORTEROCCUPATIONOPTIONS_PATIENT,
    OPTION_REPORTEROCCUPATIONOPTIONS_RISK_MANAGER,
    OPTION_REPORTEROCCUPATIONOPTIONS_OTHER,
    OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ADDITIONAL_CONTACT_PERSON,
    OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ME,
    OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_OTHER,
    OPTION_REPORTEDTOOPTIONS_BAXTER,
    OPTION_REPORTEDTOOPTIONS_CHINA_FDA,
    OPTION_REPORTEDTOOPTIONS_EMA,
    OPTION_REPORTEDTOOPTIONS_FDA,
    OPTION_REPORTEDTOOPTIONS_HEALTH_CANADA,
    OPTION_REPORTEDTOOPTIONS_PMDA_JAPAN,
    OPTION_REPORTEDTOOPTIONS_TUV,
    OPTION_REPORTEDTOOPTIONS_TGA_AUSTRALIA,
    OPTION_FOLLOWINGOCCUROPTIONS_A_PET_OR_ANIMAL,
    OPTION_FOLLOWINGOCCUROPTIONS_A_SHARP_OBJECT,
    OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_PROBLEM_OCCURRED,
    OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_COLD_ENVIRONMENT,
    OPTION_DAMAGEMINICAPOPTIONS_CARTON,
    OPTION_DAMAGEMINICAPOPTIONS_MINICAP,
    OPTION_DAMAGEMINICAPOPTIONS_POUCH,
    OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_TIGHT,
    OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_LOOSE,
    OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_OPEN,
    OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_CLAMP_OPEN,
    OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_LAMP_CLOSE,
    OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_CLOSE,
    OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THERE_WAS_DAMAGE,
    OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THE_MINICAP,
    OPTION_FLOWISSUEOPTIONS_COMPLETELY_STOPPED,
    OPTION_FLOWISSUEOPTIONS_RESTRICTED_OR_PARTIALLY,
    OPTION_BLOCKINGFLOWOPTIONS_CLOTTED_BLOOD,
    OPTION_BLOCKINGFLOWOPTIONS_FIBRIN,
    OPTION_BLOCKINGFLOWOPTIONS_KINK,
    OPTION_BLOCKINGFLOWOPTIONS_PARTICULATE,
    OPTION_BLOCKINGFLOWOPTIONS_PRODUCT_MATERIAL,
    OPTION_DESCRIBEISSUEOPTIONS_EXCESS_IODINE,
    OPTION_DESCRIBEISSUEOPTIONS_EXCESS_MOISTURE,
    OPTION_DESCRIBEISSUEOPTIONS_FOIL_POUCH,
    OPTION_DESCRIBEISSUEOPTIONS_PACKAGE_BOX,
    OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_AND_WHITE,
    OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_BROWNISH_COLOR,
    OPTION_MATERIALLOCATEDOPTIONS_IN_THE_SECONDARY,
    OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_PRODUCT_FLUID,
    OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
    OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT,
    OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_OVERPOUCH,
    OPTION_MATERIALLOCATEDOPTIONS_ON_THE_EXTERIOR,
    OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING,
    OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING,
    OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
    OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
    OPTION_RESIDUETHREADSOPTIONS_YES_RESIDUE,
    OPTION_RESIDUETHREADSOPTIONS_YES_VISIBLE,
    OPTION_RESIDUETHREADSOPTIONS_YES_OTHER,
    OPTION_OBSERVEDDAMAGEOPTIONS_FRANGIBLE,
    OPTION_OBSERVEDDAMAGEOPTIONS_HANGER_HOLE,
    OPTION_OBSERVEDDAMAGEOPTIONS_INJECTION_FILLING_PORT,
    OPTION_OBSERVEDDAMAGEOPTIONS_MEMBRANE_PORT,
    OPTION_OBSERVEDDAMAGEOPTIONS_OVERPOUCH_POUCH,
    OPTION_OBSERVEDDAMAGEOPTIONS_PATCH,
    OPTION_OBSERVEDDAMAGEOPTIONS_RUBBER_STOPPER,
    OPTION_OBSERVEDDAMAGEOPTIONS_SHIPPING_CARTON,
    OPTION_OBSERVEDDAMAGEOPTIONS_SHRINKBAND,
    OPTION_OBSERVEDDAMAGEOPTIONS_SOLUTION_CONTAINER,
    OPTION_OBSERVEDDAMAGEOPTIONS_TIP_PROTECTOR,
    OPTION_OBSERVEDDAMAGEOPTIONS_TAMPER_EVIDENT_SEAL,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BENT,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BROKEN,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CRACKED,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CUT,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_DEFORMED,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_FLAKING,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_HOLE,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_KINKED,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_MELTED,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_PATCH_LAYER_SEPARATION,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SHATTERED_GLASS,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SLICED,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_TORN,
    OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_NOT_FLOW,
    OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_FLOW,
    OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_COMPOUNDING,
    OPTION_PRODUCTDISCOLOREDOPTIONS_BOTTLE,
    OPTION_PRODUCTDISCOLOREDOPTIONS_CONTAINER,
    OPTION_PRODUCTDISCOLOREDOPTIONS_HANGER_HOLE,
    OPTION_PRODUCTDISCOLOREDOPTIONS_LINER,
    OPTION_PRODUCTDISCOLOREDOPTIONS_OVERPOUCH_POUCH,
    OPTION_PRODUCTDISCOLOREDOPTIONS_OXYGEN_INDICATOR,
    OPTION_PRODUCTDISCOLOREDOPTIONS_PATCH,
    OPTION_PRODUCTDISCOLOREDOPTIONS_PORTS,
    OPTION_PRODUCTDISCOLOREDOPTIONS_SOLUTION,
    OPTION_PRODUCTDISCOLOREDOPTIONS_TIP_PROTECTOR,
    OPTION_CHAMBERDISCOLOREDOPTIONS_AMINO_ACID_CHAMBER,
    OPTION_CHAMBERDISCOLOREDOPTIONS_DEXTROSE_CHAMBER,
    OPTION_CHAMBERDISCOLOREDOPTIONS_LIPID_CHAMBER,
    OPTION_CHAMBERDISCOLOREDOPTIONS_LOWER_CHAMBER,
    OPTION_CHAMBERDISCOLOREDOPTIONS_UPPER_CHAMBER,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_BURST_RUPTURED_SEAL,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISASSEMBLED_PRODUCT_PART,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISSING_COMPONENT,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_SEPARATION_DISCONNECTION_OF,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_OVER_FILLED,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_UNDER_FILLED,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_RECONSTITUTION,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_SOLUTION,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_VAPORIZER,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_XTERNAL_SURFACE,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OUTSIDE,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OXYGEN,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_TRANSDERMAL,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_FRANGIBLE,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_GLASS_PARTICLES,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_PORT,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_RUBBER_STOPPER,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_TUBING,
    OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_ADDING_ANOTHER,
    OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_PRIOR_TO_SPIKING,
    OPTION_CLOUDINESSOBSERVEDOPTIONS_COLD_THAWED,
    OPTION_CLOUDINESSOBSERVEDOPTIONS_FROZEN,
    OPTION_CLOUDINESSOBSERVEDOPTIONS_PARTIALLY_THAWED,
    OPTION_CLOUDINESSOBSERVEDOPTIONS_ROOM_TEMPERATURE,
    OPTION_PRODUCTTHAWEDOPTIONS_BAXTER_THAWING,
    OPTION_PRODUCTTHAWEDOPTIONS_LEFT_ON_COUNTER,
    OPTION_PRODUCTTHAWEDOPTIONS_REFRIGERATOR,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_EVIDENCE,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_LEAK_OBSERVED,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_HOLE_OR_INCOMPLETE,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_SPIKING,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_BREAKING,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CRYSTALLIZATION,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CLOUDINESS,
    OPTION_DAMAGESPECIFICINFOOPTIONS_PRODUCT_DID_NOT,
    OPTION_DAMAGESPECIFICINFOOPTIONS_UNINTENDED_EFFECT,
    OPTION_SCENARIOSLEAKOPTIONS_OPTION_APPROPRIATEDESCRIPTIONOPTIONS_DAMAGED_SHIPPING,
    OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_DELIVERED,
    OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_FOUND,
    OPTION_LABELINGISSUEOPTIONS_BARCODE_ISSUE,
    OPTION_LABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
    OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
    OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_INVENTORY,
    OPTION_LABELINGISSUEOPTIONS_EXPIRED_ILLEGIBLE_LABEL,
    OPTION_LABELINGISSUEOPTIONS_INCORRECT_LABEL,
    OPTION_LABELINGISSUEOPTIONS_INCOMPLETE_LABEL,
    OPTION_LABELINGISSUEOPTIONS_ILABEL_TOO_SIMILAR,
    OPTION_LABELINGISSUEOPTIONS_LABELS_PRODUCT,
    OPTION_LABELINGISSUEOPTIONS_MISSING_BARCODE,
    OPTION_DESCOFISSUEOPTIONS_CARTON_BOX,
    OPTION_DESCOFISSUEOPTIONS_DAMAGED_SHIPPING,
    OPTION_DESCOFISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED,
    OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
    OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_FOUND,
    OPTION_DESCOFISSUEOPTIONS_PART_OF_THE_CARTON,
    OPTION_DESCOFISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON,
    OPTION_DESCOFISSUEOPTIONS_UNITS_WERE_MISSING,
    OPTION_DESCOFISSUEOPTIONS_OTHER,
    OPTION_LABELINGISSUEOPTIONS_MISSING_LABEL,
    OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_EXPIRATION_DATE,
    OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_LOT_NUMBER,
    OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_NDC_NUMBER,
    OPTION_MOISTUREOBSERVEDOPTIONS_DROPLETS_MOISTURE,
    OPTION_MOISTUREOBSERVEDOPTIONS_LEAK,
    OPTION_MOISTUREOBSERVEDOPTIONS_LEAK_OBSERVED,
    OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_FLOWING,
    OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_INSIDE,
    OPTION_COMPONENTLEAKINGOPTIONS_BETWEEN_OVERPOUCH,
    OPTION_COMPONENTLEAKINGOPTIONS_CONNECTION_BETWEEN,
    OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_MEMBRANE,
    OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_INJECTION,
    OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_HANGER,
    OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER,
    OPTION_COMPONENTLEAKINGOPTIONS_FRANGIBLE,
    OPTION_COMPONENTLEAKINGOPTIONS_RUBBER_STOPPER,
    OPTION_COMPONENTLEAKINGOPTIONS_SHRINKBAND,
    OPTION_COMPONENTLEAKINGOPTIONS_TIP_PROTECTOR,
    OPTION_COMPONENTLEAKINGOPTIONS_UNKNOWN,
    OPTION_COMPONENTLEAKINGOPTIONS_VIAL_ADAPTER,
    OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT,
    OPTION_SCENARIOSLEAKOPTIONS_DAMAGE_HOLES,
    OPTION_SCENARIOSLEAKOPTIONS_EXPOSURE_TO_EXTREME,
    OPTION_SCENARIOSLEAKOPTIONS_LEAK_AT_VAPORIZER,
    OPTION_SCENARIOSLEAKOPTIONS_OPENING_SHIPPING,
    OPTION_SCENARIOSLEAKOPTIONS_PETS_CLAWED,
    OPTION_SCENARIOSLEAKOPTIONS_SOLUTION_BAG_UNDER,
    NO_DESCRIBE_THE_COLOR,
    OPTION_LIQUIDSPILLEDOPTIONS_ML,
    OPTION_LIQUIDSPILLEDOPTIONS_GREATER_THAN_ML,
    OPTION_LIQUIDSPILLEDOPTIONS_LESS_THAN_ML,
    OPTION_VISIBLEDEFECTSOPTIONS_BOTTLE,
    OPTION_VISIBLEDEFECTSOPTIONS_CAP,
    OPTION_VISIBLEDEFECTSOPTIONS_VALVE_NECK,
    OPTION_VISIBLEDEFECTSOPTIONS_NONE,
    OPTION_OPTIONCONNECTIONISSUEOPTIONS_CONNECTING,
    OPTION_OPTIONCONNECTIONISSUEOPTIONS_DISCONNECTING,
    OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
    OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
    OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_DRIP_CHAMBER,
    OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_TUBING,
    OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_UNKNOWN,
    OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_OTHER_PLEASE_SPECIFY,
    OTHER_PLEASE_SPECIFY,
    OPTION_DESCRIBESDISCOLORATIONOPTIONS_WHITE_CLOUDY,
    OPTION_DESCRIBESDISCOLORATIONOPTIONS_YELLOW_BROWNISH,
    OPTION_DESCRIBESDISCOLORATIONOPTIONS_OTHER_PLEASE_SPECIFY,
    OPTION_WHEREMATTERLOCATEDOPTIONS_IN_THE_PRIMARY_PACKAGING,
    OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_IV,
    OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
    OPTION_WHEREMATTERLOCATEDOPTIONS_ON_THE_EXTERIOR,
    OPTION_WHEREMATTERLOCATEDOPTIONS_OUTSIDE_THE_IV,
    OPTION_EMBEDDEDPLASTICOPTIONS_EMBEDDED,
    OPTION_EMBEDDEDPLASTICOPTIONS_LOOSE,
    OPTION_EMBEDDEDPLASTICOPTIONS_NOT_APPLICABLE,
    OPTION_INFUSATESOLUTIONOPTIONS_DESCRIBE_COLOR,
    OPTION_INFUSATESOLUTIONOPTIONS_YES_CHANGE_IN_COLOR,
    OPTION_INFUSATESOLUTIONOPTIONS_YES_PRECIPITATE,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_ACCESS_SITE,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_BURRETTES,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_CLAMP,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_DRIP_CHAMBER,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_TUBING,
    DAMAGECOMPONENTAFFECTEDOPTIONS_UNKNOWN,
    DAMAGECOMPONENTAFFECTEDOPTIONS_OTHER,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_FILTERS,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_LUER_CONNECTOR,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_SPIKE,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_CUT_CRACKED_BROKEN,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_INCORRECT_COMPONENT_ASSEMBLY,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_KINKED_COLLAPSED,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_LOOSE_COMPONENT,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MALFORMED_MIS_SHAPED,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MISSING_COMPONENT,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_CONNECTING_THE,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_DISCONNECTING_THE,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_LOOSE_CONNECTION,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_DISCONNECTION,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_BETWEEN_TWO,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_CONNECT,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_DISCONNECTT,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_BARCODE_ISSUE,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_CHANGE_IN_LABELING,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_OTHER,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_EXPIRED_PRODUCT,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_INCORRECT_INFORMATION_ON_LABEL,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_BARCODE_UDI,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_INFORMATION_ON_LABEL,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_PRODUCT_WITH_NO_EXPIRATION,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_SMUDGES_ILLEGIBLE_LABELING,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_CARTON_BOX,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_DAMAGED_SHIPPING,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_FOUND,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_OTHER,
    OPTION_ORDEREDFROMBAXTEROPTIONS_BAXTER,
    OPTION_ORDEREDFROMBAXTEROPTIONS_DISTRIBUTOR,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_PART_OF_THE_CARTON,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_UNITS_WERE_MISSING,
    OPTION_LEAKCOMINGFROMOPTIONS_ACCESS_SITE,
    OPTION_LEAKCOMINGFROMOPTIONS_AIR_VENT,
    OPTION_LEAKCOMINGFROMOPTIONS_BURETTES,
    OPTION_LEAKCOMINGFROMOPTIONS_CAP,
    OPTION_LEAKCOMINGFROMOPTIONS_CLEARLINK_INJECTION_SITES,
    OPTION_LEAKCOMINGFROMOPTIONS_CLAMP,
    OPTION_LEAKCOMINGFROMOPTIONS_DRIP_CHAMBER,
    OPTION_LEAKCOMINGFROMOPTIONS_FILTERS,
    OPTION_LEAKCOMINGFROMOPTIONS_INTERLINK_INJECTION_SITES,
    OPTION_LEAKCOMINGFROMOPTIONS_LUER_CONNECTOR,
    OPTION_LEAKCOMINGFROMOPTIONS_SPIKE,
    OPTION_LEAKCOMINGFROMOPTIONS_TUBING,
    OPTION_LEAKCOMINGFROMOPTIONS_UNKNOWN,
    OPTION_LEAKCOMINGFROMOPTIONS_OTHER,
    OPTION_LEAKCOMINGFROMOPTIONS_LEAK_BETWEEN_THE,
    OPTION_LEAKCOMINGFROMOPTIONS_NEEDLE_BASED,
    OPTION_LEAKCOMINGFROMOPTIONS_ONE_LINK_INJECTION,
    OPTION_LEAKCOMINGFROMOPTIONS_OTHER_INJECTION,
    OPTION_FOLLOWINGSCENARIOSOPTIONS_CRACK_BREAK_IN,
    OPTION_FOLLOWINGSCENARIOSOPTIONS_CUT_SLICE_IN,
    DISCONNECTION_OF_CONNECTABLE,
    OPTION_FOLLOWINGSCENARIOSOPTIONS_DISCONNECTION_OF_CONNECTABLE,
    OPTION_FOLLOWINGSCENARIOSOPTIONS_SEPARATION_OF_BONDED_COMPONENTS,
    OPTION_VISIBLEIRREGULARITIESOPTIONS_YES_DESCRIBE_IRREGULARITIES,
    YES_SPECIFY_THE_TOOL,
    OPTION_SITUATIONFLOWISSUEOPTIONS_BACKFLOW,
    OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT,
    OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_UNABLE,
    OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT_UNABLE,
    OPTION_SITUATIONFLOWISSUEOPTIONS_NO_FLOW,
    OPTION_SITUATIONFLOWISSUEOPTIONS_OVER_INFUSION,
    OPTION_SITUATIONFLOWISSUEOPTIONS_RESTRICTED_SLOW,
    OPTION_SITUATIONFLOWISSUEOPTIONS_SIMULTANEOUS_FLOW,
    OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_CLEAR,
    OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_PRIME,
    OPTION_SITUATIONFLOWISSUEOPTIONS_UNDER_INFUSION,
    OPTION_FLOWINGBACKWARDSOPTIONS_PATIENTS_BLOOD,
    OPTION_FLOWINGBACKWARDSOPTIONS_SOLUTIONS_BLOOD,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_DAMAGE_HOLE,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_DISCONNECTION,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_LEAK,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_MEDICATION_WAS_BEING,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_LOWER,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_AT,
    OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_BLOOD_CLOTTING,
    OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_CATHETER_WAS,
    OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_KINKED_TUBING,
    OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_TUBING_INJECTION,
    OPTION_SIMULTANEOUSFLOWOPTIONS_PRIMARY_AND_SECONDARY,
    OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_OR_MORE_LEADS,
    OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_ADMINISTRATION,
    OPTION_HANGERUSEDOPTIONS_BAXTER_HANGER,
    OPTION_HANGERUSEDOPTIONS_NON_BAXTER_HANGER,
    OPTION_BAGLOWEROPTIONS_BAGS_WERE_AT,
    OPTION_BAGLOWEROPTIONS_PRIMARY,
    OPTION_BAGLOWEROPTIONS_SECONDARY,
    OPTION_YSITECONNECTEDOPTIONS_MIDDLE,
    OPTION_YSITECONNECTEDOPTIONS_LOWER,
    OPTION_YSITECONNECTEDOPTIONS_UPPER,
    OPTION_WITHPUMPOPTIONS_YES_PROVIDE_NAME,
    OPTION_WHATCLAMPFAILEDOPTIONS_DARK_BLUE,
    OPTION_WHATCLAMPFAILEDOPTIONS_LIGHT_BLUE,
    OPTION_WHATCLAMPFAILEDOPTIONS_NOTCH_CLAMP,
    OPTION_WHATCLAMPFAILEDOPTIONS_ROLLER_CLAMP,
    OPTION_WHATCLAMPFAILEDOPTIONS_WHITE_SLIDE_CLAMP,
    OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_THE_CLAMP,
    OPTION_OTHERSITUATIONSPRODUCTOPTIONS_AIR_IN_LINE,
    OPTION_OTHERSITUATIONSPRODUCTOPTIONS_CLAMP_ISSUE,
    OPTION_OTHERSITUATIONSPRODUCTOPTIONS_ODOR,
    OPTION_OTHERSITUATIONSPRODUCTOPTIONS_OTHER,
    OPTION_WHICHCLAMPISSUEOPTIONS_NOTCH_PINCH,
    OPTION_WHICHCLAMPISSUEOPTIONS_ROLLER_CLAMP,
    OPTION_WHICHCLAMPISSUEOPTIONS_SLIDE_CLAMP,
    OPTION_WHICHCLAMPISSUEOPTIONS_UNKNOWN,
    OPTION_WHICHCLAMPISSUEOPTIONS_OTHER,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_CRACKED_BROKEN,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_OPEN,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_CLOSE,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_MISSING,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_OPEN,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CLOSE,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CONTROL,
    OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_TO_SQUEEZE,
    OPTION_CLAMPDESCRIBESISSUEOPTIONS_INSTRUCTIONS_WERE,
    OPTION_CLAMPDESCRIBESISSUEOPTIONS_PRODUCT_WAS_DIFFICULT,
    OPTION_LEAKOCCUROPTIONS_CRACK_BREAK,
    OPTION_LEAKOCCUROPTIONS_CUT_SLICE,
    OPTION_LEAKOCCUROPTIONS_DISCONNECTION_OF_CONNECTABLE,
    OPTION_LEAKOCCUROPTIONS_HOLE_TEA,
    OPTION_LEAKOCCUROPTIONS_SEPARATION_OF_BONDED,
    OPTION_LEAKOCCUROPTIONS_OTHER,
    OPTION_LEAKSCENARIOSOPTIONS_ADHERED_PORT,
    OPTION_LEAKSCENARIOSOPTIONS_DAMAGE_HOLES,
    OPTION_LEAKSCENARIOSOPTIONS_DAMAGED_SHIPPING_CARTON,
    OPTION_LEAKSCENARIOSOPTIONS_EXPOSURE_TO_EXTREME,
    OPTION_LEAKSCENARIOSOPTIONS_OPENING_SHIPPING,
    OPTION_LEAKSCENARIOSOPTIONS_UNKNOWN,
    OPTION_LEAKSCENARIOSOPTIONS_NONE_OF_THE_ABOVE,
    OPTION_LEAKSCENARIOSOPTIONS_PRESSURE_CUFF,
    OPTION_LEAKSCENARIOSOPTIONS_PETS_CLAWED_CHEWED,
    OPTION_PRODUCTDAMAGEDOPTIONS_PRODUCT,
    OPTION_PRODUCTDAMAGEDOPTIONS_SHIPPING_CARTON_BOX,
    OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_PRODUCT,
    OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
    OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT,
    OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING,
    OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING,
    OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_LOOSE_CONNECTION,
    OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
    OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
    OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_EXTERIOR,
    OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_INSIDE_OF,
    OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF,
    OPTION_OPTIONFLOWISSUEOPTIONS_NOT_FLOWING,
    OPTION_OPTIONFLOWISSUEOPTIONS_RESTRICTED_OR,
    OPTION_OPTIONFLOWISSUEOPTIONS_OTHER,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_BARCODE_ISSUE,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_ILLEGIBLE_LABEL,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCORRECT_LABEL,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCOMPLETE_LABEL,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABELS_PRODUCT,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABEL_TOO_SIMILAR,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_LABEL,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_BARCODE,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_OTHER,
    OPTION_DESCOFISSUEOPTIONS_FROZEN_PRODUCT,
    OPTION_DESCOFISSUEOPTIONS_THAWED_PRODUCT,
    OPTION_ALARMOPTIONS_YES_ALARM_NOT_KNOWN,
    OPTION_ALARMOPTIONS_YES_SPECIFY,
    OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_OPEN,
    OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_CLOSED,
    OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_OPEN_AT_ALL,
    OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_CLOSE_AT_ALL,
    OPTION_COMPONENTHADISSUEOPTIONS_BOX_OR_OVERPOUCH,
    OPTION_COMPONENTHADISSUEOPTIONS_BLUE_CLAMP_ON,
    OPTION_COMPONENTHADISSUEOPTIONS_CASSETT,
    OPTION_COMPONENTHADISSUEOPTIONS_DRAIN_LINE,
    OPTION_COMPONENTHADISSUEOPTIONS_EFFLUENT_SAMPLE,
    OPTION_COMPONENTHADISSUEOPTIONS_LINES,
    OPTION_COMPONENTHADISSUEOPTIONS_LUER_SPIKE,
    OPTION_COMPONENTHADISSUEOPTIONS_ORGANIZER,
    OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PATIENT_LINE,
    OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PROTECTORS,
    OPTION_COMPONENTHADISSUEOPTIONS_RED_CLAMP_ON,
    OPTION_COMPONENTHADISSUEOPTIONS_TACK_WELD,
    OPTION_COMPONENTHADISSUEOPTIONS_WHITE_CLAMP_ON_SUPPLY,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_BEIGE_CATHETER,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_CHIP_INSERT,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_DARK_BLUE_CONNECTOR,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_MAIN,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_PULL,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_OCCLUDER,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_SILICONE_TUBING,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_TITANIUM_SPIKE,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_UV_FLASH_SPIKE,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_WHITE_TWIST_CLAMP,
    OPTION_ANYCOMPONENTDAMAGEDOPTIONS_YES_DESCRIBE_THE_DAMAGE,
    OPTION_MONTHOPTIONS_JAN,
    OPTION_MONTHOPTIONS_FEB,
    OPTION_MONTHOPTIONS_MAR,
    OPTION_MONTHOPTIONS_APR,
    OPTION_MONTHOPTIONS_MAY,
    OPTION_MONTHOPTIONS_JUN,
    OPTION_MONTHOPTIONS_JUL,
    OPTION_MONTHOPTIONS_AUG,
    OPTION_MONTHOPTIONS_SEP,
    OPTION_MONTHOPTIONS_OCT,
    OPTION_MONTHOPTIONS_NOV,
    OPTION_MONTHOPTIONS_DEC,
    OPTION_SCENARIOSWITHLEAKOPTIONS_ADHERED_PORT,
    OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGE_HOLES,
    OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGED_SHIPPING,
    OPTION_SCENARIOSWITHLEAKOPTIONS_EXPOSURE_TO_EXTREME,
    OPTION_SCENARIOSWITHLEAKOPTIONS_LEAK_AT_VAPORIZER,
    OPTION_SCENARIOSWITHLEAKOPTIONS_OPENING_SHIPPING,
    OPTION_SCENARIOSWITHLEAKOPTIONS_PETS_CLAWED,
    OPTION_SCENARIOSWITHLEAKOPTIONS_SOLUTION_BAG_UNDER,
    OPTION_SCENARIOSWITHLEAKOPTIONS_UNKNOWN,
    OPTION_SCENARIOSWITHLEAKOPTIONS_NONE_OF_THE_ABOVE,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_IN_THE_SECONDARY,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_SHIPPING,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_EXTERIOR,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_OTHER,
    OPTION_PROBLEMOPTIONS_OTHER,
    OPTION_REPORTEDTOOPTIONS_OTHER,
    OPTION_DIFFICULTTOUSEOPTIONS_OTHER,
    OPTION_DIFFICULTIESMINICAPOPTIONS_OTHER,
    OPTION_BLOCKINGFLOWOPTIONS_OTHER,
    OPTION_DESCRIBEISSUEOPTIONS_OTHER,
    OPTION_MATERIALLOCATEDOPTIONS_OTHER,
    OPTION_OBSERVEDDAMAGEOPTIONS_OTHER,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_OTHER,
    OPTION_PRODUCTDISCOLOREDOPTIONS_OTHER,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_OTHER,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_OTHER,
    OPTION_PRODUCTTHAWEDOPTIONS_OTHER,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_OTHER,
    OPTION_DAMAGESPECIFICINFOOPTIONS_OTHER,
    OPTION_APPROPRIATEDESCRIPTIONOPTIONS_OTHER,
    OPTION_LABELINGISSUEOPTIONS_OTHER,
    OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_OTHER,
    OPTION_MOISTUREOBSERVEDOPTIONS_OTHER,
    OPTION_COMPONENTLEAKINGOPTIONS_OTHER,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_OTHER,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_OTHER,
    OPTION_FOLLOWINGSCENARIOSOPTIONS_OTHER,
    OPTION_SITUATIONFLOWISSUEOPTIONS_OTHER,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_OTHER,
    OPTION_SIMULTANEOUSFLOWOPTIONS_OTHER,
    OPTION_WHATCLAMPFAILEDOPTIONS_OTHER,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_OTHER,
    OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_OTHER,
    OPTION_PRODUCTDAMAGEDOPTIONS_OTHER,
    OPTION_COMPONENTHADISSUEOPTIONS_OTHER,
    OPTION_FOLLOWINGOCCUROPTIONS_NONE_OF_THE_ABOVE,
    OPTION_PREVIOUSLYREPORTEDOPTIONS_NO,
    OPTION_PREVIOUSLYREPORTEDOPTIONS_UNKNOWN,
    OPTION_PREVIOUSLYREPORTEDOPTIONS_YES,
    OPTION_ADDANOTHERFACILITYOPTIONS_NO,
    OPTION_ADDANOTHERFACILITYOPTIONS_YES,
    OPTION_PATIENINVOLVEMENTOPTIONS_NO,
    OPTION_PATIENINVOLVEMENTOPTIONS_UNKNOWN,
    OPTION_PATIENINVOLVEMENTOPTIONS_YES,
    OPTION_OTHERFACILITYREPORTOPTIONS_NO,
    OPTION_OTHERFACILITYREPORTOPTIONS_YES,
    OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_ASKED_UNKNOWN,
    OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_NO,
    OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_UNKNOWN,
    OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_YES,
    OPTION_AVAILABILITYOPTIONS_NO,
    OPTION_AVAILABILITYOPTIONS_YES,
    OPTION_MEDIAAVAILABILITYOPTIONS_NO,
    OPTION_MEDIAAVAILABILITYOPTIONS_YES,
    OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_NO,
    OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_UNKNOWN,
    OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_YES,
    OPTION_UNUSEDAVAILABILITYOPTIONS_NO,
    OPTION_UNUSEDAVAILABILITYOPTIONS_YES,
    OPTION_SELFNEGATIVEIMPACTOPTIONS_NO,
    OPTION_SELFNEGATIVEIMPACTOPTIONS_YES,
    OPTION_PATIENTNEGATIVEIMPACTOPTIONS_NO,
    OPTION_PATIENTNEGATIVEIMPACTOPTIONS_YES,
    OPTION_COUNTERACTIONOPTIONS_NO,
    OPTION_COUNTERACTIONOPTIONS_YES,
    OPTION_DRUGUSEDOPTIONS_NO,
    OPTION_DRUGUSEDOPTIONS_YES,
    OPTION_SHARECONTACTOPTIONS_NO,
    OPTION_SHARECONTACTOPTIONS_YES,
    OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_NO,
    OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_YES,
    OPTION_DIRECTORDEROPTIONS_NO,
    OPTION_DIRECTORDEROPTIONS_YES,
    OPTION_EXCESSIVEFORCEOPTIONS_NO,
    OPTION_EXCESSIVEFORCEOPTIONS_UNKNOWN,
    OPTION_EXCESSIVEFORCEOPTIONS_YES,
    OPTION_TWISTCLAMPOPTIONS_NO,
    OPTION_TWISTCLAMPOPTIONS_UNKNOWN,
    OPTION_TWISTCLAMPOPTIONS_YES,
    OPTION_DIFFICULTIESMINICAPOPTIONS_NO,
    OPTION_DIFFICULTIESMINICAPOPTIONS_UNKNOWN,
    OPTION_ENVIRONMENTOPTIONS_NO,
    OPTION_ENVIRONMENTOPTIONS_UNKNOWN,
    OPTION_ENVIRONMENTOPTIONS_YES,
    OPTION_SPONGEVISIBLEOPTIONS_NO,
    OPTION_SPONGEVISIBLEOPTIONS_UNKNOWN,
    OPTION_SPONGEVISIBLEOPTIONS_YES,
    OPTION_MATERIALEMBEDDEDOPTIONS_NO,
    OPTION_MATERIALEMBEDDEDOPTIONS_UNKNOWN,
    OPTION_MATERIALEMBEDDEDOPTIONS_YES,
    OPTION_PIECESMATERIALOPTIONS_NO,
    OPTION_PIECESMATERIALOPTIONS_UNKNOWN,
    OPTION_PIECESMATERIALOPTIONS_YES,
    OPTION_DISPOSABLECONNECTIONOPTIONS_NO,
    OPTION_DISPOSABLECONNECTIONOPTIONS_UNKNOWN,
    OPTION_DISPOSABLECONNECTIONOPTIONS_YES,
    OPTION_INITIALCONNECTIONOPTIONS_NO,
    OPTION_INITIALCONNECTIONOPTIONS_UNKNOWN,
    OPTION_INITIALCONNECTIONOPTIONS_YES,
    OPTION_SPIKELUERCONNECTORSOPTIONS_NO,
    OPTION_SPIKELUERCONNECTORSOPTIONS_UNKNOWN,
    OPTION_SPIKELUERCONNECTORSOPTIONS_YES,
    OPTION_PETSORANIMALSOPTIONS_NO,
    OPTION_PETSORANIMALSOPTIONS_UNKNOWN,
    OPTION_PETSORANIMALSOPTIONS_YES,
    OPTION_MINICAPTWISTEDOPTIONS_NO,
    OPTION_MINICAPTWISTEDOPTIONS_UNKNOWN,
    OPTION_MINICAPTWISTEDOPTIONS_YES,
    OPTION_TRANSFERSETOPTIONS_NO,
    OPTION_TRANSFERSETOPTIONS_UNKNOWN,
    OPTION_TRANSFERSETOPTIONS_YES,
    OPTION_RESIDUETHREADSOPTIONS_NO,
    OPTION_RESIDUETHREADSOPTIONS_UNKNOWN,
    OPTION_DAMAGECAUSELEAKOPTIONS_NO,
    OPTION_DAMAGECAUSELEAKOPTIONS_UNKNOWN,
    OPTION_DAMAGECAUSELEAKOPTIONS_YES,
    OPTION_SHIPPINGCARTONOPENOPTIONS_NO,
    OPTION_SHIPPINGCARTONOPENOPTIONS_UNKNOWN,
    OPTION_SHIPPINGCARTONOPENOPTIONS_YES,
    OPTION_ADAPTERDEVICEOPTIONS_NO,
    OPTION_ADAPTERDEVICEOPTIONS_UNKNOWN,
    OPTION_ADAPTERDEVICEOPTIONS_YES,
    OPTION_SQUEEZINGSOLUTIONOPTIONSS_NO,
    OPTION_SQUEEZINGSOLUTIONOPTIONSS_UNKNOWN,
    OPTION_SQUEEZINGSOLUTIONOPTIONSS_YES,
    OPTION_FORTHMOTIONOPTIONS_NO,
    OPTION_FORTHMOTIONOPTIONS_UNKNOWN,
    OPTION_FORTHMOTIONOPTIONS_YES,
    OPTION_ALARMNOFLOWOPTIONS_NO,
    OPTION_ALARMNOFLOWOPTIONS_UNKNOWN,
    OPTION_ALARMNOFLOWOPTIONS_YES,
    OPTION_DISCOLORATIONMARKINGSOPTIONS_NO,
    OPTION_DISCOLORATIONMARKINGSOPTIONS_UNKNOWN,
    OPTION_DISCOLORATIONMARKINGSOPTIONS_YES,
    OPTION_BROKENACTIVATEDOPTIONS_NO,
    OPTION_BROKENACTIVATEDOPTIONS_UNKNOWN,
    OPTION_BROKENACTIVATEDOPTIONS_YES,
    OPTION_vaporizerSightGlassOptions_NO,
    OPTION_vaporizerSightGlassOptions_UNKNOWN,
    OPTION_vaporizerSightGlassOptions_YES,
    OPTION_PRODUCTHEATOPTIONS_NO,
    OPTION_PRODUCTHEATOPTIONS_UNKNOWN,
    OPTION_PRODUCTHEATOPTIONS_YES,
    OPTION_DAMAGEPRIORACTIVATIONOPTIONS_NO,
    OPTION_DAMAGEPRIORACTIVATIONOPTIONS_UNKNOWN,
    OPTION_DAMAGEPRIORACTIVATIONOPTIONS_YES,
    OPTION_LEAKOBSERVEDOPTIONS_NO,
    OPTION_LEAKOBSERVEDOPTIONS_UNKNOWN,
    OPTION_LEAKOBSERVEDOPTIONS_YES,
    OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_NO,
    OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_UNKNOWN,
    OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_YES,
    OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_NO,
    OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_UNKNOWN,
    OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_YES,
    OPTION_CLOUDINESSGOAWAYOPTIONS_NO,
    OPTION_CLOUDINESSGOAWAYOPTIONS_UNKNOWN,
    OPTION_CLOUDINESSGOAWAYOPTIONS_YES,
    OPTION_AGITATEUNITOPTIONS_NO,
    OPTION_AGITATEUNITOPTIONS_UNKNOWN,
    OPTION_AGITATEUNITOPTIONS_YES,
    OPTION_PRECIPITATEDISSOLVEOPTIONS_NO,
    OPTION_PRECIPITATEDISSOLVEOPTIONS_UNKNOWN,
    OPTION_PRECIPITATEDISSOLVEOPTIONS_YES,
    OPTION_TEMPERATURELOGSFREEZEROPTIONS_NO,
    OPTION_TEMPERATURELOGSFREEZEROPTIONS_UNKNOWN,
    OPTION_TEMPERATURELOGSFREEZEROPTIONS_YES,
    OPTION_STORAGEUNITCALIBRATEDOPTIONSS_NO,
    OPTION_STORAGEUNITCALIBRATEDOPTIONSS_UNKNOWN,
    OPTION_STORAGEUNITCALIBRATEDOPTIONSS_YES,
    OPTION_RECENTPRESCRIPTIONOPTIONS_NO,
    OPTION_RECENTPRESCRIPTIONOPTIONS_UNKNOWN,
    OPTION_RECENTPRESCRIPTIONOPTIONS_YES,
    OPTION_EXPIREDPRODUCTOPTIONS_NO,
    OPTION_EXPIREDPRODUCTOPTIONS_UNKNOWN,
    OPTION_EXPIREDPRODUCTOPTIONS_YES,
    OPTION_ABNORMALITIESDAMAGEOPTIONS_NO,
    OPTION_ABNORMALITIESDAMAGEOPTIONS_UNKNOWN,
    OPTION_ABNORMALITIESDAMAGEOPTIONS_YES,
    OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_NO,
    OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_UNKNOWN,
    OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_YES,
    OPTION_LABELSSAMEINFORMATIONOPTIONS_NO,
    OPTION_LABELSSAMEINFORMATIONOPTIONS_UNKNOWN,
    OPTION_LABELSSAMEINFORMATIONOPTIONS_YES,
    OPTION_BARCODESCANNEROPTIONS_NO,
    OPTION_BARCODESCANNEROPTIONS_UNKNOWN,
    OPTION_BARCODESCANNEROPTIONS_YES,
    OPTION_FRANGIBLEOBSERVEDOPTIONS_NO,
    OPTION_FRANGIBLEOBSERVEDOPTIONS_UNKNOWN,
    OPTION_FRANGIBLEOBSERVEDOPTIONS_YES,
    OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_NO,
    OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_UNKNOWN,
    OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_YES,
    OPTION_FRANGIBLEBROKENOPTIONS_NO,
    OPTION_FRANGIBLEBROKENOPTIONS_UNKNOWN,
    OPTION_FRANGIBLEBROKENOPTIONS_YES,
    OPTION_MOISTURECLEAROPTIONS_UNKNOWN,
    OPTION_MOISTURECLEAROPTIONS_YES,
    OPTION_DIFFICULTYSPIKINGOPTIONS_NO,
    OPTION_DIFFICULTYSPIKINGOPTIONS_UNKNOWN,
    OPTION_DIFFICULTYSPIKINGOPTIONS_YES,
    OPTION_WASFRANGIBLEDAMAGEOPTIONS_NO,
    OPTION_WASFRANGIBLEDAMAGEOPTIONS_UNKNOWN,
    OPTION_WASFRANGIBLEDAMAGEOPTIONS_YES,
    OPTION_PRESSURECUFFOPTIONS_NO,
    OPTION_PRESSURECUFFOPTIONS_UNKNOWN,
    OPTION_PRESSURECUFFOPTIONS_YES,
    OPTION_LIQUIDSPILLEDOPTIONS_UNKNOWN,
    OPTION_BOTTLEINTOVAPORIZEROPTIONS_NO,
    OPTION_BOTTLEINTOVAPORIZEROPTIONS_UNKNOWN,
    OPTION_BOTTLEINTOVAPORIZEROPTIONS_YES,
    OPTION_REMOVEDFROMPACKAGEOPTIONS_NO,
    OPTION_REMOVEDFROMPACKAGEOPTIONS_UNKNOWN,
    OPTION_REMOVEDFROMPACKAGEOPTIONS_YES,
    OPTION_ADDINGMEDICATIONOPTIONS_NO,
    OPTION_ADDINGMEDICATIONOPTIONS_UNKNOWN,
    OPTION_ADDINGMEDICATIONOPTIONS_YES,
    OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_NO,
    OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_UNKNOWN,
    OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_YES,
    OPTION_WASPRODUCTREPLACEDOPTIONS_NO,
    OPTION_WASPRODUCTREPLACEDOPTIONS_UNKNOWN,
    OPTION_WASPRODUCTREPLACEDOPTIONS_YES,
    OPTION_WASPOWERINJECTOROPTIONS_NO,
    OPTION_WASPOWERINJECTOROPTIONS_UNKNOWN,
    OPTION_WASPOWERINJECTOROPTIONS_YES,
    OPTION_INJECTIONSITEOPENINGOPTIONS_NO,
    OPTION_INJECTIONSITEOPENINGOPTIONS_UNKNOWN,
    OPTION_INJECTIONSITEOPENINGOPTIONS_YES,
    OPTION_INJECTIONSITEOPENINGOPTIONS_OTHER,
    OPTION_VISIBLEIRREGULARITIESOPTIONS_NO,
    OPTION_VISIBLEIRREGULARITIESOPTIONS_UNKNOWN,
    OPTION_EVENTUALLYESTABLISHEDOPTIONS_NO,
    OPTION_EVENTUALLYESTABLISHEDOPTIONS_UNKNOWN,
    OPTION_EVENTUALLYESTABLISHEDOPTIONS_YES,
    OPTION_TOOLUSEDASSISTOPTIONS_NO,
    OPTION_TOOLUSEDASSISTOPTIONS_UNKNOWN,
    OPTION_SECUREPRIORUSEOPTIONS_NO,
    OPTION_SECUREPRIORUSEOPTIONS_UNKNOWN,
    OPTION_SECUREPRIORUSEOPTIONS_YES,
    OPTION_PRIORDISCONNECTINGOPTIONS_NO,
    OPTION_PRIORDISCONNECTINGOPTIONS_UNKNOWN,
    OPTION_PRIORDISCONNECTINGOPTIONS_YES,
    OPTION_FLOWPREVIOUSLYSEENOPTIONS_NO,
    OPTION_FLOWPREVIOUSLYSEENOPTIONS_UNKNOWN,
    OPTION_FLOWPREVIOUSLYSEENOPTIONS_YES,
    OPTION_YSITECONNECTEDOPTIONS_UNKNOWN,
    OPTION_COMPONENTSETREPLACEDOPTIONS_NO,
    OPTION_COMPONENTSETREPLACEDOPTIONS_UNKNOWN,
    OPTION_COMPONENTSETREPLACEDOPTIONS_YES,
    OPTION_WITHPUMPOPTIONS_NO,
    OPTION_WITHPUMPOPTIONS_UNKNOWN,
    OPTION_CLAMPFAILOPTIONS_NO,
    OPTION_CLAMPFAILOPTIONS_UNKNOWN,
    OPTION_CLAMPFAILOPTIONS_YES,
    OPTION_ISSUESOBSERVEDCLAMPOPTIONS_NO,
    OPTION_ISSUESOBSERVEDCLAMPOPTIONS_UNKNOWN,
    OPTION_WASMATERIALEMBEDDEDOPTIONS_NO,
    OPTION_WASMATERIALEMBEDDEDOPTIONS_UNKNOWN,
    OPTION_WASMATERIALEMBEDDEDOPTIONS_YES,
    OPTION_APPEARPRODUCTMATERIALOPTIONS_NO,
    OPTION_APPEARPRODUCTMATERIALOPTIONS_UNKNOWN,
    OPTION_APPEARPRODUCTMATERIALOPTIONS_YES,
    OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_NO,
    OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_UNKNOWN,
    OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_YES,
    OPTION_GELPACKSOPTIONS_NO,
    OPTION_GELPACKSOPTIONS_YES,
    OPTION_EXPIREDPRODUCTUSEOPTIONS_NO,
    OPTION_EXPIREDPRODUCTUSEOPTIONS_UNKNOWN,
    OPTION_EXPIREDPRODUCTUSEOPTIONS_YES,
    OPTION_ALARMOPTIONS_NO,
    OPTION_ALARMOPTIONS_UNKNOWN,
    OPTION_CLEANINGSOLUTIONSOPTIONS_NO,
    OPTION_CLEANINGSOLUTIONSOPTIONS_UNKNOWN,
    OPTION_CLEANINGSOLUTIONSOPTIONS_YES,
    OPTION_DIFFICULTINTWISTCLAMPOPTIONS_NO,
    OPTION_DIFFICULTINTWISTCLAMPOPTIONS_UNKNOWN,
    OPTION_TRANSFERREPLACEDOPTIONS_NO,
    OPTION_TRANSFERREPLACEDOPTIONS_UNKNOWN,
    OPTION_TRANSFERREPLACEDOPTIONS_YES,
    OPTION_FULLYTIGHTENEDOPTIONS_NO,
    OPTION_FULLYTIGHTENEDOPTIONS_UNKNOWN,
    OPTION_FULLYTIGHTENEDOPTIONS_YES,
    OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_NO,
    OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_UNKNOWN,
    OPTION_ISSUERESULTLEAKOPTIONS_NO,
    OPTION_ISSUERESULTLEAKOPTIONS_UNKNOWN,
    OPTION_ISSUERESULTLEAKOPTIONS_YES,
    OPTION_ISSUERESULTLEAKOPTIONS_OTHER,
    OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_NO,
    OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_YES,
    OPTION_EXPLICITLYREQUESTOPTIONS_NO,
    OPTION_EXPLICITLYREQUESTOPTIONS_UNKNOWN,
    OPTION_EXPLICITLYREQUESTOPTIONS_YES,
    OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_NO,
    OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_UNKNOWN,
    OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_YES,
    OPTION_PATIENINVOLVEMENTOPTIONS_ASKED_UNKNOWN,
    OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_ASKED_UNKNOWN,
    OPTION_CHAMBERDISCOLOREDOPTIONS_UNKNOWN,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_UNKNOWN,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_NO,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_UNKNOWN,
    OPTION_SCENARIOSLEAKOPTIONS_UNKNOWN,
    OPTION_SCENARIOSLEAKOPTIONS_NONE_OF_THE_ABOVE,
    OPTION_MOISTURECLEAROPTIONS_NO_DESCRIBE_THE_COLOR,
    OPTION_EMBEDDEDPLASTICOPTIONS_UNKNOWN,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_UNKNOWN,
    OPTION_TOOLUSEDASSISTOPTIONS_YES_SPECIFY_THE_TOOL,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_SEPARATION,
    OPTION_HANGERUSEDOPTIONS_UNKNOWN,
    OPTION_HANGERUSEDOPTIONS_NONE,
    OPTION_BAGLOWEROPTIONS_UNKNOWN,
    OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_OTHER,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNKNOWN,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_NO,
    OPTION_WEIGHTUNITOPTIONS_KILOGRAM,
    OPTION_WEIGHTUNITOPTIONS_POUND,
    OPTION_INFUSATESOLUTIONOPTIONS_NO,
    OPTION_INFUSATESOLUTIONOPTIONS_UNKNOWN,
    PLEASE_ENTER_THE_VALUE,
    PLEASE_SELECT_THE_VALUE,
    PLEASE_SELECT_THE_DATE,
    PLEASE_CHOOSE_THE_VALUE,
    OPTION_MEDIAAVAILABILITYOPTIONS_UNKNOWN,
    OPTION_COUNTRYOPTIONS_GREAT_BRITAIN,
    OPTION_COUNTRYOPTIONS_KOSOVO,
    OPTION_COUNTRYOPTIONS_NORTHERN_IRELAND,
    OPTION_COUNTRYOPTIONS_AFGHANISTAN,
    OPTION_COUNTRYOPTIONS_ÅLAND_ISLANDS,
    OPTION_COUNTRYOPTIONS_ALBANIA,
    OPTION_COUNTRYOPTIONS_ALGERIA,
    OPTION_COUNTRYOPTIONS_AMERICAN_SAMOA,
    OPTION_COUNTRYOPTIONS_ANDORRA,
    OPTION_COUNTRYOPTIONS_ANGOLA,
    OPTION_COUNTRYOPTIONS_ANGUILLA,
    OPTION_COUNTRYOPTIONS_ANTARCTICA,
    OPTION_COUNTRYOPTIONS_ANTIGUA_AND_BARBUDA,
    OPTION_COUNTRYOPTIONS_ARGENTINA,
    OPTION_COUNTRYOPTIONS_ARMENIA,
    OPTION_COUNTRYOPTIONS_ARUBA,
    OPTION_COUNTRYOPTIONS_AUSTRALIA,
    OPTION_COUNTRYOPTIONS_AUSTRIA,
    OPTION_COUNTRYOPTIONS_AZERBAIJAN,
    OPTION_COUNTRYOPTIONS_BAHAMAS,
    OPTION_COUNTRYOPTIONS_BAHRAIN,
    OPTION_COUNTRYOPTIONS_BANGLADESH,
    OPTION_COUNTRYOPTIONS_BARBADOS,
    OPTION_COUNTRYOPTIONS_BELARUS,
    OPTION_COUNTRYOPTIONS_BELGIUM,
    OPTION_COUNTRYOPTIONS_BELIZE,
    OPTION_COUNTRYOPTIONS_BENIN,
    OPTION_COUNTRYOPTIONS_BERMUDA,
    OPTION_COUNTRYOPTIONS_BHUTAN,
    OPTION_COUNTRYOPTIONS_BOLIVIA,
    OPTION_COUNTRYOPTIONS_BOSNIA_AND_HERZEGOVINA,
    OPTION_COUNTRYOPTIONS_BOTSWANA,
    OPTION_COUNTRYOPTIONS_BOUVET_ISLAND,
    OPTION_COUNTRYOPTIONS_BRAZIL,
    OPTION_COUNTRYOPTIONS_BRITISH_INDIAN_OCEAN_TERRITORY,
    OPTION_COUNTRYOPTIONS_BRUNEI_DARUSSALAM,
    OPTION_COUNTRYOPTIONS_BULGARIA,
    OPTION_COUNTRYOPTIONS_BURKINA_FASO,
    OPTION_COUNTRYOPTIONS_BURUNDI,
    OPTION_COUNTRYOPTIONS_CAMBODIA,
    OPTION_COUNTRYOPTIONS_CAMEROON,
    OPTION_COUNTRYOPTIONS_CANADA,
    OPTION_COUNTRYOPTIONS_CAPE_VERDE,
    OPTION_COUNTRYOPTIONS_CAYMAN_ISLANDS,
    OPTION_COUNTRYOPTIONS_CENTRAL_AFRICAN_REPUBLIC,
    OPTION_COUNTRYOPTIONS_CHAD,
    OPTION_COUNTRYOPTIONS_CHILE,
    OPTION_COUNTRYOPTIONS_CHINA,
    OPTION_COUNTRYOPTIONS_CHRISTMAS_ISLAND,
    OPTION_COUNTRYOPTIONS_COCOS_KEELING_ISLANDS,
    OPTION_COUNTRYOPTIONS_COLOMBIA,
    OPTION_COUNTRYOPTIONS_COMOROS,
    OPTION_COUNTRYOPTIONS_CONGO,
    OPTION_COUNTRYOPTIONS_CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE,
    OPTION_COUNTRYOPTIONS_COOK_ISLANDS,
    OPTION_COUNTRYOPTIONS_COSTA_RICA,
    OPTION_COUNTRYOPTIONS_CÔTE_DIVOIRE_IVORY_COAST,
    OPTION_COUNTRYOPTIONS_CROATIA,
    OPTION_COUNTRYOPTIONS_CUBA,
    OPTION_COUNTRYOPTIONS_CYPRUS,
    OPTION_COUNTRYOPTIONS_CZECH_REPUBLIC,
    OPTION_COUNTRYOPTIONS_DENMARK,
    OPTION_COUNTRYOPTIONS_DJIBOUTI,
    OPTION_COUNTRYOPTIONS_DOMINICA,
    OPTION_COUNTRYOPTIONS_DOMINICAN_REPUBLIC,
    OPTION_COUNTRYOPTIONS_ECUADOR,
    OPTION_COUNTRYOPTIONS_EGYPT,
    OPTION_COUNTRYOPTIONS_EL_SALVADOR,
    OPTION_COUNTRYOPTIONS_EQUATORIAL_GUINEA,
    OPTION_COUNTRYOPTIONS_ERITREA,
    OPTION_COUNTRYOPTIONS_ESTONIA,
    OPTION_COUNTRYOPTIONS_ETHIOPIA,
    OPTION_COUNTRYOPTIONS_FALKLAND_ISLANDS_MALVINAS,
    OPTION_COUNTRYOPTIONS_FAROE_ISLANDS,
    OPTION_COUNTRYOPTIONS_FIJI,
    OPTION_COUNTRYOPTIONS_FINLAND,
    OPTION_COUNTRYOPTIONS_FRANCE,
    OPTION_COUNTRYOPTIONS_FRENCH_GUIANA,
    OPTION_COUNTRYOPTIONS_FRENCH_POLYNESIA,
    OPTION_COUNTRYOPTIONS_FRENCH_SOUTHERN_TERRITORIES,
    OPTION_COUNTRYOPTIONS_GABON,
    OPTION_COUNTRYOPTIONS_GAMBIA,
    OPTION_COUNTRYOPTIONS_GEORGIA,
    OPTION_COUNTRYOPTIONS_GERMANY,
    OPTION_COUNTRYOPTIONS_GHANA,
    OPTION_COUNTRYOPTIONS_GIBRALTAR,
    OPTION_COUNTRYOPTIONS_GREECE,
    OPTION_COUNTRYOPTIONS_GREENLAND,
    OPTION_COUNTRYOPTIONS_GRENADA,
    OPTION_COUNTRYOPTIONS_GUADELOUPE,
    OPTION_COUNTRYOPTIONS_GUAM,
    OPTION_COUNTRYOPTIONS_GUATEMALA,
    OPTION_COUNTRYOPTIONS_GUERNSEY,
    OPTION_COUNTRYOPTIONS_GUINEA,
    OPTION_COUNTRYOPTIONS_GUINEA_BISSAU,
    OPTION_COUNTRYOPTIONS_GUYANA,
    OPTION_COUNTRYOPTIONS_HAITI,
    OPTION_COUNTRYOPTIONS_HEARD_ISLAND_AND_MCDONALD_ISLANDS,
    OPTION_COUNTRYOPTIONS_HOLY_SEE_VATICAN_CITY_STATE,
    OPTION_COUNTRYOPTIONS_HONDURAS,
    OPTION_COUNTRYOPTIONS_HONG_KONG,
    OPTION_COUNTRYOPTIONS_HUNGARY,
    OPTION_COUNTRYOPTIONS_ICELAND,
    OPTION_COUNTRYOPTIONS_INDIA,
    OPTION_COUNTRYOPTIONS_INDONESIA,
    OPTION_COUNTRYOPTIONS_IRAN_ISLAMIC_REPUBLIC_OF,
    OPTION_COUNTRYOPTIONS_IRAQ,
    OPTION_COUNTRYOPTIONS_IRELAND,
    OPTION_COUNTRYOPTIONS_ISLE_OF_MAN,
    OPTION_COUNTRYOPTIONS_ISRAEL,
    OPTION_COUNTRYOPTIONS_ITALY,
    OPTION_COUNTRYOPTIONS_JAMAICA,
    OPTION_COUNTRYOPTIONS_JAPAN,
    OPTION_COUNTRYOPTIONS_JERSEY,
    OPTION_COUNTRYOPTIONS_JORDAN,
    OPTION_COUNTRYOPTIONS_KAZAKHSTAN,
    OPTION_COUNTRYOPTIONS_KENYA,
    OPTION_COUNTRYOPTIONS_KIRIBATI,
    OPTION_COUNTRYOPTIONS_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF,
    OPTION_COUNTRYOPTIONS_KOREA_REPUBLIC_OF,
    OPTION_COUNTRYOPTIONS_KUWAIT,
    OPTION_COUNTRYOPTIONS_KYRGYZSTAN,
    OPTION_COUNTRYOPTIONS_LAO_PEOPLES_DEMOCRATIC_REPUBLIC,
    OPTION_COUNTRYOPTIONS_LATVIA,
    OPTION_COUNTRYOPTIONS_LEBANON,
    OPTION_COUNTRYOPTIONS_LESOTHO,
    OPTION_COUNTRYOPTIONS_LIBERIA,
    OPTION_COUNTRYOPTIONS_LIBYAN_ARAB_JAMAHIRIYA,
    OPTION_COUNTRYOPTIONS_LIECHTENSTEIN,
    OPTION_COUNTRYOPTIONS_LITHUANIA,
    OPTION_COUNTRYOPTIONS_LUXEMBOURG,
    OPTION_COUNTRYOPTIONS_MACAO,
    OPTION_COUNTRYOPTIONS_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF,
    OPTION_COUNTRYOPTIONS_MADAGASCAR,
    OPTION_COUNTRYOPTIONS_MALAWI,
    OPTION_COUNTRYOPTIONS_MALAYSIA,
    OPTION_COUNTRYOPTIONS_MALDIVES,
    OPTION_COUNTRYOPTIONS_MALI,
    OPTION_COUNTRYOPTIONS_MALTA,
    OPTION_COUNTRYOPTIONS_MARSHALL_ISLANDS,
    OPTION_COUNTRYOPTIONS_MARTINIQUE,
    OPTION_COUNTRYOPTIONS_MAURITANIA,
    OPTION_COUNTRYOPTIONS_MAURITIUS,
    OPTION_COUNTRYOPTIONS_MAYOTTE,
    OPTION_COUNTRYOPTIONS_MEXICO,
    OPTION_COUNTRYOPTIONS_MICRONESIA_FEDERATED_STATES_OF,
    OPTION_COUNTRYOPTIONS_MOLDOVA,
    OPTION_COUNTRYOPTIONS_MONACO,
    OPTION_COUNTRYOPTIONS_MONGOLIA,
    OPTION_COUNTRYOPTIONS_MONTENEGRO,
    OPTION_COUNTRYOPTIONS_MONTSERRAT,
    OPTION_COUNTRYOPTIONS_MOROCCO,
    OPTION_COUNTRYOPTIONS_MOZAMBIQUE,
    OPTION_COUNTRYOPTIONS_MYANMAR,
    OPTION_COUNTRYOPTIONS_NAMIBIA,
    OPTION_COUNTRYOPTIONS_NAURU,
    OPTION_COUNTRYOPTIONS_NEPAL,
    OPTION_COUNTRYOPTIONS_NETHERLANDS,
    OPTION_COUNTRYOPTIONS_NEW_CALEDONIA,
    OPTION_COUNTRYOPTIONS_NEW_ZEALAND,
    OPTION_COUNTRYOPTIONS_NICARAGUA,
    OPTION_COUNTRYOPTIONS_NIGER,
    OPTION_COUNTRYOPTIONS_NIGERIA,
    OPTION_COUNTRYOPTIONS_NIUE,
    OPTION_COUNTRYOPTIONS_NORFOLK_ISLAND,
    OPTION_COUNTRYOPTIONS_NORTHERN_MARIANA_ISLANDS,
    OPTION_COUNTRYOPTIONS_NORWAY,
    OPTION_COUNTRYOPTIONS_OMAN,
    OPTION_COUNTRYOPTIONS_PAKISTAN,
    OPTION_COUNTRYOPTIONS_PALAU,
    OPTION_COUNTRYOPTIONS_PALESTINIAN_TERRITORY_OCCUPIED,
    OPTION_COUNTRYOPTIONS_PANAMA,
    OPTION_COUNTRYOPTIONS_PAPUA_NEW_GUINEA,
    OPTION_COUNTRYOPTIONS_PARAGUAY,
    OPTION_COUNTRYOPTIONS_PERU,
    OPTION_COUNTRYOPTIONS_PHILIPPINES,
    OPTION_COUNTRYOPTIONS_PITCAIRN,
    OPTION_COUNTRYOPTIONS_POLAND,
    OPTION_COUNTRYOPTIONS_PORTUGAL,
    OPTION_COUNTRYOPTIONS_PUERTO_RICO,
    OPTION_COUNTRYOPTIONS_QATAR,
    OPTION_COUNTRYOPTIONS_RÉUNION,
    OPTION_COUNTRYOPTIONS_ROMANIA,
    OPTION_COUNTRYOPTIONS_RUSSIAN_FEDERATION,
    OPTION_COUNTRYOPTIONS_RWANDA,
    OPTION_COUNTRYOPTIONS_SAINT_BARTHÉLEMY,
    OPTION_COUNTRYOPTIONS_SAINT_HELENA,
    OPTION_COUNTRYOPTIONS_SAINT_KITTS_AND_NEVIS,
    OPTION_COUNTRYOPTIONS_SAINT_LUCIA,
    OPTION_COUNTRYOPTIONS_SAINT_MARTIN,
    OPTION_COUNTRYOPTIONS_SAINT_PIERRE_AND_MIQUELON,
    OPTION_COUNTRYOPTIONS_SAINT_VINCENT_AND_THE_GRENADINES,
    OPTION_COUNTRYOPTIONS_SAMOA,
    OPTION_COUNTRYOPTIONS_SAN_MARINO,
    OPTION_COUNTRYOPTIONS_SAO_TOME_AND_PRINCIPE,
    OPTION_COUNTRYOPTIONS_SAUDI_ARABIA,
    OPTION_COUNTRYOPTIONS_SENEGAL,
    OPTION_COUNTRYOPTIONS_SERBIA,
    OPTION_COUNTRYOPTIONS_SEYCHELLES,
    OPTION_COUNTRYOPTIONS_SIERRA_LEONE,
    OPTION_COUNTRYOPTIONS_SINGAPORE,
    OPTION_COUNTRYOPTIONS_SLOVAKIA,
    OPTION_COUNTRYOPTIONS_SLOVENIA,
    OPTION_COUNTRYOPTIONS_SOLOMON_ISLANDS,
    OPTION_COUNTRYOPTIONS_SOMALIA,
    OPTION_COUNTRYOPTIONS_SOUTH_AFRICA,
    OPTION_COUNTRYOPTIONS_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS,
    OPTION_COUNTRYOPTIONS_SPAIN,
    OPTION_COUNTRYOPTIONS_SRI_LANKA,
    OPTION_COUNTRYOPTIONS_SUDAN,
    OPTION_COUNTRYOPTIONS_SURINAME,
    OPTION_COUNTRYOPTIONS_SVALBARD_AND_JAN_MAYEN,
    OPTION_COUNTRYOPTIONS_SWAZILAND,
    OPTION_COUNTRYOPTIONS_SWEDEN,
    OPTION_COUNTRYOPTIONS_SWITZERLAND,
    OPTION_COUNTRYOPTIONS_SYRIAN_ARAB_REPUBLIC,
    OPTION_COUNTRYOPTIONS_TAIWAN_ROC,
    OPTION_COUNTRYOPTIONS_TAJIKISTAN,
    OPTION_COUNTRYOPTIONS_TANZANIA_UNITED_REPUBLIC_OF,
    OPTION_COUNTRYOPTIONS_THAILAND,
    OPTION_COUNTRYOPTIONS_TIMOR_LESTE,
    OPTION_COUNTRYOPTIONS_TOGO,
    OPTION_COUNTRYOPTIONS_TOKELAU,
    OPTION_COUNTRYOPTIONS_TONGA,
    OPTION_COUNTRYOPTIONS_TRINIDAD_AND_TOBAGO,
    OPTION_COUNTRYOPTIONS_TUNISIA,
    OPTION_COUNTRYOPTIONS_TURKEY,
    OPTION_COUNTRYOPTIONS_TURKMENISTAN,
    OPTION_COUNTRYOPTIONS_TURKS_AND_CAICOS_ISLANDS,
    OPTION_COUNTRYOPTIONS_TUVALU,
    OPTION_COUNTRYOPTIONS_UGANDA,
    OPTION_COUNTRYOPTIONS_UKRAINE,
    OPTION_COUNTRYOPTIONS_UNITED_ARAB_EMIRATES,
    OPTION_COUNTRYOPTIONS_UNITED_KINGDOM,
    OPTION_COUNTRYOPTIONS_UNITED_STATES,
    OPTION_COUNTRYOPTIONS_UNITED_STATES_MINOR_OUTLYING_ISLANDS,
    OPTION_COUNTRYOPTIONS_URUGUAY,
    OPTION_COUNTRYOPTIONS_UZBEKISTAN,
    OPTION_COUNTRYOPTIONS_VANUATU,
    OPTION_COUNTRYOPTIONS_VENEZUELA,
    OPTION_COUNTRYOPTIONS_VIET_NAM,
    OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_BRITISH,
    OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_US,
    OPTION_COUNTRYOPTIONS_WALLIS_AND_FUTUNA,
    OPTION_COUNTRYOPTIONS_WESTERN_SAHARA,
    OPTION_COUNTRYOPTIONS_YEMEN,
    OPTION_COUNTRYOPTIONS_ZAMBIA,
    OPTION_COUNTRYOPTIONS_ZIMBABWE,
    LANDING_TERMS_I_HAVE_READ,
    LANDING_TERMS_THE_USE_DISCLOSURE,
    LANDING_TERMS_THE_TRANSFER_OF,
    LANDING_TERMS_I_UNDERSTAND_THAT,
    OPTION_DOESTHEPARTICULATEMATTER_NO,
    OPTION_DOESTHEPARTICULATEMATTER_UNKNOWN,
    OPTION_DOESTHEPARTICULATEMATTER_YES,
    I_HAVE_READ_AND_UNDERSTAND_THE_LINKED_PRIVACY_NOTICE,
    PRODUCT_LOT,
    SHIPPING_DISTRIBUTION_LABEL,
    CARTON_LABEL,
    INTERNAL_PRODUCT_LABEL,
    TITLE_PD_RENAL,
    TITLE_SOLUTIONS,
    TITLE_ACCESS,
    TITLE_ALL_OTHER_PRODUCT,
    REPORTED_PROBLEM,
    LOGIN,
    SYSTEM_MENU,
    INITIATE_PRODUCT_FEEDBACK,
    FEEDBACK_STATUS,
    OKTACALLBACK,
    VALID_EMAIL,
    VALID_NUMERIC,
    PLEASE_UPLOAD_IMAGE,
    VALID_DATE,
    QUANTITY,
    EDIT,
    DELETE,
    LOT_SERIAL_NO,
    LOT_NUMBER_NOT_FOUND,
    SEARCHING_LOT_NUMBER,
    PRODUCT_CODE_NOT_FOUND,
    SEARCHING_PRODUCT_CODE,
    FILE_OF_TYPES_ARE_NOT_ALLOWED,
    THE_FILE_YOU_ARE_ATTEMPTING,
    IMAGE_ICON,
    LOGIN_TO_ACCOUNT,
    SIGN_IN_TO_YOUR_ACCOUNT,
    BAXTER_EMAIL_ADDRESS,
    PASSWORD,
    SIGN_IN,
    UNKNOWN,
    ASKED_UNKNOWN,
    DD_MMM_YYYY,
    DD,
    MMM,
    YYYY,
    SELECT_COUNTRY,
    CHINESE_SIMPLIFIED_CHINESE,
    DUTCH,
    ENGLISH,
    FRENCH,
    GERMAN,
    ITALIAN,
    JAPANESE,
    KOREAN,
    MANDARIN_TRADITIONAL_CHINESE,
    POLISH,
    PORTUGUESE,
    SPANISH,
    THAI,
    TURKISH,
    VIETNAMESE,
    BROWSE,
    FEEDBACK_SUBMITTED,
    YOUR_PRODUCT_EXPERIENCE_FEEDBACK,
    IF_YOU_HAVE_QUESTIONS_OR_ADDITIONAL_INFORMATION,
    CLOSE,
    PATIENT_AGE,
    ENTER_AGE,
    PATIENT_DOB,
    RELEVANT_ATTACHMENTS,
    BAXTER_ACCOUNT_CREDENTIALS,
    GET_PRODUCT_DETAILS,
    USE_THE_DIAGRAM_ABOVE_FIGURE_2,
    FACILITY_ADDRESS,
    LABEL_ANOTHER_FACILITY_ADDRESS,
    CHOOSE_PRODUCT_CODE,
    PRIVACY_NOTICE,
    DECLINE,
    OPTION_COUNTRYOPTIONS_BONAIRE_SINT_EUSTATIUS_AND_SABA,
    OPTION_COUNTRYOPTIONS_CURAÇAO,
    OPTION_COUNTRYOPTIONS_SOUTH_SUDAN,
    OPTION_COUNTRYOPTIONS_ESWATINI,
    FORM_HELP_TEXT,
    YOUR_FIRST_NAME,
    YOUR_LAST_NAME,
    MY_FIRST_NAME,
    MY_LAST_NAME,
    PATIENT_FIRST_NAME,
    PATIENT_LAST_NAME,
    REPORTER_FIRST_NAME,
    REPORTER_LAST_NAME,
    EMPLOYEE_FIRST_NAME,
    EMPLOYEE_LAST_NAME,
    END_USER_CUSTOMER_FIRST_NAME,
    END_USER_CUSTOMER_LAST_NAME,
    ADDITIONAL_CONTACT_FIRST_NAME,
    ADDITIONAL_CONTACT_LAST_NAME,
    COPYRIGHT_BAXTER,
    COPYRIGHT_VERSION,
    ADD_ADDITIONAL_CONTACT,
    CONTACT_ME,
    DO_NOT_CONTACT,
    END_USER_CUSTOMER_FACILITY_NAME,
    END_USER_CUSTOMER_PHONE,
    END_USER_CUSTOMER_EMAIL,
    END_USER_CUSTOMER_FACILITY_ADDRESS,
    SAME_AS_PATIENT_ADDRESS,
    SAME_AS_REPORTER_ADDRESS,
    SAME_AS_END_USER_CUSTOMER_ADDRESS,
    USE_THE_DIAGRAM_ABOVE_FIGURE_3,
    CONTACT_US,
    LANDING_BRIEF_FOR_DEVICE,
    PATIENT_SEX,
    OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_MAN_BOY,
    OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_WOMAN_GIRL,
    OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_MAN_TRANS_MAN_FEMALE_TO_MALE_FTM,
    OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_WOMAN_TRANS_WOMAN_MALE_TO_FEMALE_MTF,
    OPTION_PATIENTGENDEROPTIONS_CISGENDER_OTHER_GENDER_CATEGORY_PLEASE_SPECIFY,
    OPTION_PATIENTGENDEROPTIONS_CISGENDER_DECLINE_TO_ANSWER,
    ATTENTION_NEEDED,
    SUBMIT_ERR_MSG,
    SUBMIT_RETRY_MSG,
    OK,
} from '@translations';

let lang: any = {};
let translations: any = {};
lang.translations = translations;

translations[APP_TITLE] = "产品反馈门户";
translations[LANDING_BRIEF] = "百特产品线上反馈门户网站旨在提交有关百特产品的机密信息和相关反馈。";
translations[LANDING_LANGUAGE_SELECTOR] = "选择语言偏好";
translations[LANDING_COUNTRY_SELECTOR] = "选择活动国家/地区";
translations[LANDING_TERMS] = "我已阅读并同意百特产品反馈门户网站的使用条款和隐私声明。";
translations[LANDING_TERMS_ERROR] = "您必须阅读并同意百特产品反馈门户网站的使用条款、隐私声明和百特产品反馈门户补充使用条款和隐私声明的内容。";
translations[LANDING_CAPTCHA_ERROR] = "请确认你不是机器人。";
translations[APP_DESCRIPTION] = "百特产品线上反馈门户网站旨在提交产品相关信息。如果您遇到百特产品的任何问题，我们鼓励您分享该事件的细节。所有的反馈对我们实现不断提高产品和满意度的共同目标都是至关重要的。";
translations[LANDING_TERMS_I_HAVE_READ] = "我已阅读百特产品反馈门户的链接隐私声明，并了解百特医疗公司（“百特”）正在寻求我的同意，以便出于隐私声明中所述的目的和目的使用、披露和处理我的个人数据。我特此同意：";
translations[LANDING_TERMS_THE_USE_DISCLOSURE] = "出于隐私声明中列出的目的，使用、披露、存储和处理我的个人数据（包括我选择提供的任何敏感数据，例如健康相关数据）。";
translations[LANDING_TERMS_THE_TRANSFER_OF] = "将我的个人数据（包括敏感数据，例如我选择提供的健康相关数据）从我的国家转移到另一个可能不那么严格或没有数据保护法律的国家。";
translations[LANDING_TERMS_I_UNDERSTAND_THAT] = "我明白，这种同意是自愿的，我可以在任何时候改变主意，使用隐私声明中提供的联系方式联系百特，撤销我的同意。我明白，撤回我的同意不会影响撤回之前处理的合法性。";
translations[MENU_FEEDBACK_FORM] = "发起产品反馈";
translations[MENU_FEEDBACK_STATUS] = "查看产品反馈状态";
translations[MENU_FORM_INTAKE] = "报告人/联系信息";
translations[MENU_FORM_EVENT_DETAILS] = "事件详情";
translations[MENU_FORM_PRODUCT_INFO] = "产品信息";
translations[SYSTEM_FEEDBACK_FORM] = "发起产品反馈表";
translations[SYSTEM_FEEDBACK_STATUS] = "查看产品反馈状态";
translations[SUBMIT_FEEDBACK] = "点击此处提交反馈。";
translations[CHECK_SUBMITTED_FEEDBACK] = "点击此处查看之前提交的反馈状态。";
translations[BTN_LAUNCH_FORM] = "打开表格";
translations[BTN_CHECK_STATUS] = "检查状态";
translations[FORM_TITLE] = "产品反馈表";
translations[FORM_SUB_TITLE] = "如果涉及多名患者，请为每位患者填写一份表格。";
translations[FORM_MANDATORY_FIELDS] = "所有带 * 的字段均为必填字段";
translations[BUTTON_PREV] = "前一个";
translations[BUTTON_NEXT] = "下一个";
translations[BUTTON_SUBMIT] = "提交";
translations[SELECT_RESPONSE] = "选择回复";
translations[FUNCTION_ROLE] = "部门/职位";
translations[CUSTOMER_ACCOUNT_NUMBER] = "客户账号";
translations[ENTER_CUSTOMER_ACCOUNT] = "输入客户账户";
translations[HELP_CUSTOMER_ACCOUNT_NUMBER] = "报告事件中客户的百特账号";
translations[EVENT_REPORTED] = "此事件之前是否已经报告过（向百特或任何其他实体）？";
translations[REFERENCE_NUMBER] = "与此事件相关的参考编号";
translations[ENTER_REFERENCE] = "输入参考编号";
translations[WHO_REPORTED_TO] = "向谁报告了这件事？";
translations[WHO_WAS_NOTIFIED] = "提供被通报者的姓名";
translations[ENTER_NAME] = "输入姓名";
translations[PRODUCT_SURVEILLANCE] = "如果我们有其他问题，产品监控 /Baxter 可以联系您或其他人吗？";
translations[YOUR_NAME] = "你的名字";
translations[OCCUPATION] = "职业";
translations[PHONE_NUMBER] = "电话号码";
translations[ENTER_PHONE_NUMBER] = "输入电话号码";
translations[ENTER_EMAIL] = "输入邮件";
translations[EMAIL_ADDRESS] = "邮箱地址";
translations[ENTER_ADDRESS] = "输入邮件地址";
translations[ENTER_NA_IF_UNKNOWN] = "如果未知，请输入 NA";
translations[FACILITY_HOSPITAL] = "设施/医院或经销商名称（如果适用）";
translations[ENTER_FACILITY] = "输入医院名称";
translations[ADDRESS_1] = "地址1";
translations[ADDRESS_2] = "地址2";
translations[CITY] = "城市";
translations[STATE] = "州";
translations[POSTAL_CODE] = "邮政编码";
translations[COUNTRY] = "国家";
translations[END_USER_CUSTOMER] = "最终用户/客户是否发现了此问题？";
translations[ADDITIONAL_CONTACT_PERSON] = "其他联系人";
translations[ADDITIONAL_PHONE] = "其他联系电话号码";
translations[ADDITIONAL_EMAIL] = "其他联系人邮箱";
translations[ANOTHER_FACILITY_ADDRESS] = "添加其他设施/地址";
translations[ANOTHER_FACILITY_HOSPITAL] = "其他设施/医院或经销商名称（如果适用）";
translations[ANOTHER_ENTER_FACILITY] = "输入医院名称";
translations[ANOTHER_ADDRESS_1] = "地址1";
translations[ANOTHER_ADDRESS_2] = "地址2";
translations[ANOTHER_CITY] = "城市";
translations[ANOTHER_STATE] = "州";
translations[ANOTHER_POSTAL_CODE] = "邮政编码";
translations[ANOTHER_COUNTRY] = "国家";
translations[LOT_SERIAL_NUMBER] = "批号/序列号";
translations[ENTER_LOT_SERIAL_NUMBER] = "输入批号/序列号";
translations[HELP_LOT_SERIAL_NUMBER] = "如果您不知道批次/序列号，或者您询问报告者还无法得知，请选择 “未知”。";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_PRODUCT_CODE] = "产品代码";
translations[PRODUCT_CODE] = "产品代码";
translations[ENTER_PRODUCT_CODE] = "输入产品代码";
translations[HELP_PRODUCT_CODE] = "如果您不知道产品代码，或者您询问报告者还无法得知，请选择 “未知”。";
translations[NDC] = "国家药品代码 (NDC) 编号";
translations[ENTER_NDC] = "输入国家药品代码（NDC）";
translations[UDI] = "唯一设备标识符 (UDI)";
translations[ENTER_UDI] = "输入唯一设备标识符 (UDI)";
translations[PRODUCT_NAME] = "商品名称";
translations[ENTER_PRODUCT_NAME] = "输入产品名称";
translations[HELP_PRODUCT_NAME] = "提供商品的名称或描述";
translations[BEST_DESCRIBES] = "请做出最能描述报告问题的选择";
translations[QUANTITY_TO_SELECT] = "选择数量";
translations[ENTER_QUANTITY] = "输入数量";
translations[HELP_QUANTITY] = "问题产品的数量";
translations[UNIT] = "单位";
translations[AVAILABLE_TO_RETURNED] = "存在报告问题的实际商品是否可以退回 Baxter 进行评估？";
translations[PHOTOGRAPH_AVAILABLE] = "是否可提供产品的照片或视频？";
translations[HELP_PHOTOGRAPH_AVAILABLE] = "确保在照片或视频中可见报告的问题。";
translations[UPLOAD_IMAGES] = "上传图片";
translations[REPORTER_NAME] = "报告人姓名";
translations[REPORTER_FACILITY] = "报告人单位";
translations[REPORTER_OCCUPATION] = "报告人职业";
translations[ENTER_NUMBER] = "输入数字";
translations[REPORTER_PHONE_NUMBER] = "报告人电话号码";
translations[REPORTER_EMAIL_ADDRESS] = "报告人邮箱地址";
translations[EMPLOYEE_NAME] = "员工姓名";
translations[EMPLOYEE_PHONE_NUMBER] = "员工电话号码";
translations[EMPLOYEE_EMAIL_ADDRESS] = "员工邮箱地址";
translations[RETURNING_FOR_INVESTIGATION] = "您要返回多少个报告问题的样本（单位）进行调查？";
translations[HELP_RETURNING_FOR_INVESTIGATION] = "这些样品应该是有报告问题的商品。";
translations[UNUSED_BAXTER_PRODUCT] = "同一批次中有一款未使用的百特产品可以退回 Baxter 进行评估？";
translations[YOU_INDICATED_SAMPLES] = "您表示有样品可供评估，您能否将这些样品带给您的医疗保健提供者？";
translations[SAMPLE_RETURN_KIT] = "您表示样品可用于评估，请确认提供的地址以发送样品返回套件：";
translations[A_BOX_WITH_A_PREPAID_LABEL] = "带有预付费标签的箱子将被发送到该地址以退还样品";
translations[SAME_AS_MY_ADDRESS] = "与我的地址相同";
translations[OTHER_CONTACT_NAME] = "其他联系人的姓名";
translations[OTHER_CONTACT_OCCUPATION] = "其他联系人的职业";
translations[OTHER_CONTACT_PHONE_NUMBER] = "其他联系人的电话号码";
translations[OTHER_CONTACT_EMAIL_ADDRESS] = "其他联系人的邮箱地址";
translations[MANUFACTURED_BY_ANOTHER_COMPANY] = "您选择的产品由另一家公司制造，如果他们对您的报告有其他疑问，我们能否向他们提供您的联系信息？";
translations[CUSTOMER_EXPLICITLY_REQUEST] = "客户是否明确要求调查结果？";
translations[EXPLICITLY_REQUEST_CREDIT] = "客户是否明确要求退款？";
translations[PRODUCT_FROM_BAXTER] = "客户是否直接从百特订购产品？";
translations[QUANTITY_REQUESTED_CREDIT] = "申请退款的批号和数量：";
translations[ENTER_OCCUPATION] = "输入职业";
translations[LOT_QUANTITY_NUMBER] = "输入批号和数量";
translations[WHOLESALERS_NAME] = "经销商的名称和地点（城市、州）是什么";
translations[PLACE_WHOLESALERS_NAME] = "经销商的名称和地点（城市、州）是什么";
translations[ADD_PRODUCT_TO_THE_GRID] = "将产品添加到分类";
translations[SAVE] = "保存";
translations[CANCEL] = "取消";
translations[ADD_MORE_PRODUCTS] = "添加更多产品";
translations[REPORTER_ADDRESS] = "报告人地址";
translations[ATTACHMENTS] = "附件";
translations[DATE_OF_EVENT] = "事件发生日期";
translations[DATE_OF_EVENT_MSG] = "事件日期不能晚于第一次通知百特员工的日期。 请输入有效日期。";
translations[HELP_DATE_OF_EVENT] = "如果该事件涉及多个已知日期，请为每个日期填写表格。";
translations[DATE_BAXTER_EMPLOYEE] = "Baxter 员工首次收到通知的日期";
translations[DATE_MESSAGE_BAXTER_EMPLOYEE] = "(提供的日期不必與輸入資訊的日期相同。)";
translations[DURING_WHAT_PROCESS] = "事件在什么流程步骤中发生？";
translations[WAS_THE_PATIENT] = "事件发生时患者是否已连接（治疗正在进行中）？";
translations[WERE_YOU_CONNECTED] = "您在事件发生时是否已连接产品（正在进行治疗）？";
translations[PROVIDE_ANY_ADDITIONAL] = "提供与事件/问题相关的其他详细信息";
translations[HELP_YOU_IDENTIFIED_MORE] = "您报告了多个产品和问题，请说明各产品分别是什么问题？";
translations[ENTER_DETAILS] = "输入详情 ";
translations[PROVIDE_ANY_ATTACHMENT] = "提供任何适用的附件";
translations[WAS_NEGATIVE_MEDICAL] = "该事件是否会造成任何负面的医疗影响、症状或受伤？";
translations[WAS_MEDICAL_INTERVENTION] = "是否提供了治疗、医疗干预或护理升级来应对报告的事件？";
translations[PROVIDE_DETAILS] = "提供详情";
translations[REQUIRED_TREATMENT] = "需要的治疗/医疗干预";
translations[ENTER_TREATMENT] = "输入治疗";
translations[RELEVANT_TESTS] = "相关测试，包括实验室数据：";
translations[HELP_RELEVANT_TESTS] = "输入相关检验";
translations[RELEVANT_MEDICAL_HISTORY] = "相关病史，包括既往病史：";
translations[ENTER_HISTORY] = "输入病史";
translations[PATIENT_NAME] = "患者的姓名";
translations[PATIENT_INITIALS] = "患者姓名首字母或全名。如果涉及多名患者，请为每位患者填写一份表格。";
translations[PATIENT_PHONE_NUMBER] = "患者电话号码";
translations[I_DO_NOT_WISH_TO_PROVIDE] = "我不愿意提供";
translations[PATIENT_EMAIL_ADDRESS] = "患者的电子邮件";
translations[PATIENT_ADDRESS] = "患者地址";
translations[SAME_ADDRESS] = "相同地址";
translations[DRUG_BEING_USED] = "事件发生时是否使用了百特药物？";
translations[PATIENT_IDENTIFIER] = "患者编号";
translations[PATIENT_AGE_OR_DOB] = "患者年龄或出生日期";
translations[ENTER_PATIENT_AGE] = "月/日/年，输入患者年龄";
translations[PATIENT_GENDER] = "病人性別";
translations[PATIENT_WEIGHT] = "患者体重";
translations[ENTER_WEIGHT] = "输入体重";
translations[PATIENT_WEIGHT_UNIT] = "患者体重单位";
translations[MY_NAME] = "我的名字";
translations[ENTER_IN_YOUR_CONTACT] = "输入您的联系信息";
translations[MY_PHONE_NUMBER] = "我的电话号码";
translations[MY_EMAIL_ADDRESS] = "我的邮箱地址";
translations[MY_ADDRESS] = "我的地址";
translations[NAME_OF_BAXTER_DRUG] = "百特药物的名称";
translations[ENTER_DRUG_NAME] = "输入药品名称";
translations[PLEASE_PROVIDE_THE_NAME] = "请提供百特药物的名称或产品代码。提供报告问题时正在使用的所有百特药物的名称";
translations[SELECT_THE_COMPONENT] = "选择出现问题的组件";
translations[USE_THE_DIAGRAM] = "使用上图（图 1）确定损坏的一次性用品的位置。";
translations[TYPE_OF_DAMAGE] = "请描述损坏的类型";
translations[PLEASE_ENTER_VALUE] = "请输入值";
translations[WAS_THE_PRODUCT_KINKED] = "产品是否有扭结、破裂、打折、切割等？";
translations[WERE_ANY_CLEANING] = "产品上是否使用了清洁溶液、溶剂或消毒剂？";
translations[WHAT_WAS_THE_DISINFECTANT] = "消毒剂名称/品牌是什么？它是如何使用的？";
translations[NOTE_BAXTER_LABELING] = "使用这些产品会导致产品出现裂缝。百特标签声明，不适用漂白剂，过氧化氢，酒精或防腐剂含有酒精的消毒剂。 使用这些产品会导致产品出现裂缝。";
translations[SELECT_ALL_THAT_APPLY] = "选择所有适用的选项";
translations[DID_FOLLOWING_OCCUR] = "是否发生了以下任何情况？";
translations[SELECT_THE_LOCATION] = "选择迷你帽上有损坏的位置";
translations[WAS_THE_PRODUCT_EXPOSED] = "在问题发生之前，产品是否受过过度的冲击（例如，撞击、击中等）？";
translations[HOW_LONG_TRANSFER] = "输液短管已使用多久？";
translations[WAS_THERE_DIFFICULTY] = "打开或关闭旋转接头时是否有任何困难？";
translations[WAS_DEVICE_OR_TOOL] = "是否使用了用于打开或关闭旋转接头的装置或工具？";
translations[DESCRIBE_HOW_PRODUCT] = "描述商品如何难以使用（选择所有适用的选项）";
translations[DID_YOU_OBSERVE] = "您是否观察到产品有任何损坏（例如切口、孔、裂缝）？";
translations[WERE_DIFFICULTIES_PUTTING] = "将迷你帽放在输液短管上并顺时针旋转到牢固固定之前是否有任何困难？";
translations[WAS_THE_TRANSFER] = "是否因为此次事件而更换了输液短管？";
translations[SELECT_TYPE_OF_FLOW] = "选择输注问题的类型";
translations[WAS_ANYTHING_BLOCKING] = "是否有东西阻塞输注？";
translations[WAS_ANY_ALARM] = "有警报吗？";
translations[SELECT_BEST_DESCRIBE] = "选择最能描述问题的选项";
translations[WERE_THE_MINICAPS] = "迷你帽是否暴露或粗存再热/冷的环境中？";
translations[WAS_THE_SPONGE_VISIBLE] = "海绵在迷你帽内可见吗？";
translations[WHERE_PARTICULATE_MATTERFOREIGN] = "颗粒物/异物在哪里？";
translations[DESCRIBE_THE_EXACT_LOCATION] = "描述颗粒物/异物的确切位置、大小、形状和颜色：";
translations[WAS_THE_PARTICULATE_MATTER] = "产品中是否嵌入了颗粒物/异物？";
translations[DOES_THE_PARTICULATE_MATER] = "颗粒物/异物似乎是产品材料的碎片吗？";
translations[WHAT_COMPONENT_DOES] = "颗粒物似乎来自什么组成部分？";
translations[SELECT_CONNECTION_ISSUE] = "选择最能描述连接问题的选项";
translations[WERE_ASSIST_DEVICES] = "是否有任何辅助设备或工具用于进行一次性连接？";
translations[WERE_ANY_DIFFICULTIES] = "在初次连接过程中注意到任何困难还是断开连接？";
translations[PROVIDE_PRODUCT_INFORMATION] = "提供连接问题涉及的第二个产品的产品信息";
translations[WERE_THE_SPIKE_LUER] = "穿刺/鲁尔接头是否顺时针旋转直到牢固固定？";
translations[BAXTER_LABELING_STATES] = "Baxter 标签规定，在开始治疗之前，确保所有一次性套装连接都是安全和适合的。";
translations[WERE_PETS_OR_ANIMALS] = "是否有宠物或动物可能损坏了一次性套装？";
translations[BAXTER_LABELING_CONTAMINATION] = "Baxter 标签规定，如果宠物或动物咬一次性用品，可能会导致液体通道的污染。 为了降低这种风险，请勿与宠物或动物在同一房间进行透析。";
translations[WERE_OTHER_ISSUES] = "是否还有其他问题或困难与穿刺/鲁尔接头（例如裂纹、变形、弯曲等）相关的问题或困难？";
translations[WAS_MINICAP_TWISTED] = "迷你帽是否顺时针扭转到输液短管上，直到牢固固定？";
translations[WERE_DIFFICULTIES_TRANSFER_SET] = "将迷你帽放在输液短管上是否有任何困难？";
translations[DID_TRANSFER_SET_CONNECTORS] = "输液短管的螺纹上是否有任何可见的损坏或残留物？";
translations[WHAT_WAS_THE_ALARM] = "警报是什么？";
translations[WHERE_OBSERVED_DAMAGE] = "观察到的损坏在哪里（选择所有适用项）？";
translations[SELECT_THE_TYPE_OBSERVED] = "选择观察到的损坏类型（选择所有适用项）：";
translations[DID_DAMAGE_CAUSE_LEAK] = "损坏是否导致泄漏？";
translations[WAS_THE_SHIPPING_CARTON] = "装运纸箱是用尖锐物品打开的吗？";
translations[SELECT_FLOW_ISSUE_OBSERVED] = "选择观察到的输注问题类型";
translations[HOW_LONG_WAS_STORAGE] = "在找到过期产品之前存放多长时间？";
translations[WAS_THERE_AN_ADAPTER] = "是否有转接器或任何其他设备与产品一起使用？";
translations[NAME_AND_MODEL] = "转接器或使用的任何其他设备的名称和型号是什么？";
translations[NAME_VAPORIZER] = "喷雾器的名称和型号是什么？";
translations[WAS_VIAL_INVERTED] = "在将溶液挤入小瓶之前，小瓶是否倒置了？";
translations[WHAT_VIAL_USED] = "所用小瓶的产品信息是什么？";
translations[DRUG_NAME_MANUFACTURER] = "药品名称、制造商、药瓶大小";
translations[WERE_BREAK_FRANGIBLE] = "你能用来回挥舞的方式正确地打破易折部位吗?  ";
translations[WAS_ALARM_ASSOCIATED] = "是否有任何与无流速相关的警报？";
translations[WHAT_PART_DISCOLORED] = "产品的哪一部分被报告变色？ （选择所有适用的选项）";
translations[DESCRIBE_DISCOLORATION] = "描述变色（描述颜色、色调、色调、阴影等）：";
translations[HOW_PRODUCT_STORED] = "产品是如何存储的？";
translations[DOES_DISCOLORATION_APPEAR] = "变色是否看起来不透明、朦胧、阴天和/或有圆形/蜂蜜梳状标记？";
translations[WHICH_CHAMBER_DISCOLORED] = "袋上的哪个室腔变色了 ？";
translations[WAS_PEEL_SEAL_INTERCHAMBER] = "封条或腔室易撕物是否已经被破坏/撕去？";
translations[WAS_DISCOLORATION_NOTICED] = "是否通过喷雾器观察镜注意到变色？";
translations[SELECT_SPECIFICALLY_DESCRIBES] = "选择更具体描述问题的选项：";
translations[WHAT_DEVICE_HAD_ALARM] = "什么设备有警报？";
translations[WHAT_MISSING_MISASSEMBLED] = "什么组件丢失或组装错误？";
translations[RECONSTITUTION_ISSUE] = "提供混合问题的更具体描述";
translations[WHAT_MEDICATION_SOLUTION] = "该产品正在用什么药物/溶液混合？";
translations[WHAT_VOLUME_MEDICATION] = "用于混合的药物/溶液的量是多少？";
translations[WHAT_DEVICES_RECONSTITUTION] = "在混合过程中使用了哪些其他设备（名称/制造商、针尺寸/规格等）";
translations[WAS_PRODUCT_EXPOSED_HEAT] = "产品是否暴露在高温下？";
translations[DESCRIBE_EXPOSURE] = "描述暴露（温度、多长时间等）";
translations[WHAT_USED_ACTIVATE_SOLUTION] = "使用什么技术来混合溶液？";
translations[WAS_DAMAGE_OBSERVED] = "在混合之前产品是否收到任何损坏？";
translations[DESCRIBE_THE_DAMAGE] = "描述损坏：";
translations[APPROXIMATELY_SOLUTION_POWDER] = "大约有多少溶液或粉末被充满或过量填充？";
translations[WAS_LEAK_OBSERVED] = "有没有观察到泄漏？";
translations[WHAT_FEATUR_DIFFICULT_USE] = "产品的哪些组件或功能难以使用？";
translations[HOW_WAS_DIFFICULT_USE] = "该产品怎么难使用？";
translations[WHERE_MATTER_FOREIGN] = "颗粒物/异物在哪个位置？";
translations[DOES_PARTICULATE_MATTER] = "颗粒物/异物似乎是产品材质吗？";
translations[DESCRIBE_EXACT_LOCATION] = "描述颗粒物/异物的确切位置、颜色、大小、形状和纹理：";
translations[WAS_MATTER_FOREIGN] = "产品中是否嵌入了颗粒物/异物（不能自由移动）？";
translations[WHEN_MATTER_FOREIGN] = "什么时候观察到颗粒物/异物？";
translations[PROVIDE_INFORMATION_MEDICATION] = "提供添加的药物产品信息：";
translations[PRODUCT_NAME_CODE_NUMBER] = "产品名称、产品编码、产品批号、品牌名";
translations[DESCRIBE_SPIKING] = "描述使用的穿刺或混合技术：";
translations[INCLUDE_NEEDLE] = "包括针尺寸/规格、尖刺/穿孔角度、尝试次数";
translations[WHAT_ADMINISTRATION_RECONSTITUTION] = "使用了什么方式给药或混合设备？";
translations[INCLUDE_MANUFACTURER] = "包括制造商、产品名称、产品编码、产品批次";
translations[WAS_MEDICATION_ADDITIVE] = "产品中是否添加了药物、添加剂或混合溶液？";
translations[WHAT_MEDICATION_ADDITIVE] = "添加了哪些药物、添加剂或混合溶液？";
translations[WHAT_STATE_OF_PRODUCT] = "观察到浑浊/沉淀物时，产品的状态如何？";
translations[AFTER_UNITS_SAT] = "在产品放置并达到室温后，浑浊/沉淀消失了吗?  ";
translations[DID_ATTEMPT_AGITATE] = "您是否试图混合产品？";
translations[DID_PRECIPITATE_DISSOLVE] = "沉淀物溶解了吗？";
translations[WHAT_STORAGE_TEMPERATURE] = "产品储存温度和条件是多少？";
translations[PROVIDE_TEMPERATURE_LOCATION] = "提供温度、位置、储存在包装袋/纸箱内外、VSC/中间纸箱、单个商品";
translations[ARE_TEMPERATURE_LOGS] = "存放产品的冷藏环境是否有温度记录？";
translations[LOGS_CAN_BE_ATTACHED] = "机器记录日志可以直接附加到此表格（如果在提交时可用）";
translations[IS_THE_STORAGE_UNIT] = "存放设备（冷藏室或冰箱）是否已校准和温度控制？";
translations[HOW_PRODUCT_THAWED] = "产品是怎么解冻的？";
translations[WHAT_STORAGE_CONDITIONS] = "产品的储存条件是什么？ （温度、位置、存放在包装袋/纸箱内外）";
translations[WAS_ANY_DAMAGE] = "是否观察到产品损坏或问题？";
translations[MORE_SPECIFIC_INFORMATION] = "请提供更具体的信息：";
translations[WHAT_PURPOSE_INDICATION] = "患者的治疗目的/适应症是什么？";
translations[WHAT_ROUTE_ADMINISTRATION] = "执行方式是什么？";
translations[WHAT_DATE_ADMINISTRATION] = "执行方式和持续时间是什么时候？";
translations[WHAT_DOSAGE_STRENGTH] = "给患者的剂量/强度是多少？";
translations[WAS_RECENT_PRESCRIPTION] = "最近有处方变更吗？";
translations[WHAT_WAS_STORAGE_TEMPERATURE] = "产品的储存/温度细节是多少（存储位置/冰箱/冰柜等）？";
translations[WERE_ANY_ADJUSTMENTS] = "在给药之前对溶液或添加剂进行了任何调整吗？";
translations[SELECT_APPROPRIATE_DESCRIPTION] = "选择问题的最合适描述：";
translations[SELECT_LABELING_ISSUE] = "选择标签问题的最合适描述：";
translations[WAS_CONNECTION_SECURE] = "连接是否安全且完全收紧？";
translations[WAS_EXPIRED_PRODUCT] = "过期的产品是否向患者使用？";
translations[WAS_COMPONENT_DAMAGED] = "有任何组件损坏吗？";
translations[WERE_ABNORMALITIES_DAMAGE] = "产品是否注意到任何异常/损坏？";
translations[WHAT_PURCHASE_ORDER_NUMBER] = "你的采购订单编号是多少？";
translations[WHAT_DATE_OF_ADMINISTRATION] = "执行日期是什么时候？";
translations[WHAT_WAS_EXPIRATION_DATE] = "产品的失效日期是什么时候？";
translations[DESCRIBE_WAS_INCORRECT] = "描述标签上的内容不正确、不完整、缺失、难以辨认或标签上的内容太相似（与其他产品）：";
translations[WHAT_SCANNER_USED] = "使用了什么类型的扫描仪？";
translations[WAS_OVERPOUCH_POUCH] = "扫描时产品是否仍在外袋/袋中？";
translations[WHAT_BACKGROUND_COLOR] = "扫描时的背景颜色是什么？";
translations[DO_ALL_OF_THE_LABELS] = "所有标签（产品、箱子/纸箱、配送/配送）是否都具有相同的产品信息？";
translations[PRODUCT_INFORMATION] = "产品信息";
translations[IS_A_BARCODE_SCANNER] = "你的设施是否使用条形码扫描器？";
translations[HOW_ARE_THESE_PRODUCTS] = "这些产品是如何存储在设施中的？";
translations[WHAT_INFORMATION_INCORRECTLY] = "扫描时哪些信息显示错误？";
translations[WAS_THERE_LEAK] = "是否观察到泄漏或湿气？";
translations[WHERE_LEAK_OBSERVED] = "泄漏在哪里观察到，什么组件泄漏了？";
translations[WAS_FRANGIBLE_OBSERVED] = "观察到易碎物已破损了吗？";
translations[IS_MOISTURE_CLEAR] = "水份透明吗？";
translations[WHO_IS_YOUR_DISTRIBUTOR] = "谁是你的经销商？";
translations[WHAT_MANUFACTURER_MEDICATION] = "制造商、药物名称和使用的小瓶大小是多少？";
translations[WHAT_GAUGE_NEEDLE] = "使用的穿刺针、制造商以及现场被刺穿的次数是多少？";
translations[WHAT_ADMINISTRATION_SET] = "使用了什么执行工具？";
translations[WAS_DIFFICULTY_SPIKING] = "穿刺有困难吗？";
translations[WERE_FOLLOWING_SCENARIOS] = "泄漏是否出现以下任何情况？";
translations[WAS_FRANGIBLE_OBSERVED_DEFECT] = "被观察到易碎物有损坏还是有缺陷？";
translations[WHAT_AMOUNT_PRESSURE] = "施加了多少压力，持续时间是多少？";
translations[WAS_BAG_COMPLETELY] = "袋子是否完全正确地插入压力袖带中（是压力袖带之外的一端）？";
translations[WHAT_MANUFACTURER_MODEL] = "压力袖的制造商、型号和尺寸是什么？";
translations[WHAT_PRESSURE_PRIOR] = "检测到泄漏之前的压力是多少？";
translations[LIST_THE_VAPORIZER] = "列出喷雾器制造商和名称/型号";
translations[APPROXIMATELY_HOW_MUCH] = "大约溢出了多少液体？";
translations[WAS_THE_BOTTLE_DIFFICULT] = "瓶子难以插入喷雾器吗？";
translations[WERE_VISIBLE_DEFECTS] = "有任何明显的缺陷吗？";
translations[SELECT_THE_OPTION] = "选择最能描述连接问题的选项";
translations[PROVIDE_INVOLVED_CONNECTION_ISSUE] = "提供连接问题涉及的第二个产品的产品信息";
translations[WHICH_PART_SEPARATED] = "产品的哪些部分分离？";
translations[WHAT_COMPONENT_DISCOLORED] = "什么组件变色？";
translations[SELECT_DESCRIBES_DISCOLORATION] = "选择最能描述变色的选项：";
translations[WAS_THE_SET_DISCOLORED] = "从外包装取出套装后，套装是否变色？";
translations[DID_SET_CHANGE_COLOR] = "添加药物后，套装有变色吗？";
translations[WHAT_MEDICATION_ADDED] = "在颜色变化之前添加了什么药物？";
translations[WHERE_MATERIAL_LOCATED] = "颗粒物/异物在哪里？";
translations[DESCRIBE_APPEARANCE_COLOR_SIZE] = "描述颗粒物/异物（外观/颜色/尺寸）：";
translations[WAS_EMBEDDED_PLASTIC] = "颗粒物/异物是松动还是嵌入在塑料中？";
translations[WAS_THERE_A_PRECIPITATE] = "输液/溶液是否有未预期的沉淀或颜色变化？";
translations[WHAT_MEDICATIONS_SOLUTIONS] = "通过该套装注入了哪些药物/溶液？";
translations[WHERE_DAMAGE_COMPONENT_AFFECTED] = "损坏在哪里或哪些组件受到影响（选择所有适用的选项）？";
translations[WHAT_DAMAGE_ISSUE] = "观察到什么类型的损坏/问题（选择所有适用的选项）？";
translations[DID_ISSUE_RESULT] = "这个问题是否导致泄漏？";
translations[WAS_PATIENT_CONNECTED] = "病人是否已连接到产品？";
translations[WAS_PRODUCT_REPLACED] = "该产品是否被新产品替换了？";
translations[WHICH_SITUATION_BEST] = "哪种情况最能描述分离/连接问题";
translations[SELECT_MOST_LABELING_ISSUE] = "选择标签问题的最合适描述：";
translations[WHAT_INFORMATION_DISPLAYED] = "显示了什么信息？";
translations[WHAT_SCANNER_WAS_USED] = "使用了什么类型的扫描仪？";
translations[INCLUDE_THE_MODEL_NAME] = "包括型号名称";
translations[WAS_PRODUCT_ORDERED] = "该产品是直接从百特还是其他经销商订购的？";
translations[WHERE_LEAK_COMING] = "泄漏来自哪里（选择所有适用项）？";
translations[DID_SCENARIOS_OCCURRED_LEAK] = "泄漏是否发生了以下任何情况？";
translations[WAS_POWER_INJECTOR] = "该产品是否与加压输注器一起使用？";
translations[WHAT_INJECTOR_USED] = "使用了什么加压输注器？";
translations[MANUFACTURER_NAME_CODE_LOT] = "制造商、产品名称、产品编码、产品批次";
translations[DESCRIBE_INCORRECT_INCOMPLETE] = "描述标签上的内容不正确、不完整、缺失、难以辨认或更改的内容：";
translations[PROVIDE_INFORMATION_SECOND_PRODUCT] = "提供涉及断开连接的第二个产品的产品信息";
translations[WHICH_COMPONENTS_WERE_FOUND] = "发现哪些组件有裂纹或破裂？";
translations[DESCRIBE_CUT_HOLE_SLICE] = "描述有切口、孔或削的确切位置：";
translations[WAS_LEAK_ORIGINATING] = "是否从注射口泄露？";
translations[PROVIDE_DISCONNECTION_CONNECTION] = "提供与断开连接/连接问题的第二个产品的产品的产品信息";
translations[WHICH_SPECIFIC_BONDED] = "哪些特别的粘合的部件被分离？";
translations[WERE_VISIBLE_IRREGULARITIES] = "所涉及的产品/组件是否存在明显的不规则/损坏";
translations[WAS_SUCCESSFUL_CONNECTION] = "是否成功的连接或断开连接(未替换产品)?  ";
translations[WAS_TOOL_USED_ASSIST] = "是否使用协助连接/断开连接的工具？";
translations[WERE_LUER_CONNECTIONS] = "是否检查了所有鲁尔连接以确保它们在使用前的安全性（每个包装）";
translations[WAS_PRODUCT_SECURELY] = "在断开连接之前，商品是否已与其他产品安全地连接？";
translations[WHICH_DESCRIBES_FLOW_ISSUE] = "哪种情况最能描述输注问题？";
translations[WHAT_FLOWING_BACKWARDS] = "什么在逆流？";
translations[DESCRIBE_COMPONENTS_BACKFLOW] = "描述从逆流开始到停止的地方的组件：";
translations[DO_SITUATIONS_APPLY] = "这些情况中的任何情况是否适用于此事件？";
translations[WHICH_SPECIFIC_AREA] = "套组或组件的那个特定部位与输注问题相关？";
translations[WAS_FLOW_PREVIOUSLY_SEEN] = "之前是否可以通过套组或组件观察到流动？";
translations[WAS_ANY_FOLLOWING_OBSERVED] = "是否观察到以下任何一种情况：";
translations[WHERE_SIMULTANEOUS_FLOW] = "哪里同时流动?";
translations[WHAT_TYPE_HANGER] = "使用了什么类型的挂钩？ ";
translations[WHAT_WAS_HANGER_LENGTH] = "挂钩长度和/或制造商是？";
translations[WHICH_BAG_LOWER] = "哪个袋子比较低？";
translations[WHAT_Y_SITE_WAS] = "使用套组连接到哪个Y接头？";
translations[WHAT_COMPONENT_WITHIN] = "套装中的哪个组成部分无法清除溶液或血液？";
translations[WAS_COMPONENT_SET_REPLACED] = "无法清除后，组件/套件是否已更换？";
translations[WHAT_VOLUME_FLUID_PERIOD_TIME] = "要注入给患者的液体量和规定的时间段是多少？";
translations[WHAT_VOLUME_FLUID_OVER_TIME] = "在什么时间段内，患者实际注入的液体量是多少？";
translations[WAS_USED_WITH_PUMP] = "该套装与泵一起使用了吗？";
translations[DID_CLAMP_FAIL] = "管夹是否无法停止或控制流量？";
translations[WHAT_CLAMP_FAILED] = "什么管夹有问题？";
translations[WAS_ISSUES_OBSERVED_CLAMP] = "管夹有没有观察到任何问题？";
translations[DO_OTHER_SITUATIONS_DESCRIBE] = "其他情况中是否有任何描述产品问题（选择所有适用的选项）？";
translations[DESCRIBE_ALARM_OBSERVED] = "描述观察到的警报：";
translations[INCLUDE_ANY_MESSAGES] = "包括与警报相关的任何消息和错误代码";
translations[WHICH_CLAMP_HAD_ISSUE] = "哪个管夹有问题？";
translations[WHICH_TYPE_CLAMP_ISSUE] = "遇到了哪种类型的管夹问题（选择所有适用的选项）？";
translations[SELECT_BEST_DESCRIBES_ISSUE] = "选择最能描述问题的叙述：";
translations[PROVIDE_MORE_DETAILS] = "提供有关产品难以使用的更多详细信息：";
translations[PROVIDE_MORE_DETAILS_INSTRUCTIONS] = "提供有关难以遵循/理解的说明的更多详细信息：";
translations[DESCRIBE_THE_SMELL] = "描述气味以及它来自哪里：";
translations[WAS_ISSUES_WITH_SET] = "该套装有没有观察到任何问题？";
translations[WHERE_LEAK_LOCATED] = "泄漏在产品上的哪里？";
translations[DID_OCCUR_WITH_LEAK] = "泄漏是否发生了以下任何情况？";
translations[PROVIDE_INVOLVED_DISCONNECTION] = "提供涉及断开连接的第二个产品的产品信息";
translations[DID_OCCURRED_WITH_THE_LEAK] = "泄漏是否发生了以下任何情况？";
translations[WHERE_WAS_PRODUCT_DAMAGED] = "产品损坏在哪里？";
translations[SELECT_ALL_APPLY] = "选择所有适用的选项";
translations[DESCRIBE_OBSERVED_DAMAGE] = "描述观察到的损坏";
translations[WHAT_COMPONENT_IS_DISCOLORED] = "产品的哪个部分变色了？";
translations[DESCRIBE_HUE_TINT_SHADE] = "描述观察到的颜色（色调、色调、阴影等）：";
translations[INSIDE_OUTSIDE_OVERPOUCH] = "外包装袋的内/外部、温度、光照等";
translations[DESCRIBE_EXACT_LOCATION_SIZE] = "描述颗粒物/异物的确切位置、大小、形状和颜色：";
translations[DOES_THE_PARTICULATE_MATTER] = "颗粒物/异物似乎是产品材料吗？";
translations[WAS_PARTICULATE_MATERIAL_EMBEDDED] = "是否嵌入了颗粒物/异物？";
translations[DOES_APPEAR_PRODUCT_MATERIAL] = "颗粒物/异物似乎是产品材料的碎片吗？";
translations[WHERE_DID_THE_ISSUE_OCCUR] = "问题发生在产品上的哪里？";
translations[LIST_COMPONENTS_IF] = "列出组件。 如果涉及第二个产品，请提供制造商、产品名称、产品编码、产品批次";
translations[WERE_THERE_VISIBLE_IRREGULARITIES] = "是否观察到任何明显的异常/损坏情况？";
translations[SELECT_OPTION_FLOW_ISSUE] = "选择最能描述输注问题的选项";
translations[DESCRIBE_IRREGULARITIES] = "描述异常/损坏以及是否在连接/断开之前观察到损坏，还是在连接/断开连接期间发生了损坏";
translations[HOW_PRODUCT_SETUP] = "产品如何设置？";
translations[SELECT_MOST_APPROPRIATE_DESCRIPTION] = "选择标签问题的最合适描述：";
translations[DESCRIBE_WHAT_INCORRECT_INCOMPLETE] = "描述标签上的内容不正确、不完整、缺失、难以辨认或标签上的内容太相似（与其他产品）：";
translations[WAS_SHIPPING_CARTON_DAMAGED] = "运输纸箱内的产品是否损坏了？";
translations[WHAT_PRODUCT_WAS_SUPPOSED] = "应该收到什么产品？";
translations[IF_PRODUCT_CODE_NOT] = "如果商品编码不可用，请提供产品描述";
translations[WAS_THE_CASE_MISSING] = "箱子是否缺少干冰还是冷藏凝包？";
translations[WHAT_CARRIER_DELIVERED] = "哪家物流商运输了您的产品？";
translations[WHAT_IS_PURCHASE_ORDER_NUMBER] = "采购订单编号是多少？";
translations[WHAT_QUANTITY_MISSING_UNITS] = "短少的产品数量是多少？";
translations[WAS_EXPIRED_PRODUCT_USE] = "是否使用过期产品？";
translations[APPLY_TO_EACH_UNIT] = "如果此问题发生在多个单位产品，则以下问题适用于每个单位产品。";
translations[TERMS_CONDITIONS] = "条款和条件";
translations[PRIVACY_POLICY] = "隐私政策";
translations[PRIVACY_NOTICE] = "隐私声明";
translations[COOKIE_POLICY] = " Cookie 政策";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_ASKED_UNKNOWN] = "询问后但未知";
translations[OPTION_FUNCTIONOPTIONS_BAXTER_EMPLOYEE] = "百特员工";
translations[OPTION_FUNCTIONOPTIONS_CAREGIVER] = "护理者";
translations[OPTION_FUNCTIONOPTIONS_DISTRIBUTOR] = "经销商";
translations[OPTION_FUNCTIONOPTIONS_HEALTHCARE_PROFESSIONAL] = "医疗保健专业人员";
translations[OPTION_FUNCTIONOPTIONS_PATIENT] = "患者";
translations[OPTION_FUNCTIONOPTIONS_OTHER] = "其他";
translations[OPTION_PROCESSSTEPOPTIONS_AFTER_USE] = "使用后";
translations[OPTION_PROCESSSTEPOPTIONS_BEFORE_USE] = "使用前";
translations[OPTION_PROCESSSTEPOPTIONS_DURING_SETUP_PREPARATION] = "设定中/准备中/调配中";
translations[OPTION_PROCESSSTEPOPTIONS_DURING_THERAPY] = "治疗中";
translations[OPTION_PROCESSSTEPOPTIONS_MULTIPLE_STEPS] = "多个使用阶段";
translations[OPTION_PROCESSSTEPOPTIONS_NOT_SPECIFIED] = "未确认";
translations[OPTION_OCCUPATIONOPTIONS_FAMILY_MEMBER] = "家庭成员";
translations[OPTION_OCCUPATIONOPTIONS_NURSE] = "护士";
translations[OPTION_OCCUPATIONOPTIONS_NURSE_PRACTITIONER] = "专科护士";
translations[OPTION_OCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL] = "其他医疗保健专业人员";
translations[OPTION_OCCUPATIONOPTIONS_PHYSICIAN] = "医师";
translations[OPTION_UNITOPTIONS_BOXES] = "箱";
translations[OPTION_UNITOPTIONS_PALLETS] = "托盘";
translations[OPTION_UNITOPTIONS_UNITS] = "单位";
translations[OPTION_PROBLEMOPTIONS_ALARM_CONDITION] = "报警";
translations[OPTION_PROBLEMOPTIONS_DAMAGE] = "破损";
translations[OPTION_PROBLEMOPTIONS_DIFFICULT_TO_USE] = "难以使用";
translations[OPTION_PROBLEMOPTIONS_DISCOLORED] = "变色";
translations[OPTION_PROBLEMOPTIONS_FLOW_ISSUES] = "流量问题";
translations[OPTION_PROBLEMOPTIONS_LABELING_ISSUES] = "标签问题";
translations[OPTION_PROBLEMOPTIONS_LEAK_EXCESSIVE_MOISTURE] = "泄漏/过多水分";
translations[OPTION_PROBLEMOPTIONS_PARTICULATE_MATTER_FOREIGN_MATERIAL] = "颗粒物/异物质";
translations[OPTION_PROBLEMOPTIONS_PATIENT_REACTION_ADVERSE_EVENT] = "患者反应/不良事件";
translations[OPTION_PROBLEMOPTIONS_PRODUCT_INQUIRY] = "产品查询";
translations[OPTION_PROBLEMOPTIONS_SEPARATION_CONNECTION] = "分离/连接";
translations[OPTION_PROBLEMOPTIONS_SHIPPING_ISSUES_EXPIRED_PRODUCT] = "运输问题/过期产品";
translations[OPTION_PATIENTSEXOPTIONS_FEMALE] = "女性";
translations[OPTION_PATIENTSEXOPTIONS_UNDIFFERENTIATE] = "未区分";
translations[OPTION_PATIENTSEXOPTIONS_MALE] = "男性";
translations[OPTION_PATIENTSEXOPTIONS_DECLINETOANSWER] = "拒绝回答";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_ADMINISTRATOR_SUPERVISOR] = "行政人员/主管";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_BIOMEDICAL_ENGINEER] = "生物医学工程师";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_COMPANY_REPRESENTATIVE] = "公司代表";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_DENTIST] = "牙医";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_DISTRIBUTOR] = "经销商";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_FAMILY_MEMBER] = "家庭成员";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_LAY_USER] = "使用者";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_NURSE] = "护士";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_NURSE_PRACTITIONER] = "专科护士";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL] = "其他医疗保健专业人员";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACIST] = "药剂师";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACY_TECHNICIAN] = "药品技师";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHYSICIAN] = "医师";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PATIENT] = "患者";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_RISK_MANAGER] = "风险经理";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_OTHER] = "其他";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ADDITIONAL_CONTACT_PERSON] = "联系其他联系人";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ME] = "联系我";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_OTHER] = "联系其他人";
translations[OPTION_REPORTEDTOOPTIONS_BAXTER] = "百特";
translations[OPTION_REPORTEDTOOPTIONS_CHINA_FDA] = "中国食品及药物管理局";
translations[OPTION_REPORTEDTOOPTIONS_EMA] = "欧洲药品管理局";
translations[OPTION_REPORTEDTOOPTIONS_FDA] = "美国食品及药物管理局";
translations[OPTION_REPORTEDTOOPTIONS_HEALTH_CANADA] = "卫生部";
translations[OPTION_REPORTEDTOOPTIONS_PMDA_JAPAN] = "日本药品和医疗器械管理局";
translations[OPTION_REPORTEDTOOPTIONS_TUV] = "德国技术监督协会";
translations[OPTION_REPORTEDTOOPTIONS_TGA_AUSTRALIA] = "澳大利亚药品管理局";
translations[OPTION_FOLLOWINGOCCUROPTIONS_A_PET_OR_ANIMAL] = "宠物或动物可能导致了这个问题";
translations[OPTION_FOLLOWINGOCCUROPTIONS_A_SHARP_OBJECT] = "锋利的物品或工具被用来打开纸箱或外袋";
translations[OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_PROBLEM_OCCURRED] = "问题发生之前产品暴露或储存在热/冷环境中";
translations[OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_COLD_ENVIRONMENT] = "商品暴露或储存在热/冷环境中。";
translations[OPTION_DAMAGEMINICAPOPTIONS_CARTON] = "纸箱";
translations[OPTION_DAMAGEMINICAPOPTIONS_MINICAP] = "碘伏帽";
translations[OPTION_DAMAGEMINICAPOPTIONS_POUCH] = "袋";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_TIGHT] = "外接短管太紧";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_LOOSE] = "外接短管太松";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_CLOSE] = "外接短管无法完全关闭";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_OPEN] = "外接短管无法完全打开";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_CLAMP_OPEN] = "开关太紧致于外接短管根本无法打开";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_LAMP_CLOSE] = "开关太紧致于外接短管没有能够完全关闭";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THERE_WAS_DAMAGE] = "是的-由于外接短管无法正常关闭，存在损坏/异常";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THE_MINICAP] = "是的-碘伏帽已被用手或使用工具/辅助设备过分旋紧";
translations[OPTION_FLOWISSUEOPTIONS_COMPLETELY_STOPPED] = "完全停止，没有液体流动";
translations[OPTION_FLOWISSUEOPTIONS_RESTRICTED_OR_PARTIALLY] = "受限或部分流动（缓慢流动）";
translations[OPTION_BLOCKINGFLOWOPTIONS_CLOTTED_BLOOD] = "凝血";
translations[OPTION_BLOCKINGFLOWOPTIONS_FIBRIN] = "纤维蛋白";
translations[OPTION_BLOCKINGFLOWOPTIONS_KINK] = "扭结";
translations[OPTION_BLOCKINGFLOWOPTIONS_PARTICULATE] = "颗粒";
translations[OPTION_BLOCKINGFLOWOPTIONS_PRODUCT_MATERIAL] = "产品材料";
translations[OPTION_DESCRIBEISSUEOPTIONS_EXCESS_IODINE] = "连接时或包装中识别出的过量碘（棕色）";
translations[OPTION_DESCRIBEISSUEOPTIONS_EXCESS_MOISTURE] = "包装中识别出的过量水分（透明液滴）";
translations[OPTION_DESCRIBEISSUEOPTIONS_FOIL_POUCH] = "箔袋在打开包装前损坏";
translations[OPTION_DESCRIBEISSUEOPTIONS_PACKAGE_BOX] = "在使用前发现包装/箱子打开或损坏";
translations[OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_AND_WHITE] = "海绵干燥并且是白色的";
translations[OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_BROWNISH_COLOR] = "海绵干燥并且是棕色的";
translations[OPTION_MATERIALLOCATEDOPTIONS_IN_THE_SECONDARY] = "在二次包装/外袋内";
translations[OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_PRODUCT_FLUID] = "商品内部/流体路径";
translations[OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "装运纸箱内";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT] = "商品外部";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_OVERPOUCH] = "二次包装/外袋外";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_EXTERIOR] = "装运纸箱外部";
translations[OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING] = "将商品与其他商品连接困难";
translations[OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING] = "将商品与另一个产品断开连接困难";
translations[OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "单个商品中的组件分离";
translations[OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "将产品与另一种商品断开";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_RESIDUE] = "是 - 螺纹上的残留物";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_VISIBLE] = "是 - 可见损坏";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_OTHER] = "是-其他（请输入）";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_FRANGIBLE] = "易折接头";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_HANGER_HOLE] = "挂钩孔";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_INJECTION_FILLING_PORT] = "注射/灌装端口";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_MEMBRANE_PORT] = "膜端口";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_OVERPOUCH_POUCH] = "外层包装 /包装  ";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_PATCH] = "片";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_RUBBER_STOPPER] = "橡胶塞";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SHIPPING_CARTON] = "运输纸箱";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SHRINKBAND] = "收缩带";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SOLUTION_CONTAINER] = "液体容器";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_TIP_PROTECTOR] = "末端保护套";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_TAMPER_EVIDENT_SEAL] = "防拆标识（收缩包装）";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BENT] = "弯曲";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BROKEN] = "破碎的";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CRACKED] = "破裂";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CUT] = "切";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_DEFORMED] = "变形";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_FLAKING] = "剥落";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_HOLE] = "洞";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_KINKED] = "扭结";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_MELTED] = "融化了";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_PATCH_LAYER_SEPARATION] = "片层分离";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SHATTERED_GLASS] = "粉碎(玻璃)";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SLICED] = "切片";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_TORN] = "撕裂";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_NOT_FLOW] = "液体根本不会流动";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_FLOW] = "液体的流动速度非常缓慢";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_COMPOUNDING] = "液体在混合过程中不会流动（或缓慢流动）";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_BOTTLE] = "瓶";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_CONTAINER] = "容器";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_HANGER_HOLE] = "挂钩孔";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_LINER] = "张";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OVERPOUCH_POUCH] = "外层包装 /包装  ";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OXYGEN_INDICATOR] = "氧气指示剂";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_PATCH] = "片";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_PORTS] = "端口";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_SOLUTION] = "药水";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_TIP_PROTECTOR] = "末端保护套";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_AMINO_ACID_CHAMBER] = "氨基酸室";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_DEXTROSE_CHAMBER] = "葡萄糖室";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_LIPID_CHAMBER] = "脂室";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_LOWER_CHAMBER] = "下室";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_UPPER_CHAMBER] = "上室";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_BURST_RUPTURED_SEAL] = "爆裂/破裂密封";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISASSEMBLED_PRODUCT_PART] = "错误组装商品/零件";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISSING_COMPONENT] = "缺少组件";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_SEPARATION_DISCONNECTION_OF] = "分离/粘结的组件断开";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_OVER_FILLED] = "产品过量填充";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_UNDER_FILLED] = "产品填充不足";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_RECONSTITUTION] = "混合问题";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_IN_THE_SECONDARY] = "在二次包装/外包装的里面";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_SHIPPING] = "在运输纸箱内";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_EXTERIOR] = "在运输纸箱的外部";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_SOLUTION] = "内部药水/液体路径";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_VAPORIZER] = "汽化器底壳内部(视镜)";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_XTERNAL_SURFACE] = "产品外表面";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OUTSIDE] = "在二次包装/外包装的外面";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OXYGEN] = "在氧气吸附包";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_TRANSDERMAL] = "在透皮贴剂上";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_FRANGIBLE] = "易折接头";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_GLASS_PARTICLES] = "玻璃颗粒";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_PORT] = "加药口";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_RUBBER_STOPPER] = "橡胶塞";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_TUBING] = "管路";
translations[OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_ADDING_ANOTHER] = "添加另一种药物或混合后（小瓶）";
translations[OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_PRIOR_TO_SPIKING] = "在穿刺和混合之前";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_COLD_THAWED] = "低温（解冻但还没有到达室温）";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_FROZEN] = "冷冻";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_PARTIALLY_THAWED] = "部分解冻（溶液中的冰晶）";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_ROOM_TEMPERATURE] = "室温";
translations[OPTION_PRODUCTTHAWEDOPTIONS_BAXTER_THAWING] = "百特回温装置（BTU）";
translations[OPTION_PRODUCTTHAWEDOPTIONS_LEFT_ON_COUNTER] = "室温回温";
translations[OPTION_PRODUCTTHAWEDOPTIONS_REFRIGERATOR] = "冰箱";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_EVIDENCE] = "是-运输过程中有损坏的痕迹";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_LEAK_OBSERVED] = "是-观察到泄漏";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_HOLE_OR_INCOMPLETE] = "是的-封口中有一个洞或密封不完整";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_SPIKING] = "是的-刺破或混合有困难";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_BREAKING] = "是的-打破易折接头有困难";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CRYSTALLIZATION] = "是的-存在结晶或沉淀的溶液";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CLOUDINESS] = "是的-在Frozen Galaxy 产品中有浑浊/沉淀物";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_PRODUCT_DID_NOT] = "产品未提供预期效果或无效（缺乏效果）";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_UNINTENDED_EFFECT] = "非预期影响/反应。 请注明：（请输入）";
translations[OPTION_SCENARIOSLEAKOPTIONS_OPTION_APPROPRIATEDESCRIPTIONOPTIONS_DAMAGED_SHIPPING] = "运输过程中损坏的包装箱";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "配送过期商品";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_FOUND] = "发现过期产品";
translations[OPTION_LABELINGISSUEOPTIONS_BARCODE_ISSUE] = "条形码问题-扫描时显示的信息不正确";
translations[OPTION_LABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "条形码扫描困难/无法扫描";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "配送过期产品";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_INVENTORY] = "在库存中发现过期产品";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_ILLEGIBLE_LABEL] = "字迹模糊的标签";
translations[OPTION_LABELINGISSUEOPTIONS_INCORRECT_LABEL] = "不正确的标签";
translations[OPTION_LABELINGISSUEOPTIONS_INCOMPLETE_LABEL] = "不完整的标签";
translations[OPTION_LABELINGISSUEOPTIONS_ILABEL_TOO_SIMILAR] = "标签与其他产品过于相似";
translations[OPTION_LABELINGISSUEOPTIONS_LABELS_PRODUCT] = "标签(产品，盒子/纸箱，发货清单)没有相同的产品信息";
translations[OPTION_LABELINGISSUEOPTIONS_MISSING_BARCODE] = "缺少条形码";
translations[OPTION_DESCOFISSUEOPTIONS_CARTON_BOX] = "纸盒中含有错误的产品或混合的产品";
translations[OPTION_DESCOFISSUEOPTIONS_DAMAGED_SHIPPING] = "运输过程中纸箱损坏";
translations[OPTION_DESCOFISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED] = "收到额外的产品";
translations[OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "交付过期的产品";
translations[OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_FOUND] = "发现过期的产品";
translations[OPTION_DESCOFISSUEOPTIONS_PART_OF_THE_CARTON] = "部分纸箱被打开或没有密封";
translations[OPTION_DESCOFISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON] = "纸箱和配送标签上的产品信息与纸箱内的产品不匹配";
translations[OPTION_DESCOFISSUEOPTIONS_UNITS_WERE_MISSING] = "产品丢失";
translations[OPTION_DESCOFISSUEOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_LABELINGISSUEOPTIONS_MISSING_LABEL] = "缺少标签";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_EXPIRATION_DATE] = "到期日期";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_LOT_NUMBER] = "批号";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_NDC_NUMBER] = "国家药品代码（NDC）编号";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_DROPLETS_MOISTURE] = "外包装内有液滴/水汽，但没有观测到泄漏";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_LEAK] = "泄漏";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_LEAK_OBSERVED] = "挤压袋时观察到的泄漏";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_FLOWING] = "液体流过易折接头";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_INSIDE] = "液体在外包装内，未观测到泄漏";
translations[OPTION_COMPONENTLEAKINGOPTIONS_BETWEEN_OVERPOUCH] = "在外装袋和主容器之间的";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONNECTION_BETWEEN] = "两个产品之间的连接";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_MEMBRANE] = "容器-膜端口/管";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_INJECTION] = "容器-注射/充填端";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_HANGER] = "容器-吊挂孔";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER] = "容器";
translations[OPTION_COMPONENTLEAKINGOPTIONS_FRANGIBLE] = "易折接头";
translations[OPTION_COMPONENTLEAKINGOPTIONS_RUBBER_STOPPER] = "橡胶塞";
translations[OPTION_COMPONENTLEAKINGOPTIONS_SHRINKBAND] = "收缩带";
translations[OPTION_COMPONENTLEAKINGOPTIONS_TIP_PROTECTOR] = "末端保护器";
translations[OPTION_COMPONENTLEAKINGOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_COMPONENTLEAKINGOPTIONS_VIAL_ADAPTER] = "瓶转接器";
translations[OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT] = "黏附端";
translations[OPTION_SCENARIOSLEAKOPTIONS_DAMAGE_HOLES] = "二次包装或中间纸箱损坏(破洞、撕裂)";
translations[OPTION_SCENARIOSLEAKOPTIONS_EXPOSURE_TO_EXTREME] = "暴露在极热/极冷的环境中";
translations[OPTION_SCENARIOSLEAKOPTIONS_LEAK_AT_VAPORIZER] = "汽化器表面泄漏";
translations[OPTION_SCENARIOSLEAKOPTIONS_OPENING_SHIPPING] = "用美工刀/利器打开运输纸箱";
translations[OPTION_SCENARIOSLEAKOPTIONS_PETS_CLAWED] = "宠物(抓/咀嚼)";
translations[OPTION_SCENARIOSLEAKOPTIONS_SOLUTION_BAG_UNDER] = "以压力带或其他设备对药水袋加压";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_ADHERED_PORT] = "黏附口";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGE_HOLES] = "二次包装或中间纸箱损坏(破洞、撕裂)  ";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGED_SHIPPING] = "运输过程中纸箱损坏";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_EXPOSURE_TO_EXTREME] = "暴露在极热/极冷的环境中  ";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_LEAK_AT_VAPORIZER] = "汽化器表面泄漏";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_OPENING_SHIPPING] = "用美工刀/利器打开运输纸箱  ";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_PETS_CLAWED] = "宠物(抓/咀嚼)";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_SOLUTION_BAG_UNDER] = "以压力带或其他设备对药水袋加压";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_NONE_OF_THE_ABOVE] = "以上都没有";
translations[NO_DESCRIBE_THE_COLOR] = "否-描述颜色（请输入）";
translations[OPTION_LIQUIDSPILLEDOPTIONS_ML] = " 1-10ml";
translations[OPTION_LIQUIDSPILLEDOPTIONS_GREATER_THAN_ML] = " 大于 10ml";
translations[OPTION_LIQUIDSPILLEDOPTIONS_LESS_THAN_ML] = "小于 1ml";
translations[OPTION_VISIBLEDEFECTSOPTIONS_BOTTLE] = "瓶";
translations[OPTION_VISIBLEDEFECTSOPTIONS_CAP] = "盖";
translations[OPTION_VISIBLEDEFECTSOPTIONS_VALVE_NECK] = "阀/颈";
translations[OPTION_VISIBLEDEFECTSOPTIONS_NONE] = "无";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_CONNECTING] = "将商品与其他商品连接困难";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_DISCONNECTING] = "将商品与另一个产品断开连接困难";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "单个商品中的组件分离";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "将产品与另一种商品断开";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_DRIP_CHAMBER] = "滴室";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_TUBING] = "管";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_OTHER_PLEASE_SPECIFY] = "其他-请注明（自由文本）";
translations[OTHER_PLEASE_SPECIFY] = "其他-请注明（自由文本）";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_WHITE_CLOUDY] = "白色/云状";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_YELLOW_BROWNISH] = "黄色/棕色";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_OTHER_PLEASE_SPECIFY] = "其他-请注明（自由文本）";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_IN_THE_PRIMARY_PACKAGING] = "在主包装/泡罩袋内";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_IV] = "在 IV 流体路径内（在管道中）";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "装运纸箱内";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_ON_THE_EXTERIOR] = "在装运纸箱的外部";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_OUTSIDE_THE_IV] = "IV 流体 路径外（管道外部）";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_EMBEDDED] = "嵌入式";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_LOOSE] = "松";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_NOT_APPLICABLE] = "不适用";
translations[OPTION_INFUSATESOLUTIONOPTIONS_DESCRIBE_COLOR] = "描述颜色（自由文本）";
translations[OPTION_INFUSATESOLUTIONOPTIONS_YES_CHANGE_IN_COLOR] = "是-颜色变化";
translations[OPTION_INFUSATESOLUTIONOPTIONS_YES_PRECIPITATE] = "是-沉淀";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_ACCESS_SITE] = "接入站";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_BURRETTES] = "条状夹";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_CLAMP] = "夹子";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_DRIP_CHAMBER] = "滴室";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_TUBING] = "管";
translations[DAMAGECOMPONENTAFFECTEDOPTIONS_UNKNOWN] = "知 未知";
translations[DAMAGECOMPONENTAFFECTEDOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_FILTERS] = "过滤器";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_LUER_CONNECTOR] = "鲁尔连接器";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_SPIKE] = "针";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_CUT_CRACKED_BROKEN] = "切割/破裂/破损的组件";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_INCORRECT_COMPONENT_ASSEMBLY] = "错误组装的组件-请注明（自由文本）";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_KINKED_COLLAPSED] = "弯折/倒塌的组件";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_LOOSE_COMPONENT] = "组件在包装内松脱";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MALFORMED_MIS_SHAPED] = "变形/形状不正确的组件";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MISSING_COMPONENT] = "缺少组件";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_CONNECTING_THE] = "难以确保商品与另一个产品连接";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_DISCONNECTING_THE] = "难以断开商品与另一个产品的连接";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_LOOSE_CONNECTION] = "连接松动";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_DISCONNECTION] = "商品与另一个商品的分离/断开";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_BETWEEN_TWO] = "一个产品中的两个粘结组件之间分离";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_CONNECT] = "无法连接两个商品";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_DISCONNECTT] = "无法断开商品与另一个产品的连接";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_BARCODE_ISSUE] = "条形码问题-扫描时显示的信息不正确";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_CHANGE_IN_LABELING] = "标签更改";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "扫描困难/无法扫描条形码";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_EXPIRED_PRODUCT] = "过期产品";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_INCORRECT_INFORMATION_ON_LABEL] = "不正确标签";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_BARCODE_UDI] = "缺失条形码 /UDI";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_INFORMATION_ON_LABEL] = "缺失信息";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_PRODUCT_WITH_NO_EXPIRATION] = "商品标签没有有效期";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_SMUDGES_ILLEGIBLE_LABELING] = "污迹信息/难以辨认的标签";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_CARTON_BOX] = "纸箱/盒子里有错误的产品或混合的产品";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_DAMAGED_SHIPPING] = "发货时纸箱损坏 ";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "交付过期的产品";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_FOUND] = "发现过期的产品";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_ORDEREDFROMBAXTEROPTIONS_BAXTER] = "百特";
translations[OPTION_ORDEREDFROMBAXTEROPTIONS_DISTRIBUTOR] = "分销商";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED] = "收到额外的产品单位";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_PART_OF_THE_CARTON] = "纸箱部分打开或未密封 ";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON] = "纸箱上的产品信息和配送标签与纸箱内的产品不匹配 ";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_UNITS_WERE_MISSING] = "产品单位确实 ";
translations[OPTION_LEAKCOMINGFROMOPTIONS_ACCESS_SITE] = "接入点";
translations[OPTION_LEAKCOMINGFROMOPTIONS_AIR_VENT] = "透气孔";
translations[OPTION_LEAKCOMINGFROMOPTIONS_BURETTES] = "滴定器";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CAP] = "盖";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CLEARLINK_INJECTION_SITES] = "Clearlink注射部位 ";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CLAMP] = "夹子";
translations[OPTION_LEAKCOMINGFROMOPTIONS_DRIP_CHAMBER] = "滴室";
translations[OPTION_LEAKCOMINGFROMOPTIONS_FILTERS] = "过滤器";
translations[OPTION_LEAKCOMINGFROMOPTIONS_INTERLINK_INJECTION_SITES] = "Interlink注射部位 ";
translations[OPTION_LEAKCOMINGFROMOPTIONS_LUER_CONNECTOR] = "鲁尔连接器";
translations[OPTION_LEAKCOMINGFROMOPTIONS_SPIKE] = "针";
translations[OPTION_LEAKCOMINGFROMOPTIONS_TUBING] = "管";
translations[OPTION_LEAKCOMINGFROMOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_LEAKCOMINGFROMOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_LEAKCOMINGFROMOPTIONS_LEAK_BETWEEN_THE] = "注射点和管路之间的泄露";
translations[OPTION_LEAKCOMINGFROMOPTIONS_NEEDLE_BASED] = "Needle-Based注射部位";
translations[OPTION_LEAKCOMINGFROMOPTIONS_ONE_LINK_INJECTION] = "One-Link注射部位";
translations[OPTION_LEAKCOMINGFROMOPTIONS_OTHER_INJECTION] = "其他注射部位（自由文本）";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_CRACK_BREAK_IN] = "刚性组件的裂纹/断裂  ";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_CUT_SLICE_IN] = "切割/切片软管";
translations[DISCONNECTION_OF_CONNECTABLE] = "可连接部件/已连接产品的断开  ";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_DISCONNECTION_OF_CONNECTABLE] = "可连接部件/已连接产品的断开  ";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_SEPARATION_OF_BONDED_COMPONENTS] = "结合组件分离  ";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_YES_DESCRIBE_IRREGULARITIES] = "是-描述违规行为/损坏（自由文本）";
translations[YES_SPECIFY_THE_TOOL] = "是-指定使用的工具（自由文本）";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_BACKFLOW] = "回流";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT] = "夹子故障-难以夹紧（但最终能够关闭）";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_UNABLE] = "夹子故障-无法完全关闭";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT_UNABLE] = "夹子故障-难以/无法打开";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_NO_FLOW] = "无流量";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_OVER_INFUSION] = "输入过慢";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_RESTRICTED_SLOW] = "限制/慢流量";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_SIMULTANEOUS_FLOW] = "同时流";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_CLEAR] = "无法清除组件";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_PRIME] = "无法预充";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNDER_INFUSION] = "输入过快";
translations[OPTION_FLOWINGBACKWARDSOPTIONS_PATIENTS_BLOOD] = "患者的血液（不是血制品被注入）";
translations[OPTION_FLOWINGBACKWARDSOPTIONS_SOLUTIONS_BLOOD] = "输液/血制品";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_DAMAGE_HOLE] = "泄漏损坏/孔";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_DISCONNECTION] = "断开";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_LEAK] = "泄漏";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_MEDICATION_WAS_BEING] = "药物是通过加压输液注射器或静脉泵给予的";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_LOWER] = "二次袋低于主袋";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_AT] = "二级袋与主袋的高度相同";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_BLOOD_CLOTTING] = "凝血";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_CATHETER_WAS] = "在安装这套设备之前，无法冲洗导管  ";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_KINKED_TUBING] = "扭结";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_TUBING_INJECTION] = "软管/注射部位堵塞  ";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_PRIMARY_AND_SECONDARY] = "主要和次要容器(搭扣)  ";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_OR_MORE_LEADS] = "在多引线装置中流动的两个或多个引线  ";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_ADMINISTRATION] = "两套给药装置各有一个单独的输液泵  ";
translations[OPTION_HANGERUSEDOPTIONS_BAXTER_HANGER] = "百特挂钩";
translations[OPTION_HANGERUSEDOPTIONS_NON_BAXTER_HANGER] = "非百特挂钩";
translations[OPTION_BAGLOWEROPTIONS_BAGS_WERE_AT] = "袋子处于同一高度";
translations[OPTION_BAGLOWEROPTIONS_PRIMARY] = "主要";
translations[OPTION_BAGLOWEROPTIONS_SECONDARY] = "次要";
translations[OPTION_YSITECONNECTEDOPTIONS_MIDDLE] = "中部";
translations[OPTION_YSITECONNECTEDOPTIONS_LOWER] = "下部";
translations[OPTION_YSITECONNECTEDOPTIONS_UPPER] = "上部";
translations[OPTION_WITHPUMPOPTIONS_YES_PROVIDE_NAME] = "是-提供泵的名称和产品代码（请输入）";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_DARK_BLUE] = "深蓝色滑动夹";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_LIGHT_BLUE] = "浅蓝色滑动夹";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_NOTCH_CLAMP] = "夹片";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_ROLLER_CLAMP] = "滚轮夹";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_WHITE_SLIDE_CLAMP] = "白色滑动夹";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_THE_CLAMP] = "是-夹子破坏或破裂";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_AIR_IN_LINE] = "管路中有空气";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_CLAMP_ISSUE] = "管夹问题";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_ODOR] = "异味";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_NOTCH_PINCH] = "佳片/管路夹";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_ROLLER_CLAMP] = "滚轮夹";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_SLIDE_CLAMP] = "滑动夹";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_CRACKED_BROKEN] = "破裂/破损";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_OPEN] = "难以打开";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_CLOSE] = "难以关闭";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_MISSING] = "缺少";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_OPEN] = "无法打开";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CLOSE] = "无法关闭";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CONTROL] = "无法控制流速";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_TO_SQUEEZE] = "难以挤压滴注室";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_INSTRUCTIONS_WERE] = "说明书内容难以遵循/理解";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_PRODUCT_WAS_DIFFICULT] = "产品难以使用";
translations[OPTION_LEAKOCCUROPTIONS_CRACK_BREAK] = "裂纹/破损";
translations[OPTION_LEAKOCCUROPTIONS_CUT_SLICE] = "切/片  ";
translations[OPTION_LEAKOCCUROPTIONS_DISCONNECTION_OF_CONNECTABLE] = "可连接部件/已连接产品的断开  ";
translations[DISCONNECTION_OF_CONNECTABLE] = "可连接部件/已连接产品的断开  ";
translations[OPTION_LEAKOCCUROPTIONS_HOLE_TEA] = "孔/撕裂  ";
translations[OPTION_LEAKOCCUROPTIONS_SEPARATION_OF_BONDED] = "分离的组件";
translations[OPTION_LEAKOCCUROPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_LEAKSCENARIOSOPTIONS_ADHERED_PORT] = "黏附口";
translations[OPTION_LEAKSCENARIOSOPTIONS_DAMAGE_HOLES] = "二次包装或中间纸箱损坏(破洞、撕裂)  ";
translations[OPTION_LEAKSCENARIOSOPTIONS_DAMAGED_SHIPPING_CARTON] = "运输过程中纸箱损坏  ";
translations[OPTION_LEAKSCENARIOSOPTIONS_EXPOSURE_TO_EXTREME] = "暴露在极热/极冷的环境中  ";
translations[OPTION_LEAKSCENARIOSOPTIONS_OPENING_SHIPPING] = "用美工刀/利器打开运输纸箱  ";
translations[OPTION_LEAKSCENARIOSOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_LEAKSCENARIOSOPTIONS_NONE_OF_THE_ABOVE] = "以上都没有";
translations[OPTION_LEAKSCENARIOSOPTIONS_PRESSURE_CUFF] = "使用压力袖带或压力注射器  ";
translations[OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT] = "黏附端";
translations[OPTION_LEAKSCENARIOSOPTIONS_PETS_CLAWED_CHEWED] = "宠物(抓/咀嚼)  ";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_PRODUCT] = "产品  ";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_SHIPPING_CARTON_BOX] = "运输纸箱/箱";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_PRODUCT] = "产品内部";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "运输纸箱内部";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT] = "在产品外部";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING] = "难以将产品连接到另一产品";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING] = "难以将产品与到另一产品断开连接";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_LOOSE_CONNECTION] = "连接松散";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "在单个产品中分离组件";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "产品与另一产品的分离/断开";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_EXTERIOR] = "在运输纸箱外部";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_INSIDE_OF] = "在二次包装/外层包装的内部";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF] = "二次包装/外层包装外部";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_NOT_FLOWING] = "不流动";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_RESTRICTED_OR] = "受限或部分流动";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_BARCODE_ISSUE] = "条形码问题-扫描时显示的信息不正确";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "条形码扫描困难/ 无法扫描";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_ILLEGIBLE_LABEL] = "字迹模糊的标签  ";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCORRECT_LABEL] = "不正确的标签  ";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCOMPLETE_LABEL] = "不完整的标签  ";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABELS_PRODUCT] = "标签(产品，盒子/纸箱，发货清单)没有相同的产品信息  ";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABEL_TOO_SIMILAR] = "标签与其他产品过于相似  ";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_LABEL] = "缺少标签  ";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_BARCODE] = "缺少条形码";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_DESCOFISSUEOPTIONS_FROZEN_PRODUCT] = "收到冷冻产品";
translations[OPTION_DESCOFISSUEOPTIONS_THAWED_PRODUCT] = "收到解冻产品";
translations[OPTION_ALARMOPTIONS_YES_ALARM_NOT_KNOWN] = "是的，警报不知道";
translations[OPTION_ALARMOPTIONS_YES_SPECIFY] = "是的，请指定";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_OPEN] = "是的-外接短管无法完全开放";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_CLOSED] = "是的-外接短管无法完全关闭";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_OPEN_AT_ALL] = "是-旋转接头太近，输液管根本无法打开";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_CLOSE_AT_ALL] = "是-旋转接头太近，输液管根本无法完全关闭";
translations[OPTION_COMPONENTHADISSUEOPTIONS_BOX_OR_OVERPOUCH] = "箱子或外包装";
translations[OPTION_COMPONENTHADISSUEOPTIONS_BLUE_CLAMP_ON] = "最终补充管上的蓝色夹子";
translations[OPTION_COMPONENTHADISSUEOPTIONS_CASSETT] = "卡匣";
translations[OPTION_COMPONENTHADISSUEOPTIONS_DRAIN_LINE] = "排水管连接器和拉环帽";
translations[OPTION_COMPONENTHADISSUEOPTIONS_EFFLUENT_SAMPLE] = "废水样本点";
translations[OPTION_COMPONENTHADISSUEOPTIONS_LINES] = "管路";
translations[OPTION_COMPONENTHADISSUEOPTIONS_LUER_SPIKE] = "鲁尔接口/穿刺器";
translations[OPTION_COMPONENTHADISSUEOPTIONS_ORGANIZER] = "管组架";
translations[OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PATIENT_LINE] = "病人管路上的拉环帽/尖端保护帽";
translations[OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PROTECTORS] = "拉环帽/尖端保护帽";
translations[OPTION_COMPONENTHADISSUEOPTIONS_RED_CLAMP_ON] = "加热管道上的红色夹子";
translations[OPTION_COMPONENTHADISSUEOPTIONS_TACK_WELD] = "定位焊缝";
translations[OPTION_COMPONENTHADISSUEOPTIONS_WHITE_CLAMP_ON_SUPPLY] = "供应管上的白色夹子";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_BEIGE_CATHETER] = "米色导管接头连接器";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_CHIP_INSERT] = "内嵌芯片";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_DARK_BLUE_CONNECTOR] = "深蓝色连接器";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_MAIN] = "浅蓝色主体";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_PULL] = "浅蓝色拉环帽";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_OCCLUDER] = "浅蓝色夹脚";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_SILICONE_TUBING] = "硅胶管";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_TITANIUM_SPIKE] = "钛钉";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_UV_FLASH_SPIKE] = "紫外照射钉";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_WHITE_TWIST_CLAMP] = "白色开关夹/套筒";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONS_YES_DESCRIBE_THE_DAMAGE] = "是：描述损坏（请输入）";
translations[OPTION_MONTHOPTIONS_JAN] = "一月";
translations[OPTION_MONTHOPTIONS_FEB] = "二月";
translations[OPTION_MONTHOPTIONS_MAR] = "三月";
translations[OPTION_MONTHOPTIONS_APR] = "四月";
translations[OPTION_MONTHOPTIONS_MAY] = "五月";
translations[OPTION_MONTHOPTIONS_JUN] = "六月";
translations[OPTION_MONTHOPTIONS_JUL] = "七月";
translations[OPTION_MONTHOPTIONS_AUG] = "八月";
translations[OPTION_MONTHOPTIONS_SEP] = "九月";
translations[OPTION_MONTHOPTIONS_OCT] = "十月";
translations[OPTION_MONTHOPTIONS_NOV] = "十一月";
translations[OPTION_MONTHOPTIONS_DEC] = "十二月";
translations[OPTION_PROBLEMOPTIONS_OTHER] = "其他";
translations[OPTION_REPORTEDTOOPTIONS_OTHER] = "其他";
translations[OPTION_DIFFICULTTOUSEOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_BLOCKINGFLOWOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_DESCRIBEISSUEOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_MATERIALLOCATEDOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_PRODUCTTHAWEDOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_LABELINGISSUEOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_COMPONENTLEAKINGOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_OTHER] = "其他（自由文本）";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_COMPONENTHADISSUEOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_FOLLOWINGOCCUROPTIONS_NONE_OF_THE_ABOVE] = "以上都没有";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_NO] = "否";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_YES] = "是";
translations[OPTION_ADDANOTHERFACILITYOPTIONS_NO] = "否";
translations[OPTION_ADDANOTHERFACILITYOPTIONS_YES] = "是";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_NO] = "否";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_YES] = "是";
translations[OPTION_OTHERFACILITYREPORTOPTIONS_NO] = "否";
translations[OPTION_OTHERFACILITYREPORTOPTIONS_YES] = "是";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_ASKED_UNKNOWN] = "询问后但未知";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_NO] = "否";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_UNKNOWN] = "知 未知";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_YES] = "是";
translations[OPTION_AVAILABILITYOPTIONS_NO] = "否";
translations[OPTION_AVAILABILITYOPTIONS_YES] = "是";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_NO] = "否";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_YES] = "是";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_NO] = "否";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_YES] = "是";
translations[OPTION_UNUSEDAVAILABILITYOPTIONS_NO] = "否";
translations[OPTION_UNUSEDAVAILABILITYOPTIONS_YES] = "是";
translations[OPTION_SELFNEGATIVEIMPACTOPTIONS_NO] = "否";
translations[OPTION_SELFNEGATIVEIMPACTOPTIONS_YES] = "是";
translations[OPTION_PATIENTNEGATIVEIMPACTOPTIONS_NO] = "否";
translations[OPTION_PATIENTNEGATIVEIMPACTOPTIONS_YES] = "是";
translations[OPTION_COUNTERACTIONOPTIONS_NO] = "否";
translations[OPTION_COUNTERACTIONOPTIONS_YES] = "是";
translations[OPTION_DRUGUSEDOPTIONS_NO] = "否";
translations[OPTION_DRUGUSEDOPTIONS_YES] = "是";
translations[OPTION_SHARECONTACTOPTIONS_NO] = "否";
translations[OPTION_SHARECONTACTOPTIONS_YES] = "是";
translations[OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_NO] = "否";
translations[OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_YES] = "是";
translations[OPTION_DIRECTORDEROPTIONS_NO] = "否";
translations[OPTION_DIRECTORDEROPTIONS_YES] = "是";
translations[OPTION_EXCESSIVEFORCEOPTIONS_NO] = "否";
translations[OPTION_EXCESSIVEFORCEOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_EXCESSIVEFORCEOPTIONS_YES] = "是";
translations[OPTION_TWISTCLAMPOPTIONS_NO] = "否";
translations[OPTION_TWISTCLAMPOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_TWISTCLAMPOPTIONS_YES] = "是";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_NO] = "否";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_ENVIRONMENTOPTIONS_NO] = "否";
translations[OPTION_ENVIRONMENTOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_ENVIRONMENTOPTIONS_YES] = "是";
translations[OPTION_SPONGEVISIBLEOPTIONS_NO] = "否";
translations[OPTION_SPONGEVISIBLEOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_SPONGEVISIBLEOPTIONS_YES] = "是";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_NO] = "否";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_YES] = "是";
translations[OPTION_PIECESMATERIALOPTIONS_NO] = "否";
translations[OPTION_PIECESMATERIALOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_PIECESMATERIALOPTIONS_YES] = "是";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_NO] = "否";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_YES] = "是";
translations[OPTION_INITIALCONNECTIONOPTIONS_NO] = "否";
translations[OPTION_INITIALCONNECTIONOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_INITIALCONNECTIONOPTIONS_YES] = "是";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_NO] = "否";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_YES] = "是";
translations[OPTION_PETSORANIMALSOPTIONS_NO] = "否";
translations[OPTION_PETSORANIMALSOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_PETSORANIMALSOPTIONS_YES] = "是";
translations[OPTION_MINICAPTWISTEDOPTIONS_NO] = "否";
translations[OPTION_MINICAPTWISTEDOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_MINICAPTWISTEDOPTIONS_YES] = "是";
translations[OPTION_TRANSFERSETOPTIONS_NO] = "否";
translations[OPTION_TRANSFERSETOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_TRANSFERSETOPTIONS_YES] = "是";
translations[OPTION_RESIDUETHREADSOPTIONS_NO] = "否";
translations[OPTION_RESIDUETHREADSOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_NO] = "否";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_YES] = "是";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_NO] = "否";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_YES] = "是";
translations[OPTION_ADAPTERDEVICEOPTIONS_NO] = "否";
translations[OPTION_ADAPTERDEVICEOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_ADAPTERDEVICEOPTIONS_YES] = "是";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_NO] = "否";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_UNKNOWN] = "知 未知";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_YES] = "是";
translations[OPTION_FORTHMOTIONOPTIONS_NO] = "否";
translations[OPTION_FORTHMOTIONOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_FORTHMOTIONOPTIONS_YES] = "是";
translations[OPTION_ALARMNOFLOWOPTIONS_NO] = "否";
translations[OPTION_ALARMNOFLOWOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_ALARMNOFLOWOPTIONS_YES] = "是";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_NO] = "否";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_YES] = "是";
translations[OPTION_BROKENACTIVATEDOPTIONS_NO] = "否";
translations[OPTION_BROKENACTIVATEDOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_BROKENACTIVATEDOPTIONS_YES] = "是";
translations[OPTION_vaporizerSightGlassOptions_NO] = "否";
translations[OPTION_vaporizerSightGlassOptions_UNKNOWN] = "知 未知";
translations[OPTION_vaporizerSightGlassOptions_YES] = "是";
translations[OPTION_PRODUCTHEATOPTIONS_NO] = "否";
translations[OPTION_PRODUCTHEATOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_PRODUCTHEATOPTIONS_YES] = "是";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_NO] = "否";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_YES] = "是";
translations[OPTION_LEAKOBSERVEDOPTIONS_NO] = "否";
translations[OPTION_LEAKOBSERVEDOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_LEAKOBSERVEDOPTIONS_YES] = "是";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_NO] = "否";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_YES] = "是";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_NO] = "否";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_YES] = "是";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_NO] = "否";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_YES] = "是";
translations[OPTION_AGITATEUNITOPTIONS_NO] = "否";
translations[OPTION_AGITATEUNITOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_AGITATEUNITOPTIONS_YES] = "是";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_NO] = "否";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_YES] = "是";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_NO] = "否";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_YES] = "是";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_NO] = "否";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_UNKNOWN] = "知 未知";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_YES] = "是";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_NO] = "否";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_YES] = "是";
translations[OPTION_EXPIREDPRODUCTOPTIONS_NO] = "否";
translations[OPTION_EXPIREDPRODUCTOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_EXPIREDPRODUCTOPTIONS_YES] = "是";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_NO] = "否";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_YES] = "是";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_NO] = "否";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_YES] = "是";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_NO] = "否";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_YES] = "是";
translations[OPTION_BARCODESCANNEROPTIONS_NO] = "否";
translations[OPTION_BARCODESCANNEROPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_BARCODESCANNEROPTIONS_YES] = "是";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_NO] = "否";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_YES] = "是";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_NO] = "否";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_YES] = "是";
translations[OPTION_FRANGIBLEBROKENOPTIONS_NO] = "否";
translations[OPTION_FRANGIBLEBROKENOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_FRANGIBLEBROKENOPTIONS_YES] = "是";
translations[OPTION_MOISTURECLEAROPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_MOISTURECLEAROPTIONS_YES] = "是";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_NO] = "否";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_YES] = "是";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_NO] = "否";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_YES] = "是";
translations[OPTION_PRESSURECUFFOPTIONS_NO] = "否";
translations[OPTION_PRESSURECUFFOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_PRESSURECUFFOPTIONS_YES] = "是";
translations[OPTION_LIQUIDSPILLEDOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_NO] = "否";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_YES] = "是";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_NO] = "否";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_YES] = "是";
translations[OPTION_ADDINGMEDICATIONOPTIONS_NO] = "否";
translations[OPTION_ADDINGMEDICATIONOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_ADDINGMEDICATIONOPTIONS_YES] = "是";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_NO] = "否";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_YES] = "是";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_NO] = "否";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_YES] = "是";
translations[OPTION_WASPOWERINJECTOROPTIONS_NO] = "否";
translations[OPTION_WASPOWERINJECTOROPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_WASPOWERINJECTOROPTIONS_YES] = "是";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_NO] = "否";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_YES] = "是";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_NO] = "否";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_NO] = "否";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_YES] = "是";
translations[OPTION_TOOLUSEDASSISTOPTIONS_NO] = "否";
translations[OPTION_TOOLUSEDASSISTOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_SECUREPRIORUSEOPTIONS_NO] = "否";
translations[OPTION_SECUREPRIORUSEOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_SECUREPRIORUSEOPTIONS_YES] = "是";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_NO] = "否";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_YES] = "是";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_NO] = "否";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_YES] = "是";
translations[OPTION_YSITECONNECTEDOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_NO] = "否";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_YES] = "是";
translations[OPTION_WITHPUMPOPTIONS_NO] = "否";
translations[OPTION_WITHPUMPOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_CLAMPFAILOPTIONS_NO] = "否";
translations[OPTION_CLAMPFAILOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_CLAMPFAILOPTIONS_YES] = "是";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_NO] = "否";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_NO] = "否";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_YES] = "是";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_NO] = "否";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_YES] = "是";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_NO] = "否";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_YES] = "是";
translations[OPTION_GELPACKSOPTIONS_NO] = "否";
translations[OPTION_GELPACKSOPTIONS_YES] = "是";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_NO] = "否";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_YES] = "是";
translations[OPTION_ALARMOPTIONS_NO] = "否";
translations[OPTION_ALARMOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_NO] = "否";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_YES] = "是";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_NO] = "否";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_TRANSFERREPLACEDOPTIONS_NO] = "否";
translations[OPTION_TRANSFERREPLACEDOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_TRANSFERREPLACEDOPTIONS_YES] = "是";
translations[OPTION_FULLYTIGHTENEDOPTIONS_NO] = "否";
translations[OPTION_FULLYTIGHTENEDOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_FULLYTIGHTENEDOPTIONS_YES] = "是";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_NO] = "否";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_UNKNOWN] = "知 未知";
translations[OPTION_ISSUERESULTLEAKOPTIONS_NO] = "否";
translations[OPTION_ISSUERESULTLEAKOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_ISSUERESULTLEAKOPTIONS_YES] = "是";
translations[OPTION_ISSUERESULTLEAKOPTIONS_OTHER] = "其他（自由文本）";
translations[OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_NO] = "否";
translations[OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_YES] = "是";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_NO] = "否";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_YES] = "是";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_NO] = "否";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_YES] = "是";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_ASKED_UNKNOWN] = "询问后但未知";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_ASKED_UNKNOWN] = "询问后但未知";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_NO] = "否";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_UNKNOWN] = "未知";
translations[OPTION_SCENARIOSLEAKOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_SCENARIOSLEAKOPTIONS_NONE_OF_THE_ABOVE] = "以上都没有";
translations[OPTION_MOISTURECLEAROPTIONS_NO_DESCRIBE_THE_COLOR] = "否-描述颜色（请输入）";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_TOOLUSEDASSISTOPTIONS_YES_SPECIFY_THE_TOOL] = "是-指定使用的工具（自由文本）";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SEPARATION] = "分离";
translations[OPTION_HANGERUSEDOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_HANGERUSEDOPTIONS_NONE] = "无";
translations[OPTION_BAGLOWEROPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_OTHER] = "是-其他（请输入）";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_NO] = "否";
translations[OPTION_WEIGHTUNITOPTIONS_KILOGRAM] = "千克（s）";
translations[OPTION_WEIGHTUNITOPTIONS_POUND] = "英镑";
translations[OPTION_INFUSATESOLUTIONOPTIONS_NO] = "否";
translations[OPTION_INFUSATESOLUTIONOPTIONS_UNKNOWN] = "知 未知";
translations[PLEASE_ENTER_THE_VALUE] = "请输入值";
translations[PLEASE_SELECT_THE_VALUE] = "请选择值";
translations[PLEASE_SELECT_THE_DATE] = "请选择日期";
translations[PLEASE_CHOOSE_THE_VALUE] = "请选择值";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_UNKNOWN] = "知 未知";
translations[OPTION_COUNTRYOPTIONS_GREAT_BRITAIN] = "大不列颠";
translations[OPTION_COUNTRYOPTIONS_KOSOVO] = "科索沃";
translations[OPTION_COUNTRYOPTIONS_NORTHERN_IRELAND] = "北爱尔兰";
translations[OPTION_COUNTRYOPTIONS_AFGHANISTAN] = "阿富汗";
translations[OPTION_COUNTRYOPTIONS_ÅLAND_ISLANDS] = "奥兰群岛";
translations[OPTION_COUNTRYOPTIONS_ALBANIA] = "阿尔巴尼亚";
translations[OPTION_COUNTRYOPTIONS_ALGERIA] = "阿尔及利亚";
translations[OPTION_COUNTRYOPTIONS_AMERICAN_SAMOA] = "美属萨摩亚";
translations[OPTION_COUNTRYOPTIONS_ANDORRA] = "安道尔";
translations[OPTION_COUNTRYOPTIONS_ANGOLA] = "安哥拉";
translations[OPTION_COUNTRYOPTIONS_ANGUILLA] = "安圭拉";
translations[OPTION_COUNTRYOPTIONS_ANTARCTICA] = "南极洲";
translations[OPTION_COUNTRYOPTIONS_ANTIGUA_AND_BARBUDA] = "安提瓜和巴布达";
translations[OPTION_COUNTRYOPTIONS_ARGENTINA] = "阿根廷";
translations[OPTION_COUNTRYOPTIONS_ARMENIA] = "亚美尼亚";
translations[OPTION_COUNTRYOPTIONS_ARUBA] = "阿鲁巴";
translations[OPTION_COUNTRYOPTIONS_AUSTRALIA] = "澳大利亚";
translations[OPTION_COUNTRYOPTIONS_AUSTRIA] = "奥地利";
translations[OPTION_COUNTRYOPTIONS_AZERBAIJAN] = "阿塞拜疆";
translations[OPTION_COUNTRYOPTIONS_BAHAMAS] = "巴哈马";
translations[OPTION_COUNTRYOPTIONS_BAHRAIN] = "巴林";
translations[OPTION_COUNTRYOPTIONS_BANGLADESH] = "孟加拉国";
translations[OPTION_COUNTRYOPTIONS_BARBADOS] = "巴巴多斯";
translations[OPTION_COUNTRYOPTIONS_BELARUS] = "白俄罗斯";
translations[OPTION_COUNTRYOPTIONS_BELGIUM] = "比利时";
translations[OPTION_COUNTRYOPTIONS_BELIZE] = "伯利兹";
translations[OPTION_COUNTRYOPTIONS_BENIN] = "贝宁";
translations[OPTION_COUNTRYOPTIONS_BERMUDA] = "百慕大";
translations[OPTION_COUNTRYOPTIONS_BHUTAN] = "不丹";
translations[OPTION_COUNTRYOPTIONS_BOLIVIA] = "玻利维亚";
translations[OPTION_COUNTRYOPTIONS_BOSNIA_AND_HERZEGOVINA] = "波斯尼亚和黑塞哥维那";
translations[OPTION_COUNTRYOPTIONS_BOTSWANA] = "博茨瓦纳";
translations[OPTION_COUNTRYOPTIONS_BOUVET_ISLAND] = "布韦岛";
translations[OPTION_COUNTRYOPTIONS_BRAZIL] = "巴西";
translations[OPTION_COUNTRYOPTIONS_BRITISH_INDIAN_OCEAN_TERRITORY] = "英属印度洋领地";
translations[OPTION_COUNTRYOPTIONS_BRUNEI_DARUSSALAM] = "文莱达鲁萨兰国";
translations[OPTION_COUNTRYOPTIONS_BULGARIA] = "保加利亚";
translations[OPTION_COUNTRYOPTIONS_BURKINA_FASO] = "布基纳法索";
translations[OPTION_COUNTRYOPTIONS_BURUNDI] = "布隆迪";
translations[OPTION_COUNTRYOPTIONS_CAMBODIA] = "柬埔寨";
translations[OPTION_COUNTRYOPTIONS_CAMEROON] = "喀麦隆";
translations[OPTION_COUNTRYOPTIONS_CANADA] = "加拿大";
translations[OPTION_COUNTRYOPTIONS_CAPE_VERDE] = "佛得角";
translations[OPTION_COUNTRYOPTIONS_CAYMAN_ISLANDS] = "开曼群岛";
translations[OPTION_COUNTRYOPTIONS_CENTRAL_AFRICAN_REPUBLIC] = "中非共和国";
translations[OPTION_COUNTRYOPTIONS_CHAD] = "乍得";
translations[OPTION_COUNTRYOPTIONS_CHILE] = "智利";
translations[OPTION_COUNTRYOPTIONS_CHINA] = "中国";
translations[OPTION_COUNTRYOPTIONS_CHRISTMAS_ISLAND] = "圣诞岛";
translations[OPTION_COUNTRYOPTIONS_COCOS_KEELING_ISLANDS] = "科科斯（基林）群岛";
translations[OPTION_COUNTRYOPTIONS_COLOMBIA] = "哥伦比亚";
translations[OPTION_COUNTRYOPTIONS_COMOROS] = "科摩罗";
translations[OPTION_COUNTRYOPTIONS_CONGO] = "刚果";
translations[OPTION_COUNTRYOPTIONS_CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE] = "刚果民主共和国";
translations[OPTION_COUNTRYOPTIONS_COOK_ISLANDS] = "库克群岛";
translations[OPTION_COUNTRYOPTIONS_COSTA_RICA] = "哥斯达黎加";
translations[OPTION_COUNTRYOPTIONS_CÔTE_DIVOIRE_IVORY_COAST] = "科特迪瓦（象牙海岸）";
translations[OPTION_COUNTRYOPTIONS_CROATIA] = "克罗地亚";
translations[OPTION_COUNTRYOPTIONS_CUBA] = "古巴";
translations[OPTION_COUNTRYOPTIONS_CYPRUS] = "塞浦路斯";
translations[OPTION_COUNTRYOPTIONS_CZECH_REPUBLIC] = "捷克共和国";
translations[OPTION_COUNTRYOPTIONS_DENMARK] = "丹麦";
translations[OPTION_COUNTRYOPTIONS_DJIBOUTI] = "吉布提";
translations[OPTION_COUNTRYOPTIONS_DOMINICA] = "多米尼克";
translations[OPTION_COUNTRYOPTIONS_DOMINICAN_REPUBLIC] = "多明尼加共和国";
translations[OPTION_COUNTRYOPTIONS_ECUADOR] = "厄瓜多尔";
translations[OPTION_COUNTRYOPTIONS_EGYPT] = "埃及";
translations[OPTION_COUNTRYOPTIONS_EL_SALVADOR] = "萨尔瓦多";
translations[OPTION_COUNTRYOPTIONS_EQUATORIAL_GUINEA] = "赤道几内亚";
translations[OPTION_COUNTRYOPTIONS_ERITREA] = "厄立特里亚";
translations[OPTION_COUNTRYOPTIONS_ESTONIA] = "爱沙尼亚";
translations[OPTION_COUNTRYOPTIONS_ETHIOPIA] = "埃塞俄比亚";
translations[OPTION_COUNTRYOPTIONS_FALKLAND_ISLANDS_MALVINAS] = "福克兰群岛（马尔维纳斯）";
translations[OPTION_COUNTRYOPTIONS_FAROE_ISLANDS] = "法罗群岛";
translations[OPTION_COUNTRYOPTIONS_FIJI] = "斐济";
translations[OPTION_COUNTRYOPTIONS_FINLAND] = "芬兰";
translations[OPTION_COUNTRYOPTIONS_FRANCE] = "法国";
translations[OPTION_COUNTRYOPTIONS_FRENCH_GUIANA] = "法属圭亚那";
translations[OPTION_COUNTRYOPTIONS_FRENCH_POLYNESIA] = "法属波利尼西亚";
translations[OPTION_COUNTRYOPTIONS_FRENCH_SOUTHERN_TERRITORIES] = "法属南部领地";
translations[OPTION_COUNTRYOPTIONS_GABON] = "加蓬";
translations[OPTION_COUNTRYOPTIONS_GAMBIA] = "冈比亚";
translations[OPTION_COUNTRYOPTIONS_GEORGIA] = "乔治亚州";
translations[OPTION_COUNTRYOPTIONS_GERMANY] = "德国";
translations[OPTION_COUNTRYOPTIONS_GHANA] = "加纳";
translations[OPTION_COUNTRYOPTIONS_GIBRALTAR] = "直布罗陀";
translations[OPTION_COUNTRYOPTIONS_GREECE] = "希腊";
translations[OPTION_COUNTRYOPTIONS_GREENLAND] = "格陵兰";
translations[OPTION_COUNTRYOPTIONS_GRENADA] = "格林纳达";
translations[OPTION_COUNTRYOPTIONS_GUADELOUPE] = "瓜德罗普";
translations[OPTION_COUNTRYOPTIONS_GUAM] = "关岛";
translations[OPTION_COUNTRYOPTIONS_GUATEMALA] = "危地马拉";
translations[OPTION_COUNTRYOPTIONS_GUERNSEY] = "根西岛";
translations[OPTION_COUNTRYOPTIONS_GUINEA] = "几内亚";
translations[OPTION_COUNTRYOPTIONS_GUINEA_BISSAU] = "几内亚比绍";
translations[OPTION_COUNTRYOPTIONS_GUYANA] = "圭亚那";
translations[OPTION_COUNTRYOPTIONS_HAITI] = "海地";
translations[OPTION_COUNTRYOPTIONS_HEARD_ISLAND_AND_MCDONALD_ISLANDS] = "赫德岛和麦当劳岛";
translations[OPTION_COUNTRYOPTIONS_HOLY_SEE_VATICAN_CITY_STATE] = "罗马教廷（梵蒂冈州）";
translations[OPTION_COUNTRYOPTIONS_HONDURAS] = "洪都拉斯";
translations[OPTION_COUNTRYOPTIONS_HONG_KONG] = "香港";
translations[OPTION_COUNTRYOPTIONS_HUNGARY] = "匈牙利";
translations[OPTION_COUNTRYOPTIONS_ICELAND] = "冰岛";
translations[OPTION_COUNTRYOPTIONS_INDIA] = "印度";
translations[OPTION_COUNTRYOPTIONS_INDONESIA] = "印度尼西亚";
translations[OPTION_COUNTRYOPTIONS_IRAN_ISLAMIC_REPUBLIC_OF] = "伊朗伊斯兰共和国";
translations[OPTION_COUNTRYOPTIONS_IRAQ] = "伊拉克";
translations[OPTION_COUNTRYOPTIONS_IRELAND] = "爱尔兰";
translations[OPTION_COUNTRYOPTIONS_ISLE_OF_MAN] = "马恩岛";
translations[OPTION_COUNTRYOPTIONS_ISRAEL] = "以色列";
translations[OPTION_COUNTRYOPTIONS_ITALY] = "意大利";
translations[OPTION_COUNTRYOPTIONS_JAMAICA] = "牙买加";
translations[OPTION_COUNTRYOPTIONS_JAPAN] = "日本";
translations[OPTION_COUNTRYOPTIONS_JERSEY] = "球衣";
translations[OPTION_COUNTRYOPTIONS_JORDAN] = "约旦";
translations[OPTION_COUNTRYOPTIONS_KAZAKHSTAN] = "哈萨克斯坦";
translations[OPTION_COUNTRYOPTIONS_KENYA] = "肯尼亚";
translations[OPTION_COUNTRYOPTIONS_KIRIBATI] = "基里巴斯";
translations[OPTION_COUNTRYOPTIONS_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF] = "朝鲜民主主义人民共和国";
translations[OPTION_COUNTRYOPTIONS_KOREA_REPUBLIC_OF] = "大韩民国";
translations[OPTION_COUNTRYOPTIONS_KUWAIT] = "科威特";
translations[OPTION_COUNTRYOPTIONS_KYRGYZSTAN] = "吉尔吉斯斯坦";
translations[OPTION_COUNTRYOPTIONS_LAO_PEOPLES_DEMOCRATIC_REPUBLIC] = "老挝人民民主共和国";
translations[OPTION_COUNTRYOPTIONS_LATVIA] = "拉脱维亚";
translations[OPTION_COUNTRYOPTIONS_LEBANON] = "黎巴嫩";
translations[OPTION_COUNTRYOPTIONS_LESOTHO] = "莱索托";
translations[OPTION_COUNTRYOPTIONS_LIBERIA] = "利比里亚";
translations[OPTION_COUNTRYOPTIONS_LIBYAN_ARAB_JAMAHIRIYA] = "阿拉伯利比亚民众国";
translations[OPTION_COUNTRYOPTIONS_LIECHTENSTEIN] = "列支敦士登";
translations[OPTION_COUNTRYOPTIONS_LITHUANIA] = "立陶宛";
translations[OPTION_COUNTRYOPTIONS_LUXEMBOURG] = "卢森堡";
translations[OPTION_COUNTRYOPTIONS_MACAO] = "澳门";
translations[OPTION_COUNTRYOPTIONS_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF] = "马其顿，前南斯拉夫共和国";
translations[OPTION_COUNTRYOPTIONS_MADAGASCAR] = "马达加斯加";
translations[OPTION_COUNTRYOPTIONS_MALAWI] = "马拉维";
translations[OPTION_COUNTRYOPTIONS_MALAYSIA] = "马来西亚";
translations[OPTION_COUNTRYOPTIONS_MALDIVES] = "马尔代夫";
translations[OPTION_COUNTRYOPTIONS_MALI] = "马里";
translations[OPTION_COUNTRYOPTIONS_MALTA] = "马耳他";
translations[OPTION_COUNTRYOPTIONS_MARSHALL_ISLANDS] = "马绍尔群岛";
translations[OPTION_COUNTRYOPTIONS_MARTINIQUE] = "马提尼克岛";
translations[OPTION_COUNTRYOPTIONS_MAURITANIA] = "毛里塔尼亚";
translations[OPTION_COUNTRYOPTIONS_MAURITIUS] = "毛里求斯";
translations[OPTION_COUNTRYOPTIONS_MAYOTTE] = "马约特";
translations[OPTION_COUNTRYOPTIONS_MEXICO] = "墨西哥";
translations[OPTION_COUNTRYOPTIONS_MICRONESIA_FEDERATED_STATES_OF] = "密克罗尼西亚联邦";
translations[OPTION_COUNTRYOPTIONS_MOLDOVA] = "摩尔多瓦";
translations[OPTION_COUNTRYOPTIONS_MONACO] = "摩纳哥";
translations[OPTION_COUNTRYOPTIONS_MONGOLIA] = "蒙古";
translations[OPTION_COUNTRYOPTIONS_MONTENEGRO] = "黑山共和国";
translations[OPTION_COUNTRYOPTIONS_MONTSERRAT] = "蒙特塞拉特";
translations[OPTION_COUNTRYOPTIONS_MOROCCO] = "摩洛哥";
translations[OPTION_COUNTRYOPTIONS_MOZAMBIQUE] = "莫桑比克";
translations[OPTION_COUNTRYOPTIONS_MYANMAR] = "缅甸";
translations[OPTION_COUNTRYOPTIONS_NAMIBIA] = "纳米比亚";
translations[OPTION_COUNTRYOPTIONS_NAURU] = "瑙鲁";
translations[OPTION_COUNTRYOPTIONS_NEPAL] = "尼泊尔";
translations[OPTION_COUNTRYOPTIONS_NETHERLANDS] = "荷兰";
translations[OPTION_COUNTRYOPTIONS_NEW_CALEDONIA] = "新喀里多尼亚";
translations[OPTION_COUNTRYOPTIONS_NEW_ZEALAND] = "新西兰";
translations[OPTION_COUNTRYOPTIONS_NICARAGUA] = "尼加拉瓜";
translations[OPTION_COUNTRYOPTIONS_NIGER] = "尼日尔";
translations[OPTION_COUNTRYOPTIONS_NIGERIA] = "尼日利亚";
translations[OPTION_COUNTRYOPTIONS_NIUE] = "纽埃";
translations[OPTION_COUNTRYOPTIONS_NORFOLK_ISLAND] = "诺福克岛";
translations[OPTION_COUNTRYOPTIONS_NORTHERN_MARIANA_ISLANDS] = "北马里亚纳群岛";
translations[OPTION_COUNTRYOPTIONS_NORWAY] = "挪威";
translations[OPTION_COUNTRYOPTIONS_OMAN] = "阿曼";
translations[OPTION_COUNTRYOPTIONS_PAKISTAN] = "巴基斯坦";
translations[OPTION_COUNTRYOPTIONS_PALAU] = "帕劳";
translations[OPTION_COUNTRYOPTIONS_PALESTINIAN_TERRITORY_OCCUPIED] = "巴勒斯坦领土，被占领";
translations[OPTION_COUNTRYOPTIONS_PANAMA] = "巴拿马";
translations[OPTION_COUNTRYOPTIONS_PAPUA_NEW_GUINEA] = "巴布亚新几内亚";
translations[OPTION_COUNTRYOPTIONS_PARAGUAY] = "巴拉圭";
translations[OPTION_COUNTRYOPTIONS_PERU] = "秘鲁";
translations[OPTION_COUNTRYOPTIONS_PHILIPPINES] = "菲律宾";
translations[OPTION_COUNTRYOPTIONS_PITCAIRN] = "皮特凯恩";
translations[OPTION_COUNTRYOPTIONS_POLAND] = "波兰";
translations[OPTION_COUNTRYOPTIONS_PORTUGAL] = "葡萄牙";
translations[OPTION_COUNTRYOPTIONS_PUERTO_RICO] = "波多黎各";
translations[OPTION_COUNTRYOPTIONS_QATAR] = "卡塔尔";
translations[OPTION_COUNTRYOPTIONS_RÉUNION] = "团圆";
translations[OPTION_COUNTRYOPTIONS_ROMANIA] = "罗马尼亚";
translations[OPTION_COUNTRYOPTIONS_RUSSIAN_FEDERATION] = "俄罗斯联邦";
translations[OPTION_COUNTRYOPTIONS_RWANDA] = "卢旺达";
translations[OPTION_COUNTRYOPTIONS_SAINT_BARTHÉLEMY] = "圣巴泰勒米";
translations[OPTION_COUNTRYOPTIONS_SAINT_HELENA] = "圣赫勒拿";
translations[OPTION_COUNTRYOPTIONS_SAINT_KITTS_AND_NEVIS] = "圣基茨和尼维斯";
translations[OPTION_COUNTRYOPTIONS_SAINT_LUCIA] = "圣卢西亚";
translations[OPTION_COUNTRYOPTIONS_SAINT_MARTIN] = "圣马丁";
translations[OPTION_COUNTRYOPTIONS_SAINT_PIERRE_AND_MIQUELON] = "圣皮埃尔和密克隆";
translations[OPTION_COUNTRYOPTIONS_SAINT_VINCENT_AND_THE_GRENADINES] = "圣文森特和格林纳丁斯";
translations[OPTION_COUNTRYOPTIONS_SAMOA] = "萨摩亚";
translations[OPTION_COUNTRYOPTIONS_SAN_MARINO] = "圣马力诺";
translations[OPTION_COUNTRYOPTIONS_SAO_TOME_AND_PRINCIPE] = "圣多美和普林西比";
translations[OPTION_COUNTRYOPTIONS_SAUDI_ARABIA] = "沙特阿拉伯";
translations[OPTION_COUNTRYOPTIONS_SENEGAL] = "塞内加尔";
translations[OPTION_COUNTRYOPTIONS_SERBIA] = "塞尔维亚";
translations[OPTION_COUNTRYOPTIONS_SEYCHELLES] = "塞舌尔";
translations[OPTION_COUNTRYOPTIONS_SIERRA_LEONE] = "塞拉利昂";
translations[OPTION_COUNTRYOPTIONS_SINGAPORE] = "新加坡";
translations[OPTION_COUNTRYOPTIONS_SLOVAKIA] = "斯洛伐克";
translations[OPTION_COUNTRYOPTIONS_SLOVENIA] = "斯洛文尼亚";
translations[OPTION_COUNTRYOPTIONS_SOLOMON_ISLANDS] = "所罗门群岛";
translations[OPTION_COUNTRYOPTIONS_SOMALIA] = "索马里";
translations[OPTION_COUNTRYOPTIONS_SOUTH_AFRICA] = "南非";
translations[OPTION_COUNTRYOPTIONS_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS] = "南乔治亚州和南桑威奇群岛";
translations[OPTION_COUNTRYOPTIONS_SPAIN] = "西班牙";
translations[OPTION_COUNTRYOPTIONS_SRI_LANKA] = "斯里兰卡";
translations[OPTION_COUNTRYOPTIONS_SUDAN] = "苏丹";
translations[OPTION_COUNTRYOPTIONS_SURINAME] = "苏里南";
translations[OPTION_COUNTRYOPTIONS_SVALBARD_AND_JAN_MAYEN] = "斯瓦尔巴和扬马延";
translations[OPTION_COUNTRYOPTIONS_SWAZILAND] = "斯威士兰";
translations[OPTION_COUNTRYOPTIONS_SWEDEN] = "瑞典";
translations[OPTION_COUNTRYOPTIONS_SWITZERLAND] = "瑞士";
translations[OPTION_COUNTRYOPTIONS_SYRIAN_ARAB_REPUBLIC] = "阿拉伯叙利亚共和国";
translations[OPTION_COUNTRYOPTIONS_TAIWAN_ROC] = "台湾，中华民国";
translations[OPTION_COUNTRYOPTIONS_TAJIKISTAN] = "塔吉克斯坦";
translations[OPTION_COUNTRYOPTIONS_TANZANIA_UNITED_REPUBLIC_OF] = "坦桑尼亚联合共和国";
translations[OPTION_COUNTRYOPTIONS_THAILAND] = "泰国";
translations[OPTION_COUNTRYOPTIONS_TIMOR_LESTE] = "东帝汶";
translations[OPTION_COUNTRYOPTIONS_TOGO] = "多哥";
translations[OPTION_COUNTRYOPTIONS_TOKELAU] = "托克劳";
translations[OPTION_COUNTRYOPTIONS_TONGA] = "汤加";
translations[OPTION_COUNTRYOPTIONS_TRINIDAD_AND_TOBAGO] = "特立尼达和多巴哥";
translations[OPTION_COUNTRYOPTIONS_TUNISIA] = "突尼斯";
translations[OPTION_COUNTRYOPTIONS_TURKEY] = "火鸡";
translations[OPTION_COUNTRYOPTIONS_TURKMENISTAN] = "土库曼斯坦";
translations[OPTION_COUNTRYOPTIONS_TURKS_AND_CAICOS_ISLANDS] = "特克斯和凯科斯群岛";
translations[OPTION_COUNTRYOPTIONS_TUVALU] = "图瓦卢";
translations[OPTION_COUNTRYOPTIONS_UGANDA] = "乌干达";
translations[OPTION_COUNTRYOPTIONS_UKRAINE] = "乌克兰";
translations[OPTION_COUNTRYOPTIONS_UNITED_ARAB_EMIRATES] = "阿拉伯联合酋长国";
translations[OPTION_COUNTRYOPTIONS_UNITED_KINGDOM] = "英国";
translations[OPTION_COUNTRYOPTIONS_UNITED_STATES] = "美国";
translations[OPTION_COUNTRYOPTIONS_UNITED_STATES_MINOR_OUTLYING_ISLANDS] = "美国离岛小岛";
translations[OPTION_COUNTRYOPTIONS_URUGUAY] = "乌拉圭";
translations[OPTION_COUNTRYOPTIONS_UZBEKISTAN] = "乌兹别克斯坦";
translations[OPTION_COUNTRYOPTIONS_VANUATU] = "瓦努阿图";
translations[OPTION_COUNTRYOPTIONS_VENEZUELA] = "委内瑞拉";
translations[OPTION_COUNTRYOPTIONS_VIET_NAM] = "越南";
translations[OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_BRITISH] = "维尔京群岛，英国";
translations[OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_US] = "美国维尔京群岛";
translations[OPTION_COUNTRYOPTIONS_WALLIS_AND_FUTUNA] = "瓦利斯和富图纳";
translations[OPTION_COUNTRYOPTIONS_WESTERN_SAHARA] = "西撒哈拉";
translations[OPTION_COUNTRYOPTIONS_YEMEN] = "也门";
translations[OPTION_COUNTRYOPTIONS_ZAMBIA] = "赞比亚";
translations[OPTION_COUNTRYOPTIONS_ZIMBABWE] = "津巴布韦";
translations[OPTION_DOESTHEPARTICULATEMATTER_NO] = "否";
translations[OPTION_DOESTHEPARTICULATEMATTER_UNKNOWN] = "知 未知";
translations[OPTION_DOESTHEPARTICULATEMATTER_YES] = "是";
translations[I_HAVE_READ_AND_UNDERSTAND_THE_LINKED_PRIVACY_NOTICE] = "我已阅读并理解百特产品反馈门户的链接隐私声明。 ";
translations[PRODUCT_LOT] = "产品批次";
translations[SHIPPING_DISTRIBUTION_LABEL] = "发货/配送标签";
translations[CARTON_LABEL] = "纸箱标签";
translations[INTERNAL_PRODUCT_LABEL] = "内部产品标签";
translations[TITLE_PD_RENAL] = "PD肾";
translations[TITLE_SOLUTIONS] = "解决方案";
translations[TITLE_ACCESS] = "使用权";
translations[TITLE_ALL_OTHER_PRODUCT] = "所有其他产品";
translations[REPORTED_PROBLEM] = "报告的问题";
translations[LOGIN] = "登录";
translations[SYSTEM_MENU] = "系统菜单";
translations[INITIATE_PRODUCT_FEEDBACK] = "发起产品反馈";
translations[FEEDBACK_STATUS] = "反馈状态";
translations[OKTACALLBACK] = "Okta回调";
translations[VALID_EMAIL] = "请输入有效的电子邮箱";
translations[VALID_NUMERIC] = "请输入一个整数。";
translations[PLEASE_UPLOAD_IMAGE] = "请上传图片";
translations[VALID_DATE] = "请选择有效日期";
translations[QUANTITY] = "数量";
translations[EDIT] = "编辑";
translations[DELETE] = "删除";
translations[LOT_SERIAL_NO] = "批号/序列号";
translations[LOT_NUMBER_NOT_FOUND] = "未找到批号";
translations[SEARCHING_LOT_NUMBER] = "查询批号";
translations[PRODUCT_CODE_NOT_FOUND] = "未找到产品代码";
translations[SEARCHING_PRODUCT_CODE] = "搜索产品代码";
translations[FILE_OF_TYPES_ARE_NOT_ALLOWED] = "不可使用类型的文件 (.asa, .asax, .bat, .cer, .cmd, .docm, .exe, .img, .iso, .js, .php, .php5, .pht, .phtml, .ps1, .py, .rar,  .scr, .shtml, .swf, .vbs, .xap, .xml, .xps)";
translations[THE_FILE_YOU_ARE_ATTEMPTING] = "您尝试附加的文件超出了存储限制。请压缩或附加其他文件。";
translations[IMAGE_ICON] = "单击图像图标以选择选项";
translations[LOGIN_TO_ACCOUNT] = "登入帐户";
translations[SIGN_IN_TO_YOUR_ACCOUNT] = "登录到您的帐户";
translations[BAXTER_EMAIL_ADDRESS] = "百特电子邮件地址";
translations[PASSWORD] = "密码";
translations[SIGN_IN] = "登入";
translations[UNKNOWN] = "知 未知";
translations[ASKED_UNKNOWN] = "询问后但未知";
translations[DD_MMM_YYYY] = "DD-MMM-YYYY";
translations[DD] = "DD";
translations[MMM] = "MMM";
translations[YYYY] = "YYYY";
translations[SELECT_COUNTRY] = "选择国家/地区";
translations[CHINESE_SIMPLIFIED_CHINESE] = "中文（简体中文）";
translations[DUTCH] = "荷兰语";
translations[ENGLISH] = "英语";
translations[FRENCH] = "法语";
translations[GERMAN] = "德语";
translations[ITALIAN] = "意大利语";
translations[JAPANESE] = "日语";
translations[KOREAN] = "韩语";
translations[MANDARIN_TRADITIONAL_CHINESE] = "中文（繁体中文） ";
translations[POLISH] = "波兰语";
translations[PORTUGUESE] = "葡萄牙语";
translations[SPANISH] = "西班牙语";
translations[THAI] = "泰语";
translations[TURKISH] = "土耳其语";
translations[VIETNAMESE] = "越南语";
translations[BROWSE] = "浏览";
translations[FEEDBACK_SUBMITTED] = "已提交反馈";
translations[YOUR_PRODUCT_EXPERIENCE_FEEDBACK] = "您的商品体验反馈已成功提交。 谢谢您的报告。 您将收到一封包含参考编号的电子邮件。 作为医疗产品的供应商，客户对我们产品的满意度和反馈对于我们提供最高质量产品的目标至关重要。 请联系 ";
translations[IF_YOU_HAVE_QUESTIONS_OR_ADDITIONAL_INFORMATION] = "如果您有任何疑问或其他信息。";
translations[CLOSE] = "关";
translations[PATIENT_AGE] = "患者年龄";
translations[ENTER_AGE] = "输入年龄";
translations[PATIENT_DOB] = "患者出生日期";
translations[RELEVANT_ATTACHMENTS] = "请提供任何相关附件";
translations[BAXTER_ACCOUNT_CREDENTIALS] = "输入您的百特账户信息";
translations[GET_PRODUCT_DETAILS] = "获取产品详情";
translations[USE_THE_DIAGRAM_ABOVE_FIGURE_2] = "使用上图（图 2）确定报告问题的位置";
translations[FACILITY_ADDRESS] = "设施地址";
translations[LABEL_ANOTHER_FACILITY_ADDRESS] = "另一个设施地址";
translations[CHOOSE_PRODUCT_CODE] = "请为输入的批号/序列号选择产品代码";
translations[DECLINE] = "拒绝";
translations[OPTION_COUNTRYOPTIONS_BONAIRE_SINT_EUSTATIUS_AND_SABA] = "博内尔岛、圣尤斯特歇斯岛和萨巴岛";
translations[OPTION_COUNTRYOPTIONS_CURAÇAO] = "库拉索";
translations[OPTION_COUNTRYOPTIONS_SOUTH_SUDAN] = "南苏丹";
translations[OPTION_COUNTRYOPTIONS_ESWATINI] = "史瓦帝尼";
translations[FORM_HELP_TEXT] = "表示帮助文本可用于此字段";
translations[YOUR_FIRST_NAME] = "你的名字";
translations[YOUR_LAST_NAME] = "你的姓氏";
translations[MY_FIRST_NAME] = "我的名字";
translations[MY_LAST_NAME] = "我的姓氏";
translations[PATIENT_FIRST_NAME] = "患者的名字";
translations[PATIENT_LAST_NAME] = "患者姓氏";
translations[REPORTER_FIRST_NAME] = "记者名字";
translations[REPORTER_LAST_NAME] = "记者姓氏";
translations[EMPLOYEE_FIRST_NAME] = "员工名字";
translations[EMPLOYEE_LAST_NAME] = "员工姓氏";
translations[END_USER_CUSTOMER_FIRST_NAME] = "最终用户/客户联系人名字";
translations[END_USER_CUSTOMER_LAST_NAME] = "最终用户/客户联系人姓氏";
translations[ADDITIONAL_CONTACT_FIRST_NAME] = "其他联系人名字";
translations[ADDITIONAL_CONTACT_LAST_NAME] = "其他联系人姓氏";
translations[COPYRIGHT] = "版权 ©";
translations[COPYRIGHT_BAXTER] = "百特";
translations[COPYRIGHT_VERSION] = "版权所有 |版本";
translations[ADD_ADDITIONAL_CONTACT] = "添加其他联系人";
translations[CONTACT_ME] = "客户不希望被联系。如有任何其他问题，请与我联系。";
translations[DO_NOT_CONTACT] = "请勿联系";
translations[END_USER_CUSTOMER_FACILITY_NAME] = "最终用户/客户联系地址名称";
translations[END_USER_CUSTOMER_PHONE] = "最终用户/客户联系地址电话号码";
translations[END_USER_CUSTOMER_EMAIL] = "最终用户/客户电子邮件地址";
translations[END_USER_CUSTOMER_FACILITY_ADDRESS] = "最终用户/客户联系地址";
translations[SAME_AS_PATIENT_ADDRESS] = "与相同的地址病人";
translations[SAME_AS_REPORTER_ADDRESS] = "与记者相同的地址";
translations[SAME_AS_END_USER_CUSTOMER_ADDRESS] = "与最终用户/客户联系人相同的地址";
translations[USE_THE_DIAGRAM_ABOVE_FIGURE_3] = "使用上图（图 3）确定报告问题的位置";
translations[CONTACT_US] = "联系我们";
translations[LANDING_BRIEF_FOR_DEVICE] = "如果需要设备维修、部件更换、服务或技术支持，请联系当地的技术服务团队。";
translations[PATIENT_SEX] = "患者性別";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_MAN_BOY] = "顺性别的男人/男孩";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_WOMAN_GIRL] = "顺性别的女性/女孩";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_MAN_TRANS_MAN_FEMALE_TO_MALE_FTM] = "变性人/跨性别男人/女对男";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_WOMAN_TRANS_WOMAN_MALE_TO_FEMALE_MTF] = "变性女人/变性女人/男对女";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_OTHER_GENDER_CATEGORY_PLEASE_SPECIFY] = "其他性别类别；请注明";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_DECLINE_TO_ANSWER] = "拒绝回答";
translations[ATTENTION_NEEDED] = "!!!需要紧急注意：您的产品反馈门户网站提交失败！";
translations[SUBMIT_ERR_MSG] = "要重新提交，请单击 “确定”，然后单击 “提交”，或通过电子邮件将您的投诉发送至 (@@@)。";
translations[SUBMIT_RETRY_MSG] = "如果您重新提交，请确认您在电子邮件框中收到了来自产品反馈门户的确认电子邮件。如果未收到确认电子邮件，则提交不成功，您必须通过电子邮件将投诉发送至 (@@@)。";
translations[OK] = "OK";

export default lang;